/* THIS FILE IS GENERATED, DO NOT EDIT!!! */

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  Date: string;
  Upload: File;
  JSON: any;
};

export enum PermissionName {
  /** --------  WISHES  -------- */
  WishesViewAll = 'Wishes_ViewAll',
  WishesAdd = 'Wishes_Add',
  WishView = 'Wish_View',
  WishUpdate = 'Wish_Update',
  WishExport = 'Wish_Export',
  WishJudge = 'Wish_Judge',
  WishUpdateStatus = 'Wish_UpdateStatus',
  WishArchive = 'Wish_Archive',
  WishViewDate = 'Wish_ViewDate',
  WishUpdateDate = 'Wish_UpdateDate',
  WishViewVolunteers = 'Wish_ViewVolunteers',
  WishUpdateVolunteers = 'Wish_UpdateVolunteers',
  WishViewVehicle = 'Wish_ViewVehicle',
  WishUpdateVehicle = 'Wish_UpdateVehicle',
  WishViewPickup = 'Wish_ViewPickup',
  WishUpdatePickup = 'Wish_UpdatePickup',
  WishViewLocation = 'Wish_ViewLocation',
  WishAddLocation = 'Wish_AddLocation',
  WishUpdateLocation = 'Wish_UpdateLocation',
  WishViewAdditionalInformation = 'Wish_ViewAdditionalInformation',
  WishAddAdditionalInformation = 'Wish_AddAdditionalInformation',
  WishViewFiles = 'Wish_ViewFiles',
  WishAddFiles = 'Wish_AddFiles',
  WishDeleteFiles = 'Wish_DeleteFiles',
  WishViewMobilityStatus = 'Wish_ViewMobilityStatus',
  WishViewNotes = 'Wish_ViewNotes',
  WishViewDeclarations = 'Wish_ViewDeclarations',
  WishAddDeclarations = 'Wish_AddDeclarations',
  WishUpdateDeclarations = 'Wish_UpdateDeclarations',
  WishDeleteDeclarations = 'Wish_DeleteDeclarations',
  /** --------  CHECKLISTS  -------- */
  ChecklistView = 'Checklist_View',
  ChecklistFillAnswers = 'Checklist_FillAnswers',
  /** --------  Availability  -------- */
  AvailabilityView = 'Availability_View',
  AvailabilityUpdate = 'Availability_Update',
  /** --------  Volunteers  -------- */
  VolunteersViewAll = 'Volunteers_ViewAll',
  VolunteersInvite = 'Volunteers_Invite',
  VolunteersView = 'Volunteers_View',
  VolunteersUpdate = 'Volunteers_Update',
  /** --------  PLANNING  -------- */
  PlanningViewAll = 'Planning_ViewAll',
  PlanningUpdate = 'Planning_Update',
  PlanningViewDate = 'Planning_ViewDate',
  PlanningUpdateDate = 'Planning_UpdateDate',
  PlanningAssignVolunteers = 'Planning_AssignVolunteers',
  PlanningSaveDraft = 'Planning_SaveDraft',
  /** --------  USERS  -------- */
  UsersViewAll = 'Users_ViewAll',
  UsersUpdateAll = 'Users_UpdateAll',
  UsersView = 'Users_View',
  UsersUpdate = 'Users_Update',
  UsersUpdatePlanner = 'Users_UpdatePlanner',
  UsersDelete = 'Users_Delete',
  UsersViewFinancialData = 'Users_ViewFinancialData',
  UsersViewDiplomaInfo = 'Users_ViewDiplomaInfo',
  UsersEditDiplomaInfo = 'Users_EditDiplomaInfo',
  UsersInvite = 'Users_Invite',
  UsersImport = 'Users_Import',
  UsersWithdrawInvitation = 'Users_WithdrawInvitation',
  /** --------  EXPENSES AND FEES  -------- */
  ExpensesViewAll = 'Expenses_ViewAll',
  ExpensesDownload = 'Expenses_Download',
  ExpensesSepaExport = 'Expenses_SepaExport',
  /** --------  VEHICLES  -------- */
  VehiclesViewAll = 'Vehicles_ViewAll',
  VehiclesAdd = 'Vehicles_Add',
  VehiclesUpdate = 'Vehicles_Update',
  VehiclesDelete = 'Vehicles_Delete',
  /** --------  MILEAGES  -------- */
  MileagesViewAll = 'Mileages_ViewAll',
  MileagesAdd = 'Mileages_Add',
  MileagesUpdate = 'Mileages_Update',
  MileagesDelete = 'Mileages_Delete',
  /** --------  DOCUMENTS  -------- */
  DocumentsViewAll = 'Documents_ViewAll',
  DocumentsAdd = 'Documents_Add',
  DocumentsUpdate = 'Documents_Update',
  DocumentsDelete = 'Documents_Delete',
  /** --------  USER SETTINGS  -------- */
  UserSettingsView = 'UserSettings_View',
  UserSettingsUpdate = 'UserSettings_Update',
  /** --------  RESERVATIONS  -------- */
  ReservationsViewAll = 'Reservations_ViewAll',
  ReservationsView = 'Reservations_View',
  ReservationsAdd = 'Reservations_Add',
  ReservationsUpdate = 'Reservations_Update',
  ReservationsDelete = 'Reservations_Delete',
  /** --------  MANAGE  -------- */
  ManageExact = 'Manage_Exact',
  /** --------  ACTIVITY  -------- */
  ActivityViewAll = 'Activity_ViewAll'
}

export enum RoleName {
  Admin = 'Admin',
  Beheerder = 'Beheerder',
  Planner = 'Planner',
  Driver = 'Driver',
  Nurse = 'Nurse',
  Photographer = 'Photographer'
}

export enum NotificationType {
  NewWish = 'NewWish'
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Unknown = 'Unknown'
}

export enum ContactType {
  Patient = 'Patient',
  ContactPerson = 'ContactPerson',
  Doctor = 'Doctor'
}

export enum Country {
  Af = 'Af',
  Ax = 'Ax',
  Al = 'Al',
  Dz = 'Dz',
  As = 'As',
  Ad = 'Ad',
  Ao = 'Ao',
  Ai = 'Ai',
  Aq = 'Aq',
  Ag = 'Ag',
  Ar = 'Ar',
  Am = 'Am',
  Aw = 'Aw',
  Au = 'Au',
  At = 'At',
  Az = 'Az',
  Bs = 'Bs',
  Bh = 'Bh',
  Bd = 'Bd',
  Bb = 'Bb',
  By = 'By',
  Be = 'Be',
  Bz = 'Bz',
  Bj = 'Bj',
  Bm = 'Bm',
  Bt = 'Bt',
  Bo = 'Bo',
  Ba = 'Ba',
  Bw = 'Bw',
  Bv = 'Bv',
  Br = 'Br',
  Io = 'Io',
  Vg = 'Vg',
  Bn = 'Bn',
  Bg = 'Bg',
  Bf = 'Bf',
  Bi = 'Bi',
  Kh = 'Kh',
  Cm = 'Cm',
  Ca = 'Ca',
  Cv = 'Cv',
  Bq = 'Bq',
  Ky = 'Ky',
  Cf = 'Cf',
  Td = 'Td',
  Cl = 'Cl',
  Cn = 'Cn',
  Cx = 'Cx',
  Cc = 'Cc',
  Co = 'Co',
  Km = 'Km',
  Cg = 'Cg',
  Cd = 'Cd',
  Ck = 'Ck',
  Cr = 'Cr',
  Ci = 'Ci',
  Hr = 'Hr',
  Cu = 'Cu',
  Cw = 'Cw',
  Cy = 'Cy',
  Cz = 'Cz',
  Dk = 'Dk',
  Dj = 'Dj',
  Dm = 'Dm',
  Do = 'Do',
  Ec = 'Ec',
  Eg = 'Eg',
  Sv = 'Sv',
  Gq = 'Gq',
  Er = 'Er',
  Ee = 'Ee',
  Sz = 'Sz',
  Et = 'Et',
  Fk = 'Fk',
  Fo = 'Fo',
  Fj = 'Fj',
  Fi = 'Fi',
  Fr = 'Fr',
  Gf = 'Gf',
  Pf = 'Pf',
  Tf = 'Tf',
  Ga = 'Ga',
  Gm = 'Gm',
  Ge = 'Ge',
  De = 'De',
  Gh = 'Gh',
  Gi = 'Gi',
  Gr = 'Gr',
  Gl = 'Gl',
  Gd = 'Gd',
  Gp = 'Gp',
  Gu = 'Gu',
  Gt = 'Gt',
  Gg = 'Gg',
  Gn = 'Gn',
  Gw = 'Gw',
  Gy = 'Gy',
  Ht = 'Ht',
  Hm = 'Hm',
  Hn = 'Hn',
  Hk = 'Hk',
  Hu = 'Hu',
  Is = 'Is',
  In = 'In',
  Id = 'Id',
  Ir = 'Ir',
  Iq = 'Iq',
  Ie = 'Ie',
  Im = 'Im',
  Il = 'Il',
  It = 'It',
  Jm = 'Jm',
  Jp = 'Jp',
  Je = 'Je',
  Jo = 'Jo',
  Kz = 'Kz',
  Ke = 'Ke',
  Ki = 'Ki',
  Kw = 'Kw',
  Kg = 'Kg',
  La = 'La',
  Lv = 'Lv',
  Lb = 'Lb',
  Ls = 'Ls',
  Lr = 'Lr',
  Ly = 'Ly',
  Li = 'Li',
  Lt = 'Lt',
  Lu = 'Lu',
  Mo = 'Mo',
  Mg = 'Mg',
  Mw = 'Mw',
  My = 'My',
  Mv = 'Mv',
  Ml = 'Ml',
  Mt = 'Mt',
  Mh = 'Mh',
  Mq = 'Mq',
  Mr = 'Mr',
  Mu = 'Mu',
  Yt = 'Yt',
  Mx = 'Mx',
  Fm = 'Fm',
  Md = 'Md',
  Mc = 'Mc',
  Mn = 'Mn',
  Me = 'Me',
  Ms = 'Ms',
  Ma = 'Ma',
  Mz = 'Mz',
  Mm = 'Mm',
  Na = 'Na',
  Nr = 'Nr',
  Np = 'Np',
  Nl = 'Nl',
  Nc = 'Nc',
  Nz = 'Nz',
  Ni = 'Ni',
  Ne = 'Ne',
  Ng = 'Ng',
  Nu = 'Nu',
  Nf = 'Nf',
  Kp = 'Kp',
  Mk = 'Mk',
  Mp = 'Mp',
  No = 'No',
  Om = 'Om',
  Pk = 'Pk',
  Pw = 'Pw',
  Ps = 'Ps',
  Pa = 'Pa',
  Pg = 'Pg',
  Py = 'Py',
  Pe = 'Pe',
  Ph = 'Ph',
  Pn = 'Pn',
  Pl = 'Pl',
  Pt = 'Pt',
  Pr = 'Pr',
  Qa = 'Qa',
  Re = 'Re',
  Ro = 'Ro',
  Ru = 'Ru',
  Rw = 'Rw',
  Ws = 'Ws',
  Sm = 'Sm',
  St = 'St',
  Sa = 'Sa',
  Sn = 'Sn',
  Rs = 'Rs',
  Sc = 'Sc',
  Sl = 'Sl',
  Sg = 'Sg',
  Sx = 'Sx',
  Sk = 'Sk',
  Si = 'Si',
  Sb = 'Sb',
  So = 'So',
  Za = 'Za',
  Gs = 'Gs',
  Kr = 'Kr',
  Ss = 'Ss',
  Es = 'Es',
  Lk = 'Lk',
  Bl = 'Bl',
  Sh = 'Sh',
  Kn = 'Kn',
  Lc = 'Lc',
  Mf = 'Mf',
  Pm = 'Pm',
  Vc = 'Vc',
  Sd = 'Sd',
  Sr = 'Sr',
  Sj = 'Sj',
  Se = 'Se',
  Ch = 'Ch',
  Sy = 'Sy',
  Tw = 'Tw',
  Tj = 'Tj',
  Tz = 'Tz',
  Th = 'Th',
  Tl = 'Tl',
  Tg = 'Tg',
  Tk = 'Tk',
  To = 'To',
  Tt = 'Tt',
  Tn = 'Tn',
  Tr = 'Tr',
  Tm = 'Tm',
  Tc = 'Tc',
  Tv = 'Tv',
  Um = 'Um',
  Vi = 'Vi',
  Ug = 'Ug',
  Ua = 'Ua',
  Ae = 'Ae',
  Gb = 'Gb',
  Us = 'Us',
  Uy = 'Uy',
  Uz = 'Uz',
  Vu = 'Vu',
  Va = 'Va',
  Ve = 'Ve',
  Vn = 'Vn',
  Wf = 'Wf',
  Eh = 'Eh',
  Ye = 'Ye',
  Zm = 'Zm',
  Zw = 'Zw'
}

export enum Mobility {
  Walk = 'Walk',
  WalkWithHelp = 'WalkWithHelp',
  WheelChair = 'WheelChair',
  Bedridden = 'Bedridden',
  Other = 'Other'
}

export enum LivingSituation {
  GroundFloor = 'GroundFloor',
  FirstFloor = 'FirstFloor',
  SecondFloor = 'SecondFloor',
  ThirdFloor = 'ThirdFloor',
  HigherFloor = 'HigherFloor'
}

export enum Status {
  Concept = 'Concept',
  Requested = 'Requested',
  InProcess = 'InProcess',
  Pending = 'Pending',
  Scheduled = 'Scheduled',
  Executed = 'Executed',
  Completed = 'Completed',
  Rejected = 'Rejected'
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Deleted = 'Deleted'
}

export enum UserFilesStatus {
  Completed = 'Completed',
  Incomplete = 'Incomplete'
}

export enum PlanningStatus {
  Unplanned = 'Unplanned',
  Draft = 'Draft',
  Final = 'Final',
  Confirmed = 'Confirmed'
}

export enum ReservedProcedures {
  Oxygen = 'OXYGEN',
  PeripheralInfusion = 'PERIPHERAL_INFUSION',
  Drain = 'DRAIN',
  TransurethralCatheter = 'TRANSURETHRAL_CATHETER',
  AsciticDrain = 'ASCITIC_DRAIN',
  Stoma = 'STOMA',
  StomachSiphon = 'STOMACH_SIPHON',
  PeripherallyInsertedCentralCatheter = 'PERIPHERALLY_INSERTED_CENTRAL_CATHETER',
  CentralVenousCatheter = 'CENTRAL_VENOUS_CATHETER',
  IntravenousAntibiotic = 'INTRAVENOUS_ANTIBIOTIC',
  MorphineSubcutaneous = 'MORPHINE_SUBCUTANEOUS',
  MorphinePeripheral = 'MORPHINE_PERIPHERAL',
  DrainFlushing = 'DRAIN_FLUSHING',
  VacuumAssistedClosure = 'VACUUM_ASSISTED_CLOSURE',
  Nephrostomy = 'NEPHROSTOMY',
  ChestDrain = 'CHEST_DRAIN',
  SuprapubicCatheter = 'SUPRAPUBIC_CATHETER',
  PercutaneousTranshepaticCholangiography = 'PERCUTANEOUS_TRANSHEPATIC_CHOLANGIOGRAPHY',
  IntratrachealSuctioning = 'INTRATRACHEAL_SUCTIONING',
  CardiacCare = 'CARDIAC_CARE',
  Monitoring = 'MONITORING',
  ArtificialRespiration = 'ARTIFICIAL_RESPIRATION',
  IntramuscularInjection = 'INTRAMUSCULAR_INJECTION'
}

export enum NurseType {
  Caregiver = 'CAREGIVER',
  Nurse = 'NURSE',
  NurseIcu = 'NURSE_ICU',
  NurseCcu = 'NURSE_CCU',
  NurseAmbulance = 'NURSE_AMBULANCE'
}

export enum BigGroupCode {
  DoctorOfMedicine = 'DoctorOfMedicine',
  Dentist = 'Dentist',
  Midwife = 'Midwife',
  Physiotherapist = 'Physiotherapist',
  Psychotherapist = 'Psychotherapist',
  Pharmacist = 'Pharmacist',
  PharmacyHoldingPhysician = 'PharmacyHoldingPhysician',
  HealthcarePsychologist = 'HealthcarePsychologist',
  Nurse = 'Nurse',
  RemedialEducationalist = 'RemedialEducationalist',
  RegionalNurse = 'RegionalNurse',
  RegisteredDentalHygienist = 'RegisteredDentalHygienist',
  AlliedMedicalCareProfessional = 'AlliedMedicalCareProfessional',
  PhysicianAssistant = 'PhysicianAssistant',
  TechnicalPhysician = 'TechnicalPhysician',
  PharmaceuticalAssistant = 'PharmaceuticalAssistant',
  ClinicalPhysicist = 'ClinicalPhysicist',
  DentalTechnician = 'DentalTechnician',
  NurseInIndividualHealthcare = 'NurseInIndividualHealthcare',
  Optometrist = 'Optometrist',
  SkinTherapist = 'SkinTherapist',
  Dietician = 'Dietician',
  OccupationalTherapist = 'OccupationalTherapist',
  SpeechAndLanguageTherapist = 'SpeechAndLanguageTherapist',
  DentalHygienist = 'DentalHygienist',
  MensendieckTherapist = 'MensendieckTherapist',
  CesarTherapist = 'CesarTherapist',
  Orthoptist = 'Orthoptist',
  Podotherapist = 'Podotherapist',
  DiagnosticRadiographer = 'DiagnosticRadiographer',
  TherapeuticRadiographer = 'TherapeuticRadiographer',
  Unknown = 'Unknown'
}

export enum NoteEventType {
  Note = 'Note',
  WishStatusChange = 'WishStatusChange',
  UserStatusChange = 'UserStatusChange'
}

export enum FileCategory {
  Image = 'Image',
  Document = 'Document',
  Video = 'Video',
  Audio = 'Audio'
}

export enum MailCustomizationType {
  ExtraInformation = 'ExtraInformation'
}

export enum ExpenseType {
  WishCosts = 'WishCosts',
  TravelAllowance = 'TravelAllowance',
  Accommodation = 'Accommodation',
  Fuel = 'Fuel'
}

export enum ExpenseStatus {
  Payed = 'Payed',
  Processed = 'Processed',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Received = 'Received',
  Concept = 'Concept'
}

export enum MileageReference {
  Maintenance = 'Maintenance',
  Event = 'Event'
}

export enum ChecklistStatus {
  Open = 'OPEN',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE'
}

export enum ChecklistAnswerType {
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  DynamicRows = 'DYNAMIC_ROWS',
  Float = 'FLOAT',
  MultiCheck = 'MULTI_CHECK',
  Percentage = 'PERCENTAGE',
  Rating = 'RATING',
  Select = 'SELECT',
  Signature = 'SIGNATURE',
  Text = 'TEXT'
}

export enum MailStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Failed = 'FAILED',
  Delivered = 'DELIVERED',
  Opened = 'OPENED'
}

export enum DriverLicenseType {
  B1 = 'B1',
  B = 'B',
  C = 'C',
  C1 = 'C1',
  D = 'D',
  D1 = 'D1',
  Be = 'BE',
  C1E = 'C1E',
  D1E = 'D1E',
  De = 'DE'
}

/** Generic model type for dynamic fields */
export type GenericModel = {
  __typename?: 'GenericModel';
  model?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

export enum JournalType {
  PurchaseInvoices = 'PurchaseInvoices',
  CardTransactions = 'CardTransactions'
}

export type Query = {
  __typename?: 'Query';
  photos: Array<Photo>;
  exportPhotos: Scalars['String'];
  wishPlanningConfirmationExtraInformation: Scalars['String'];
  vehicles: Array<Vehicle>;
  activeVehicles: Array<Vehicle>;
  vehicle?: Maybe<Vehicle>;
  allVehicleAvailabilityEntries: Array<VehicleAvailabilityEntry>;
  vehicleAvailabilityEntries: Array<VehicleAvailabilityEntryData>;
  vehicleAvailabilityEntriesWishesCount: Array<VehicleAvailabilityCountRecord>;
  allAvailableVehicles: Array<Vehicle>;
  userAddress?: Maybe<UserAddress>;
  office?: Maybe<Address>;
  calculateDistance?: Maybe<CalculateDistance>;
  mapsPlaceAutocomplete: Array<PlaceAutocompleteResult>;
  mapsPlaceDetails?: Maybe<Address>;
  postalCodeCheck?: Maybe<PostalCodeCheck>;
  availability: Array<Availability>;
  bigCheck?: Maybe<Big>;
  userWithActivationToken: User;
  userDetails?: Maybe<UserDetails>;
  me?: Maybe<User>;
  notifications: Array<Notification>;
  user?: Maybe<User>;
  checklist: Checklist;
  checklists: Array<Checklist>;
  wishRequest?: Maybe<Wish>;
  wish?: Maybe<Wish>;
  plannableWishes: Array<Wish>;
  validateWishDate: WishDateValidationResponse;
  similarWishes: Array<Wish>;
  expense: Expense;
  exportExpenses: Scalars['String'];
  expenseRelatedWishes: Array<Wish>;
  exportMileages: Scalars['String'];
  reservation?: Maybe<Reservation>;
  reservations: Array<Reservation>;
  exactAuthLink?: Maybe<Scalars['String']>;
  exactAuthenticated: Scalars['Boolean'];
  exactConfig: ExactConfig;
  exactDivisions: Array<ExactDivision>;
  userAddresses: UserAddressPaginator;
  addresses: AddressPaginator;
  users: UserPaginator;
  planningVolunteers: PlanningVolunteerPaginator;
  media: MediaPaginator;
  wishes: WishPaginator;
  expenses: ExpensePaginator;
  mileages: MileagePaginator;
};


export type QueryPhotosArgs = {
  wish_id: Scalars['ID'];
};


export type QueryExportPhotosArgs = {
  wish_id: Scalars['ID'];
  photo_uuids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryVehiclesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryVehicleArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryAllVehicleAvailabilityEntriesArgs = {
  from: Scalars['Date'];
  to: Scalars['Date'];
  vehicle_id?: InputMaybe<Scalars['ID']>;
};


export type QueryVehicleAvailabilityEntriesArgs = {
  vehicle_id: Scalars['ID'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type QueryVehicleAvailabilityEntriesWishesCountArgs = {
  date: Scalars['Date'];
  vehicle_id: Scalars['ID'];
};


export type QueryAllAvailableVehiclesArgs = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type QueryUserAddressArgs = {
  id: Scalars['ID'];
};


export type QueryCalculateDistanceArgs = {
  fromAddressId?: InputMaybe<Scalars['ID']>;
  toAddressId?: InputMaybe<Scalars['ID']>;
  roundtrip?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMapsPlaceAutocompleteArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMapsPlaceDetailsArgs = {
  place_id: Scalars['String'];
};


export type QueryPostalCodeCheckArgs = {
  postalCode: Scalars['String'];
  number: Scalars['String'];
};


export type QueryAvailabilityArgs = {
  start: Scalars['Date'];
  end: Scalars['Date'];
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBigCheckArgs = {
  big: Scalars['String'];
};


export type QueryUserWithActivationTokenArgs = {
  input?: InputMaybe<ActivationTokenInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryChecklistArgs = {
  id: Scalars['ID'];
  wish_id: Scalars['ID'];
};


export type QueryChecklistsArgs = {
  wish_id: Scalars['ID'];
};


export type QueryWishRequestArgs = {
  key: Scalars['String'];
};


export type QueryWishArgs = {
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
};


export type QueryPlannableWishesArgs = {
  input: PlannableWishesInput;
};


export type QueryValidateWishDateArgs = {
  input: ValidateWishDateInput;
};


export type QuerySimilarWishesArgs = {
  id: Scalars['ID'];
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryExportExpensesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExpenseRelatedWishesArgs = {
  expense_id: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryExportMileagesArgs = {
  vehicle_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['Date']>;
  end_date?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<QueryExportMileagesOrderByOrderByClause>>;
};


export type QueryReservationArgs = {
  id: Scalars['ID'];
};


export type QueryReservationsArgs = {
  start_date: Scalars['Date'];
  end_date?: InputMaybe<Scalars['Date']>;
};


export type QueryExactAuthLinkArgs = {
  redirectUrl?: InputMaybe<Scalars['String']>;
};


export type QueryUserAddressesArgs = {
  user_id: Scalars['ID'];
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryAddressesArgs = {
  wishAddresses?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<QueryAddressesOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  filesDelivered?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<UserStatus>;
  role?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<QueryUsersOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryPlanningVolunteersArgs = {
  wishId?: InputMaybe<Scalars['ID']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate?: InputMaybe<Scalars['Date']>;
  showAvailable?: InputMaybe<Scalars['Boolean']>;
  specializations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<RoleName>>>;
  orderBy?: InputMaybe<Array<QueryPlanningVolunteersOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMediaArgs = {
  file_category?: InputMaybe<FileCategory>;
  search?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<QueryMediaOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryWishesArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Status>;
  search?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['Date']>;
  wish_date?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<QueryWishesOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryExpensesArgs = {
  wishId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ExpenseType>;
  status?: InputMaybe<ExpenseStatus>;
  transaction_at?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  only_unlinked?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<QueryExpensesOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMileagesArgs = {
  wish_id?: InputMaybe<Scalars['ID']>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  created_at?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<QueryMileagesOrderByOrderByClause>>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  uploadPhotos: Array<Photo>;
  deletePhotos: Scalars['Boolean'];
  saveWishPlanningConfirmationExtraInformation: Scalars['Boolean'];
  deleteMailCustomization?: Maybe<MailCustomization>;
  createVehicle?: Maybe<Vehicle>;
  updateVehicle?: Maybe<Vehicle>;
  deleteVehicle: Vehicle;
  restoreVehicle: Vehicle;
  toggleVehicleActiveness: ToggleActivenessResponse;
  createVehicleAvailabilityEntry: VehicleAvailabilityEntry;
  updateVehicleAvailabilityEntry: VehicleAvailabilityEntry;
  deleteVehicleAvailabilityEntry?: Maybe<VehicleAvailabilityEntry>;
  createAddress: AddressLike;
  updateAddress: AddressLike;
  deleteAddress: AddressLike;
  createAvailabilityEntry: AvailabilityEntry;
  deleteAvailabilityEntry: AvailabilityEntry;
  updateWishContacts: Array<Contact>;
  activateUser: AuthPayload;
  saveUserDetails?: Maybe<UserDetails>;
  setNotificationRead: SimpleStatus;
  setNotificationUnread: SimpleStatus;
  setNotificationDeleted: SimpleStatus;
  uploadAvatar?: Maybe<AvatarUrl>;
  importUsers?: Maybe<ImportUsersResponse>;
  createUser?: Maybe<User>;
  deleteUser: User;
  restoreUser: User;
  updateUser: User;
  resendActivationMail?: Maybe<SimpleStatus>;
  createMedicalInformation?: Maybe<MedicalInformation>;
  updateMedicalInformation?: Maybe<MedicalInformation>;
  createNote?: Maybe<Note>;
  deleteMedia?: Maybe<Media>;
  uploadMedia?: Maybe<Media>;
  saveChecklistAnswers: Checklist;
  createChecklistBlockWish: ChecklistBlockWish;
  deleteChecklistBlockWish: DeleteChecklistBlockWishResponse;
  createWish?: Maybe<Wish>;
  createWishRequest?: Maybe<Wish>;
  updateWishRequest?: Maybe<Wish>;
  updateWish: Wish;
  archiveWish?: Maybe<Wish>;
  restoreWish?: Maybe<Wish>;
  uploadWishDocument?: Maybe<WishDocumentUploadResponse>;
  attachMediaToWish?: Maybe<SimpleStatus>;
  detachMediaFromWish?: Maybe<SimpleStatus>;
  confirmWish?: Maybe<ConfirmWishResponse>;
  unplanWish?: Maybe<Wish>;
  createExpense: Expense;
  deleteExpense: Array<Expense>;
  updateExpense: Expense;
  approveExpenses: Array<Expense>;
  relinkExpense: Expense;
  createMileage?: Maybe<Mileage>;
  updateMileage?: Maybe<Mileage>;
  deleteMileage?: Maybe<Mileage>;
  createReservation?: Maybe<Reservation>;
  updateReservation?: Maybe<Reservation>;
  deleteReservation: Reservation;
  exactUpdateConfig?: Maybe<ExactConfig>;
  login: AuthPayload;
  refreshToken: RefreshTokenPayload;
  logout: LogoutResponse;
  forgotPassword: ForgotPasswordResponse;
  updateForgottenPassword: ForgotPasswordResponse;
  updatePassword: UpdatePasswordResponse;
  twoFactorVerification: TwoFactorVerificationResponse;
  resendTwoFactorVerification: ResendTwoFactorVerificationResponse;
};


export type MutationUploadPhotosArgs = {
  wish_id: Scalars['ID'];
  files: Array<Scalars['Upload']>;
};


export type MutationDeletePhotosArgs = {
  wish_id: Scalars['ID'];
  photo_uuids: Array<Scalars['ID']>;
};


export type MutationSaveWishPlanningConfirmationExtraInformationArgs = {
  wishId: Scalars['ID'];
  content: Scalars['String'];
};


export type MutationDeleteMailCustomizationArgs = {
  id: Scalars['ID'];
};


export type MutationCreateVehicleArgs = {
  input: VehicleInput;
};


export type MutationUpdateVehicleArgs = {
  id: Scalars['ID'];
  input: VehicleInput;
};


export type MutationDeleteVehicleArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreVehicleArgs = {
  id: Scalars['ID'];
};


export type MutationToggleVehicleActivenessArgs = {
  id: Scalars['ID'];
  inactive: Scalars['Boolean'];
};


export type MutationCreateVehicleAvailabilityEntryArgs = {
  vehicle_id: Scalars['ID'];
  unavailable_on: Scalars['Date'];
};


export type MutationUpdateVehicleAvailabilityEntryArgs = {
  id: Scalars['ID'];
  input: VehicleAvailabilityEntryInput;
};


export type MutationDeleteVehicleAvailabilityEntryArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationUpdateAddressArgs = {
  id: Scalars['ID'];
  input: UpdateAddressInput;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['ID'];
  type: Scalars['String'];
};


export type MutationCreateAvailabilityEntryArgs = {
  user_id: Scalars['ID'];
  date: Scalars['Date'];
};


export type MutationDeleteAvailabilityEntryArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateWishContactsArgs = {
  wish_id: Scalars['ID'];
  contact_type?: InputMaybe<ContactType>;
  input: Array<UpdateContactInput>;
};


export type MutationActivateUserArgs = {
  input?: InputMaybe<ActivateUserInput>;
};


export type MutationSaveUserDetailsArgs = {
  input?: InputMaybe<SaveUserDetailsInput>;
};


export type MutationSetNotificationReadArgs = {
  input: NotificationActionInput;
};


export type MutationSetNotificationUnreadArgs = {
  input: NotificationActionInput;
};


export type MutationSetNotificationDeletedArgs = {
  input: NotificationActionInput;
};


export type MutationUploadAvatarArgs = {
  input?: InputMaybe<Avatar>;
};


export type MutationImportUsersArgs = {
  input?: InputMaybe<ImportUsersInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationResendActivationMailArgs = {
  id: Scalars['ID'];
};


export type MutationCreateMedicalInformationArgs = {
  input: CreateMedicalInformationInput;
};


export type MutationUpdateMedicalInformationArgs = {
  id: Scalars['ID'];
  input: MedicalInformationInput;
};


export type MutationCreateNoteArgs = {
  input: CreateWishNoteInput;
};


export type MutationDeleteMediaArgs = {
  id: Scalars['ID'];
};


export type MutationUploadMediaArgs = {
  id?: InputMaybe<Scalars['ID']>;
  file?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
};


export type MutationSaveChecklistAnswersArgs = {
  checklist_id: Scalars['ID'];
  wish_id: Scalars['ID'];
  input: Array<AnswersInput>;
};


export type MutationCreateChecklistBlockWishArgs = {
  checklist_block_id: Scalars['ID'];
  wish_id: Scalars['ID'];
  custom_block_name: Scalars['String'];
};


export type MutationDeleteChecklistBlockWishArgs = {
  id: Scalars['ID'];
};


export type MutationCreateWishArgs = {
  input: WishInput;
};


export type MutationCreateWishRequestArgs = {
  input: CreateWishRequestInput;
};


export type MutationUpdateWishRequestArgs = {
  input: UpdateWishRequestInput;
};


export type MutationUpdateWishArgs = {
  id: Scalars['ID'];
  planningUpdate?: InputMaybe<Scalars['Boolean']>;
  input: UpdateWishInput;
};


export type MutationArchiveWishArgs = {
  id: Scalars['ID'];
};


export type MutationRestoreWishArgs = {
  id: Scalars['ID'];
};


export type MutationUploadWishDocumentArgs = {
  input: WishDocumentInput;
};


export type MutationAttachMediaToWishArgs = {
  wish_id: Scalars['ID'];
  media_id: Scalars['ID'];
};


export type MutationDetachMediaFromWishArgs = {
  wish_id: Scalars['ID'];
  media_id: Scalars['ID'];
};


export type MutationConfirmWishArgs = {
  token: Scalars['String'];
};


export type MutationUnplanWishArgs = {
  id: Scalars['ID'];
};


export type MutationCreateExpenseArgs = {
  input: ExpenseCreateInput;
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateExpenseArgs = {
  id: Scalars['ID'];
  input: ExpenseUpdateInput;
};


export type MutationApproveExpensesArgs = {
  ids: Array<Scalars['ID']>;
  all?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRelinkExpenseArgs = {
  id: Scalars['ID'];
  wish_id?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateMileageArgs = {
  input: MileageInput;
};


export type MutationUpdateMileageArgs = {
  id: Scalars['ID'];
  input: MileageInput;
};


export type MutationDeleteMileageArgs = {
  id: Scalars['ID'];
};


export type MutationCreateReservationArgs = {
  input: ReservationInput;
};


export type MutationUpdateReservationArgs = {
  id: Scalars['ID'];
  input: ReservationInput;
};


export type MutationDeleteReservationArgs = {
  id: Scalars['ID'];
};


export type MutationExactUpdateConfigArgs = {
  input: ExactConfigInput;
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type MutationRefreshTokenArgs = {
  input?: InputMaybe<RefreshTokenInput>;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationUpdateForgottenPasswordArgs = {
  input?: InputMaybe<NewPasswordWithCodeInput>;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationTwoFactorVerificationArgs = {
  input: TwoFactorVerificationInput;
};


export type MutationResendTwoFactorVerificationArgs = {
  input: ResendTwoFactorVerificationInput;
};

export type Subscription = {
  __typename?: 'Subscription';
  vehiclesUpdated?: Maybe<Vehicle>;
  notificationCreated?: Maybe<Notification>;
  notificationUpdated?: Maybe<Notification>;
  notificationDeleted?: Maybe<Notification>;
  wishUpdated?: Maybe<Wish>;
  wishesUpdated?: Maybe<Wish>;
  reservationUpdated?: Maybe<Reservation>;
  reservationsUpdated?: Maybe<Reservation>;
};


export type SubscriptionWishUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionReservationUpdatedArgs = {
  id: Scalars['ID'];
};

export type SimpleStatus = {
  __typename?: 'SimpleStatus';
  status?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type MailCustomizationModel = Wish;

export type MailCustomization = {
  __typename?: 'MailCustomization';
  id: Scalars['ID'];
  content: Scalars['String'];
  model?: Maybe<MailCustomizationModel>;
  mail_type: Scalars['String'];
  customization_type: MailCustomizationType;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID'];
  vehicle_number?: Maybe<Scalars['Int']>;
  licence_plate?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mileages?: Maybe<Array<Mileage>>;
  mileage?: Maybe<Scalars['Int']>;
  bank_card_number?: Maybe<Scalars['Int']>;
  bank_pincode?: Maybe<Scalars['String']>;
  fuel_pincode?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  availability_entries?: Maybe<Array<VehicleAvailabilityEntry>>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type VehicleInput = {
  vehicle_number?: InputMaybe<Scalars['Int']>;
  licence_plate?: InputMaybe<Scalars['String']>;
  bank_pincode?: InputMaybe<Scalars['String']>;
  fuel_pincode?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

export type ToggleActivenessInput = {
  id: Scalars['ID'];
  inactive: Scalars['Boolean'];
};

export type ToggleActivenessResponse = {
  __typename?: 'ToggleActivenessResponse';
  success: Scalars['Boolean'];
  attached_wishes: Scalars['Int'];
};

export type DetachAllFutureWishesResponse = {
  __typename?: 'DetachAllFutureWishesResponse';
  success: Scalars['Boolean'];
  detached: Scalars['Int'];
};

export type AvailableVehiclesResponseItem = {
  __typename?: 'AvailableVehiclesResponseItem';
  date: Scalars['Date'];
  count: Scalars['Int'];
};

export type VehicleAvailabilityEntry = {
  __typename?: 'VehicleAvailabilityEntry';
  id: Scalars['ID'];
  vehicle?: Maybe<Vehicle>;
  unavailable_on: Scalars['Date'];
  reason?: Maybe<Scalars['String']>;
};

export type VehicleAvailabilityEntryInput = {
  vehicle_id?: InputMaybe<Scalars['ID']>;
  unavailable_on?: InputMaybe<Scalars['Date']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type VehicleAvailabilityEntryData = {
  __typename?: 'VehicleAvailabilityEntryData';
  date: Scalars['Date'];
  unavailable: Scalars['Boolean'];
  blocked: Scalars['Boolean'];
  wish_planned: Scalars['Boolean'];
  wish_draft_planned: Scalars['Boolean'];
  reservation_planned: Scalars['Boolean'];
  unavailability_entry?: Maybe<VehicleAvailabilityEntry>;
  vehicle_id?: Maybe<Scalars['ID']>;
};

export type QueryVehicleAvailabilityEntryInput = {
  vehicle_id: Scalars['ID'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type VehicleAvailabilityCountRecord = {
  __typename?: 'VehicleAvailabilityCountRecord';
  date: Scalars['Date'];
  wishes_count: Scalars['Int'];
};

export type AddressInterface = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_addition?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  place_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type Address = AddressInterface & {
  __typename?: 'Address';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_addition?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  place_id?: Maybe<Scalars['ID']>;
  formatted?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  wishes_count?: Maybe<Scalars['Int']>;
  users_count?: Maybe<Scalars['Int']>;
  contacts_count?: Maybe<Scalars['Int']>;
  total_count?: Maybe<Scalars['Int']>;
  has_location?: Maybe<Scalars['Boolean']>;
  has_place_id?: Maybe<Scalars['Boolean']>;
};

export type ContactAddress = AddressInterface & {
  __typename?: 'ContactAddress';
  id: Scalars['ID'];
  address_id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_addition?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  place_id?: Maybe<Scalars['ID']>;
  floor?: Maybe<Scalars['Int']>;
  elevator_available?: Maybe<Scalars['Boolean']>;
  stretcher_accessible?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  departure_at?: Maybe<Scalars['DateTime']>;
  arrival_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type WishAddress = AddressInterface & {
  __typename?: 'WishAddress';
  id: Scalars['ID'];
  address_id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_addition?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  place_id?: Maybe<Scalars['ID']>;
  floor?: Maybe<Scalars['Int']>;
  elevator_available?: Maybe<Scalars['Boolean']>;
  stretcher_accessible?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  departure_at?: Maybe<Scalars['DateTime']>;
  arrival_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type UserAddress = AddressInterface & {
  __typename?: 'UserAddress';
  id: Scalars['ID'];
  address_id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_addition?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  place_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type AddressLike = Address | WishAddress | UserAddress | ContactAddress;

export type Addressable = Wish | User | Contact;

export type CreateWishAddressInput = {
  wish_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Int']>;
  elevator_available?: InputMaybe<Scalars['Boolean']>;
  stretcher_accessible?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  departure_at?: InputMaybe<Scalars['DateTime']>;
  arrival_at?: InputMaybe<Scalars['DateTime']>;
};

export type CreateUserAddressInput = {
  user_id: Scalars['ID'];
};

export type CreateContactAddressInput = {
  contact_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Int']>;
  elevator_available?: InputMaybe<Scalars['Boolean']>;
  stretcher_accessible?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  departure_at?: InputMaybe<Scalars['DateTime']>;
  arrival_at?: InputMaybe<Scalars['DateTime']>;
};

export type CreateAddressInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  street?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_addition?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  name?: InputMaybe<Scalars['String']>;
  wish_address?: InputMaybe<CreateWishAddressInput>;
  contact_address?: InputMaybe<CreateContactAddressInput>;
  user_address?: InputMaybe<CreateUserAddressInput>;
};

export type UpdateWishAddressInput = {
  wish_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Int']>;
  elevator_available?: InputMaybe<Scalars['Boolean']>;
  stretcher_accessible?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  departure_at?: InputMaybe<Scalars['DateTime']>;
  arrival_at?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateUserAddressInput = {
  user_id: Scalars['ID'];
};

export type UpdateContactAddressInput = {
  contact_id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['Int']>;
  elevator_available?: InputMaybe<Scalars['Boolean']>;
  stretcher_accessible?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  departure_at?: InputMaybe<Scalars['DateTime']>;
  arrival_at?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateAddressInput = {
  address_id: Scalars['ID'];
  street?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_addition?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  wish_address?: InputMaybe<UpdateWishAddressInput>;
  contact_address?: InputMaybe<UpdateContactAddressInput>;
  user_address?: InputMaybe<UpdateUserAddressInput>;
};

export type CalculateDistance = {
  __typename?: 'CalculateDistance';
  distance?: Maybe<Scalars['Int']>;
};

export type PlaceAutocompleteResult = {
  __typename?: 'PlaceAutocompleteResult';
  name: Scalars['String'];
  address: Scalars['String'];
  description: Scalars['String'];
  place_id: Scalars['String'];
};

export type AddressParts = {
  __typename?: 'AddressParts';
  number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
};

export type PlaceDetailsResult = {
  __typename?: 'PlaceDetailsResult';
  name?: Maybe<Scalars['String']>;
  formatted_address?: Maybe<Scalars['String']>;
  address: AddressParts;
};

export type PostalCodeCheck = {
  __typename?: 'PostalCodeCheck';
  zipcode: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type AvailabilityEntry = {
  __typename?: 'AvailabilityEntry';
  id: Scalars['ID'];
  date: Scalars['Date'];
};

export type AvailabilityCountRecord = {
  __typename?: 'AvailabilityCountRecord';
  date: Scalars['Date'];
  volunteers_count: Scalars['Int'];
};

export type Availability = {
  __typename?: 'Availability';
  date: Scalars['Date'];
  available?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  wish_planned?: Maybe<Scalars['Boolean']>;
  wish_planned_as_concept?: Maybe<Scalars['Boolean']>;
  volunteer_count?: Maybe<Scalars['Int']>;
  availability_entry?: Maybe<AvailabilityEntry>;
};

export type Big = {
  __typename?: 'Big';
  registrations: Array<Maybe<Registration>>;
  mentions: Array<Maybe<Mention>>;
  full_name: Scalars['String'];
  gender: Gender;
};

export type Registration = {
  __typename?: 'Registration';
  number: Scalars['String'];
  group: BigGroupCode;
  valid: Scalars['Boolean'];
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
};

export type Mention = {
  __typename?: 'Mention';
  id: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
};

export type ContactInput = {
  first_name?: InputMaybe<Scalars['String']>;
  insertion?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Gender>;
  email?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  contact_type: ContactType;
  relationship?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<CreateAddressHasOne>;
};

export type CreateAddressHasOne = {
  create: CreateSimpleContactAddressInput;
};

export type CreateSimpleContactAddressInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_addition?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  floor?: InputMaybe<Scalars['Int']>;
  elevator_available?: InputMaybe<Scalars['Boolean']>;
  stretcher_accessible?: InputMaybe<Scalars['Boolean']>;
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['ID'];
  full_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  insertion?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['Date']>;
  gender?: Maybe<Gender>;
  persona?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  contact_type?: Maybe<ContactType>;
  relationship?: Maybe<Scalars['String']>;
  receives_mail?: Maybe<Scalars['Boolean']>;
  addresses?: Maybe<Array<ContactAddress>>;
};

export type UpdateContactInput = {
  id?: InputMaybe<Scalars['ID']>;
  first_name?: InputMaybe<Scalars['String']>;
  insertion?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  date_of_birth?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Gender>;
  email?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  contact_type?: InputMaybe<ContactType>;
  receives_mail?: InputMaybe<Scalars['Boolean']>;
  relationship?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<CreateAddressHasOne>;
};

export type ActivationTokenInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type ActivateUserInput = {
  email: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
};

export type UserDetails = {
  __typename?: 'UserDetails';
  addresses: Array<UserAddress>;
  bank_account_holder?: Maybe<Scalars['String']>;
  bank_account_number?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_contact_phone_number?: Maybe<Scalars['String']>;
  big_number?: Maybe<Scalars['String']>;
  big_expires?: Maybe<Scalars['Date']>;
  has_diploma?: Maybe<Scalars['Boolean']>;
  diploma_type?: Maybe<Scalars['String']>;
  graduation_year?: Maybe<Scalars['Int']>;
  profession?: Maybe<Scalars['String']>;
  driver_license_types: Array<DriverLicenseType>;
  driver_license_expires?: Maybe<Scalars['Date']>;
  vog_issued_at?: Maybe<Scalars['Date']>;
  vog_identifier?: Maybe<Scalars['Int']>;
  active_since?: Maybe<Scalars['Date']>;
  reserved_procedures: Array<ReservedProcedures>;
  preserve_name?: Maybe<Scalars['Boolean']>;
};

export type SaveUserDetailsInput = {
  addresses: Array<AddressInput>;
  bank_account_holder?: InputMaybe<Scalars['String']>;
  bank_account_number?: InputMaybe<Scalars['String']>;
  emergency_contact_name?: InputMaybe<Scalars['String']>;
  emergency_contact_phone_number?: InputMaybe<Scalars['String']>;
  big_number?: InputMaybe<Scalars['String']>;
  big_expires?: InputMaybe<Scalars['Date']>;
  has_diploma?: InputMaybe<Scalars['Boolean']>;
  diploma_type?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  profession?: InputMaybe<Scalars['String']>;
  driver_license_types: Array<InputMaybe<DriverLicenseType>>;
  driver_license_expires?: InputMaybe<Scalars['Date']>;
  vog_issued_at?: InputMaybe<Scalars['Date']>;
  vog_identifier?: InputMaybe<Scalars['Int']>;
  active_since?: InputMaybe<Scalars['Date']>;
  reserved_procedures: Array<InputMaybe<ReservedProcedures>>;
  preserve_name?: InputMaybe<Scalars['Boolean']>;
};

export type AddressInput = {
  id?: InputMaybe<Scalars['ID']>;
  street?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_addition?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};

export type NotificationActionInput = {
  uuid: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  uuid: Scalars['ID'];
  type?: Maybe<NotificationType>;
  data?: Maybe<Scalars['JSON']>;
  read_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
};

export type Avatar = {
  file: Scalars['Upload'];
};

export type AvatarUrl = {
  __typename?: 'AvatarUrl';
  url?: Maybe<Scalars['String']>;
};

export type ImportUsersResponse = {
  __typename?: 'ImportUsersResponse';
  success: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  name?: Maybe<RoleName>;
};

export type Permission = {
  __typename?: 'Permission';
  name?: Maybe<PermissionName>;
};

export type ImportUsersInput = {
  file: Scalars['Upload'];
};

export type UserInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name_prefix?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  roles: Array<RoleName>;
};

export type UpdateUserInput = {
  status?: InputMaybe<UserStatus>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name_prefix?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  preserve_name?: InputMaybe<Scalars['Boolean']>;
  bank_account_holder?: InputMaybe<Scalars['String']>;
  bank_account_number?: InputMaybe<Scalars['String']>;
  emergency_contact_name?: InputMaybe<Scalars['String']>;
  emergency_contact_phone_number?: InputMaybe<Scalars['String']>;
  big_number?: InputMaybe<Scalars['String']>;
  big_expires?: InputMaybe<Scalars['Date']>;
  has_diploma?: InputMaybe<Scalars['Boolean']>;
  diploma_type?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  profession?: InputMaybe<Scalars['String']>;
  driver_license_expires?: InputMaybe<Scalars['Date']>;
  vog_issued_at?: InputMaybe<Scalars['Date']>;
  vog_identifier?: InputMaybe<Scalars['Int']>;
  travel_allowance?: InputMaybe<Scalars['Boolean']>;
  roles?: InputMaybe<Array<RoleName>>;
  addresses?: InputMaybe<Array<AddressInput>>;
  reserved_procedures?: InputMaybe<Array<ReservedProcedures>>;
  driver_license_types?: InputMaybe<Array<DriverLicenseType>>;
  active_since?: InputMaybe<Scalars['Date']>;
  completed_at?: InputMaybe<Scalars['DateTime']>;
  files_delivered_at?: InputMaybe<Scalars['DateTime']>;
  avatar?: InputMaybe<Scalars['Upload']>;
  declaration_of_conduct?: InputMaybe<UserMedia>;
  drivers_license?: InputMaybe<UserMedia>;
  degree?: InputMaybe<UserMedia>;
};

export type DeleteUserInput = {
  preserve_name?: InputMaybe<Scalars['Boolean']>;
};

export type UserMedia = {
  file?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['String']>;
};

export type PlanningVolunteer = {
  __typename?: 'PlanningVolunteer';
  id: Scalars['ID'];
  full_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  active_since?: Maybe<Scalars['Date']>;
  score?: Maybe<Scalars['Float']>;
  addresses?: Maybe<Array<UserAddress>>;
  roles: Array<RoleName>;
};

export type MedicalInformationInput = {
  body_weight?: InputMaybe<Scalars['Int']>;
  medical_condition_and_life_expectancy?: InputMaybe<Scalars['String']>;
  covid_positive?: InputMaybe<Scalars['Boolean']>;
  location_covid_positive?: InputMaybe<Scalars['Boolean']>;
  medical_supplies?: InputMaybe<Scalars['String']>;
  resuscitate?: InputMaybe<Scalars['Boolean']>;
  resuscitate_statement?: InputMaybe<Scalars['Boolean']>;
  mobility_status?: InputMaybe<Mobility>;
  mobility_status_divergent?: InputMaybe<Scalars['String']>;
};

export type CreateMedicalInformationInput = {
  wish_id: Scalars['ID'];
  body_weight?: InputMaybe<Scalars['Int']>;
  medical_condition_and_life_expectancy?: InputMaybe<Scalars['String']>;
  covid_positive?: InputMaybe<Scalars['Boolean']>;
  location_covid_positive?: InputMaybe<Scalars['Boolean']>;
  medical_supplies?: InputMaybe<Scalars['String']>;
  resuscitate?: InputMaybe<Scalars['Boolean']>;
  resuscitate_statement?: InputMaybe<Scalars['Boolean']>;
  mobility_status?: InputMaybe<Mobility>;
  mobility_status_divergent?: InputMaybe<Scalars['String']>;
};

export type MedicalInformation = {
  __typename?: 'MedicalInformation';
  id: Scalars['ID'];
  body_weight?: Maybe<Scalars['Int']>;
  medical_condition_and_life_expectancy?: Maybe<Scalars['String']>;
  covid_positive?: Maybe<Scalars['Boolean']>;
  location_covid_positive?: Maybe<Scalars['Boolean']>;
  medical_supplies?: Maybe<Scalars['String']>;
  resuscitate?: Maybe<Scalars['Boolean']>;
  resuscitate_statement?: Maybe<Scalars['Boolean']>;
  mobility_status?: Maybe<Mobility>;
  mobility_status_divergent?: Maybe<Scalars['String']>;
};

export type Note = {
  __typename?: 'Note';
  id: Scalars['ID'];
  content: Scalars['String'];
  user?: Maybe<User>;
  notes: Array<Note>;
  event_type: NoteEventType;
  event_data?: Maybe<Scalars['JSON']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type CreateWishNoteInput = {
  noteable_id: Scalars['ID'];
  noteable_type: Scalars['String'];
  content: Scalars['String'];
  event_type: NoteEventType;
  event_data?: InputMaybe<Scalars['JSON']>;
};

export type Media = {
  __typename?: 'Media';
  id: Scalars['ID'];
  attachable: Scalars['Boolean'];
  collection_name: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  file_name: Scalars['String'];
  mime_type?: Maybe<Scalars['String']>;
  disk: Scalars['String'];
  conversion_disks?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  order_column?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  custom_properties?: Maybe<Scalars['JSON']>;
};

export type MediaInput = {
  file: Scalars['Upload'];
  description?: InputMaybe<Scalars['String']>;
};

export type MediaUploadResponse = {
  __typename?: 'MediaUploadResponse';
  success: Scalars['Boolean'];
};

export type Checklist = {
  __typename?: 'Checklist';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  status: ChecklistStatus;
  blocks: Array<ChecklistBlock>;
};

export type ChecklistBlock = {
  __typename?: 'ChecklistBlock';
  id: Scalars['ID'];
  checklist_id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  can_duplicate?: Maybe<Scalars['Boolean']>;
  questions: Array<ChecklistQuestion>;
};

export type ChecklistQuestion = {
  __typename?: 'ChecklistQuestion';
  id: Scalars['ID'];
  parent_id?: Maybe<Scalars['ID']>;
  checklist_id: Scalars['ID'];
  checklist_block_id: Scalars['ID'];
  question: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  answer_type: ChecklistAnswerType;
  required: Scalars['Boolean'];
  custom_options?: Maybe<Scalars['JSON']>;
  answers: Array<ChecklistAnswer>;
};

export type ChecklistAnswer = {
  __typename?: 'ChecklistAnswer';
  id: Scalars['ID'];
  wish_id: Scalars['ID'];
  checklist_id: Scalars['ID'];
  checklist_block_id: Scalars['ID'];
  checklist_question_id: Scalars['ID'];
  checklist_block_wish_id?: Maybe<Scalars['ID']>;
  answer: Scalars['JSON'];
  sequence: Scalars['Int'];
};

export type AnswersInput = {
  checklist_question_id: Scalars['ID'];
  checklist_block_wish_id?: InputMaybe<Scalars['ID']>;
  answer: Scalars['JSON'];
  sequence: Scalars['Int'];
};

export type DeleteChecklistBlockWishResponse = {
  __typename?: 'DeleteChecklistBlockWishResponse';
  success: Scalars['Boolean'];
};

export type Photo = {
  __typename?: 'Photo';
  uuid: Scalars['ID'];
  name: Scalars['String'];
  src: Scalars['String'];
  srcset: Array<SrcsetItem>;
  placeholder?: Maybe<Scalars['String']>;
  download_url: Scalars['String'];
  metadata: PhotoMetadata;
};

export type SrcsetItem = {
  __typename?: 'SrcsetItem';
  width: Scalars['Int'];
  src: Scalars['String'];
};

export type PhotoMetadata = {
  __typename?: 'PhotoMetadata';
  size?: Maybe<Scalars['Int']>;
  mime_type?: Maybe<Scalars['String']>;
};

export type WishInput = {
  preferred_wish_date?: InputMaybe<Scalars['Date']>;
  wish_description: Scalars['String'];
  additional_information?: InputMaybe<Scalars['String']>;
  referral_information?: InputMaybe<Scalars['String']>;
  previously_wish_requested: Scalars['Boolean'];
  wish_requested_at_other_organization: Scalars['Boolean'];
  organization_wish_requested_at?: InputMaybe<Scalars['String']>;
  wish_needs_ambulance: Scalars['Boolean'];
  contacts: CreateContactsHasMany;
  medical_information: CreateMedicalInformationHasOne;
};

export type CreateWishRequestInput = {
  status?: InputMaybe<Status>;
  preferred_wish_date?: InputMaybe<Scalars['Date']>;
  wish_description: Scalars['String'];
  additional_information?: InputMaybe<Scalars['String']>;
  referral_information?: InputMaybe<Scalars['String']>;
  previously_wish_requested?: InputMaybe<Scalars['Boolean']>;
  wish_requested_at_other_organization?: InputMaybe<Scalars['Boolean']>;
  organization_wish_requested_at?: InputMaybe<Scalars['String']>;
  wish_needs_ambulance?: InputMaybe<Scalars['Boolean']>;
  contacts?: InputMaybe<CreateContactsHasMany>;
  medical_information?: InputMaybe<CreateMedicalInformationHasOne>;
};

export type UpdateWishRequestInput = {
  id: Scalars['ID'];
  status?: InputMaybe<Status>;
  preferred_wish_date?: InputMaybe<Scalars['Date']>;
  wish_description?: InputMaybe<Scalars['String']>;
  additional_information?: InputMaybe<Scalars['String']>;
  referral_information?: InputMaybe<Scalars['String']>;
  previously_wish_requested?: InputMaybe<Scalars['Boolean']>;
  wish_requested_at_other_organization?: InputMaybe<Scalars['Boolean']>;
  organization_wish_requested_at?: InputMaybe<Scalars['String']>;
  wish_needs_ambulance?: InputMaybe<Scalars['Boolean']>;
  contacts?: InputMaybe<UpdateContactsHasMany>;
  medical_information?: InputMaybe<CreateMedicalInformationHasOne>;
};

export type UpdateWishInput = {
  status?: InputMaybe<Status>;
  wish_date?: InputMaybe<Scalars['Date']>;
  end_date?: InputMaybe<Scalars['Date']>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
  planning_status?: InputMaybe<PlanningStatus>;
  people_going?: InputMaybe<Scalars['Int']>;
  preferred_wish_date?: InputMaybe<Scalars['Date']>;
  wish_description?: InputMaybe<Scalars['String']>;
  additional_information?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  volunteers?: InputMaybe<Array<Scalars['ID']>>;
  departure_at?: InputMaybe<Scalars['DateTime']>;
  arrival_at?: InputMaybe<Scalars['DateTime']>;
  referral_information?: InputMaybe<Scalars['String']>;
  previously_wish_requested?: InputMaybe<Scalars['Boolean']>;
  wish_requested_at_other_organization?: InputMaybe<Scalars['Boolean']>;
  organization_wish_requested_at?: InputMaybe<Scalars['String']>;
  wish_needs_ambulance?: InputMaybe<Scalars['Boolean']>;
};

export type ValidateWishDateInput = {
  wish_id: Scalars['Int'];
  vehicle_id: Scalars['ID'];
  wish_date?: InputMaybe<Scalars['Date']>;
  end_date?: InputMaybe<Scalars['Date']>;
};

export type WishDateValidationResponse = {
  __typename?: 'WishDateValidationResponse';
  valid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type CreateContactsHasMany = {
  create: Array<ContactInput>;
};

export type UpdateContactsHasMany = {
  update: Array<UpdateContactInput>;
};

export type CreateMedicalInformationHasOne = {
  create?: InputMaybe<MedicalInformationInput>;
};

export type Wish = {
  __typename?: 'Wish';
  id: Scalars['ID'];
  vehicle_id?: Maybe<Scalars['ID']>;
  vehicle?: Maybe<Vehicle>;
  preferred_wish_date?: Maybe<Scalars['Date']>;
  wish_date?: Maybe<Scalars['Date']>;
  end_date?: Maybe<Scalars['Date']>;
  wish_description?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  additional_information?: Maybe<Scalars['String']>;
  referral_information?: Maybe<Scalars['String']>;
  previously_wish_requested?: Maybe<Scalars['Boolean']>;
  wish_requested_at_other_organization?: Maybe<Scalars['Boolean']>;
  organization_wish_requested_at?: Maybe<Scalars['String']>;
  wish_needs_ambulance?: Maybe<Scalars['Boolean']>;
  days: Scalars['Int'];
  status: Status;
  planning_status?: Maybe<PlanningStatus>;
  people_going: Scalars['Int'];
  patient?: Maybe<Contact>;
  contacts?: Maybe<Array<Contact>>;
  medical_information?: Maybe<MedicalInformation>;
  created_at?: Maybe<Scalars['Date']>;
  updated_at?: Maybe<Scalars['Date']>;
  deleted_at?: Maybe<Scalars['Date']>;
  users?: Maybe<Array<User>>;
  user_wish?: Maybe<Array<UserWish>>;
  checklist_blocks?: Maybe<Array<ChecklistBlock>>;
  checklist_block_wish?: Maybe<Array<ChecklistBlockWish>>;
  locations?: Maybe<Array<WishAddress>>;
  notes?: Maybe<Array<Note>>;
  media?: Maybe<Array<Media>>;
  mailCustomizations?: Maybe<Array<MailCustomization>>;
  mileage?: Maybe<Mileage>;
  expenses_sum?: Maybe<Scalars['Float']>;
  activities?: Maybe<Array<Activity>>;
};

export type UserWish = {
  __typename?: 'UserWish';
  user: User;
  confirmed: Scalars['Boolean'];
};

export type ChecklistBlockWish = {
  __typename?: 'ChecklistBlockWish';
  id: Scalars['ID'];
  checklistBlock: ChecklistBlock;
  custom_block_name: Scalars['String'];
  answers?: Maybe<Array<ChecklistAnswer>>;
};

export type UpdateUsersBelongToMany = {
  connect?: InputMaybe<Array<Scalars['ID']>>;
  disconnect?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateWishUsersInput = {
  id: Scalars['ID'];
  users?: InputMaybe<UpdateUsersBelongToMany>;
};

export type UpdateWishVehicleInput = {
  id: Scalars['ID'];
  vehicle_id?: InputMaybe<Scalars['ID']>;
};

export type PlannableWishesInput = {
  start_date: Scalars['Date'];
  end_date: Scalars['Date'];
  with_unplanned: Scalars['Boolean'];
};

export type WishDocumentInput = {
  id: Scalars['ID'];
  file: Scalars['Upload'];
  description?: InputMaybe<Scalars['String']>;
};

export type GenericMediaToWishInput = {
  wish_id: Scalars['ID'];
  genric_media_id: Scalars['ID'];
};

export type WishDocumentUploadResponse = {
  __typename?: 'WishDocumentUploadResponse';
  success: Scalars['Boolean'];
};

export type AssignWishToVehicleResponse = {
  __typename?: 'AssignWishToVehicleResponse';
  success: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type ConfirmWishResponse = {
  __typename?: 'ConfirmWishResponse';
  success: Scalars['Boolean'];
};

export type Expense = {
  __typename?: 'Expense';
  id: Scalars['ID'];
  wish_id?: Maybe<Scalars['ID']>;
  wish?: Maybe<Wish>;
  submitted_by?: Maybe<User>;
  payout_to?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  type?: Maybe<ExpenseType>;
  status?: Maybe<ExpenseStatus>;
  attachment?: Maybe<Media>;
  metadata?: Maybe<MetaData>;
  transaction_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
};

export type ExpenseCreateInput = {
  wish_id?: InputMaybe<Scalars['ID']>;
  payout_to?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
  type: ExpenseType;
  attachment?: InputMaybe<Scalars['Upload']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  transaction_at?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
};

export type ExpenseUpdateInput = {
  payout_to?: InputMaybe<Scalars['ID']>;
  amount?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ExpenseType>;
  status?: InputMaybe<ExpenseStatus>;
  attachment?: InputMaybe<Scalars['Upload']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  transaction_at?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
};

export type Mileage = {
  __typename?: 'Mileage';
  id: Scalars['ID'];
  vehicle?: Maybe<Vehicle>;
  wish?: Maybe<Wish>;
  mileage_start?: Maybe<Scalars['Int']>;
  mileage_end?: Maybe<Scalars['Int']>;
  distance_traveled?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  reference?: Maybe<MileageReference>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MileageInput = {
  vehicle_id: Scalars['ID'];
  wish_id?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  reference?: InputMaybe<MileageReference>;
  mileage_start: Scalars['Int'];
  mileage_end: Scalars['Int'];
};

export type Reservation = {
  __typename?: 'Reservation';
  id: Scalars['ID'];
  start_date: Scalars['Date'];
  end_date?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['ID']>;
  deleted_at?: Maybe<Scalars['Date']>;
};

export type ReservationInput = {
  vehicle_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['Date']>;
  end_date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
};

export type MetaData = {
  __typename?: 'MetaData';
  from_address_id?: Maybe<Scalars['ID']>;
  to_address_id?: Maybe<Scalars['ID']>;
  travel_allowance_rate?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  roundtrip?: Maybe<Scalars['Boolean']>;
  readonly?: Maybe<Scalars['Boolean']>;
  bank_card_number?: Maybe<Scalars['Int']>;
  exact?: Maybe<Scalars['Boolean']>;
};

export type ExactDivision = {
  __typename?: 'ExactDivision';
  id: Scalars['ID'];
  code?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  journals: Array<ExactJournal>;
  general_ledger_accounts: Array<ExactGeneralLedgerAccount>;
};

export type ExactJournal = {
  __typename?: 'ExactJournal';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ExactGeneralLedgerAccount = {
  __typename?: 'ExactGeneralLedgerAccount';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ExactJournalTypeValue = {
  __typename?: 'ExactJournalTypeValue';
  type: Scalars['String'];
  id: Scalars['ID'];
};

export type ExactGeneralLedgerAccountTypeValue = {
  __typename?: 'ExactGeneralLedgerAccountTypeValue';
  type: Scalars['String'];
  id: Scalars['ID'];
};

export type ExactConfig = {
  __typename?: 'ExactConfig';
  id: Scalars['ID'];
  enabled?: Maybe<Scalars['Boolean']>;
  default_division?: Maybe<Scalars['ID']>;
  default_journals: Array<ExactJournalTypeValue>;
  default_general_ledger_accounts: Array<ExactGeneralLedgerAccountTypeValue>;
};

export type ExactJournalTypeValueInput = {
  type: Scalars['String'];
  id: Scalars['ID'];
};

export type ExactGeneralLedgerAccountTypeValueInput = {
  type: Scalars['String'];
  id: Scalars['ID'];
};

export type ExactConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  default_division?: InputMaybe<Scalars['ID']>;
  default_journals?: InputMaybe<Array<ExactJournalTypeValueInput>>;
  default_general_ledger_accounts?: InputMaybe<Array<ExactGeneralLedgerAccountTypeValueInput>>;
};

export type Subject = Mail | Note | GenericModel;

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['ID'];
  log_name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  subject_type?: Maybe<Scalars['String']>;
  subject_id?: Maybe<Scalars['ID']>;
  subject?: Maybe<Subject>;
  causer_type?: Maybe<Scalars['String']>;
  causer_id?: Maybe<Scalars['ID']>;
  event?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['JSON']>;
  batch_uuid?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  causer?: Maybe<User>;
};

export type Notifiable = User | Contact;

export type Mail = {
  __typename?: 'Mail';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['ID']>;
  notification?: Maybe<Scalars['String']>;
  notifiable?: Maybe<Notifiable>;
  subject?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  status?: Maybe<MailStatus>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  preview_url?: Maybe<Scalars['String']>;
};

export type LoginInput = {
  username: Scalars['String'];
  password: Scalars['String'];
};

export type RefreshTokenInput = {
  refresh_token?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  status?: Maybe<UserStatus>;
  preserve_name?: Maybe<Scalars['Boolean']>;
  full_name: Scalars['String'];
  first_name: Scalars['String'];
  last_name_prefix?: Maybe<Scalars['String']>;
  last_name: Scalars['String'];
  email: Scalars['String'];
  date_of_birth?: Maybe<Scalars['Date']>;
  phone_number?: Maybe<Scalars['String']>;
  bank_account_holder?: Maybe<Scalars['String']>;
  bank_account_number?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_contact_phone_number?: Maybe<Scalars['String']>;
  big_number?: Maybe<Scalars['String']>;
  big_expires?: Maybe<Scalars['Date']>;
  has_diploma?: Maybe<Scalars['Boolean']>;
  diploma_type?: Maybe<Scalars['String']>;
  graduation_year?: Maybe<Scalars['Int']>;
  profession?: Maybe<Scalars['String']>;
  driver_license_expires?: Maybe<Scalars['Date']>;
  vog_issued_at?: Maybe<Scalars['Date']>;
  vog_identifier?: Maybe<Scalars['Int']>;
  travel_allowance?: Maybe<Scalars['Boolean']>;
  avatar_url?: Maybe<Scalars['String']>;
  declaration_of_conduct?: Maybe<Media>;
  drivers_license?: Maybe<Media>;
  degree?: Maybe<Media>;
  activated?: Maybe<Scalars['Boolean']>;
  activated_at?: Maybe<Scalars['DateTime']>;
  active_since?: Maybe<Scalars['Date']>;
  completed?: Maybe<Scalars['Boolean']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  files_delivered?: Maybe<Scalars['Boolean']>;
  files_delivered_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  deletable?: Maybe<Scalars['Boolean']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  roles: Array<RoleName>;
  permissions: Array<PermissionName>;
  driver_license_types: Array<DriverLicenseType>;
  addresses?: Maybe<Array<UserAddress>>;
  wishes?: Maybe<Array<Wish>>;
  reserved_procedures?: Maybe<Array<ReservedProcedures>>;
  activities?: Maybe<Array<Activity>>;
};

export enum TwoFaMethod {
  Email = 'Email',
  Sms = 'SMS'
}

export type OtpResponse = {
  __typename?: 'OtpResponse';
  success: Scalars['Boolean'];
  method: TwoFaMethod;
  digits: Scalars['Int'];
  expiration_time_in_minutes: Scalars['Int'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  access_token?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  token_type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  otp?: Maybe<OtpResponse>;
};

export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload';
  access_token: Scalars['String'];
  refresh_token: Scalars['String'];
  expires_in: Scalars['Int'];
  token_type: Scalars['String'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  status: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  status: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type UpdatePasswordResponse = {
  __typename?: 'UpdatePasswordResponse';
  status: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type NewPasswordWithCodeInput = {
  email: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
};

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type UpdatePasswordInput = {
  old_password: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
};

export type TwoFactorVerificationInput = {
  otp: Scalars['String'];
  id: Scalars['ID'];
};

export type TwoFactorVerificationResponse = {
  __typename?: 'TwoFactorVerificationResponse';
  valid: Scalars['Boolean'];
  otp: Scalars['String'];
  user: User;
};

export type ResendTwoFactorVerificationInput = {
  id: Scalars['ID'];
};

export type ResendTwoFactorVerificationResponse = {
  __typename?: 'ResendTwoFactorVerificationResponse';
  success: Scalars['Boolean'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

/** A paginated list of UserAddress items. */
export type UserAddressPaginator = {
  __typename?: 'UserAddressPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of UserAddress items. */
  data: Array<UserAddress>;
};

/** A paginated list of Address items. */
export type AddressPaginator = {
  __typename?: 'AddressPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of Address items. */
  data: Array<Address>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of User items. */
  data: Array<User>;
};

/** A paginated list of PlanningVolunteer items. */
export type PlanningVolunteerPaginator = {
  __typename?: 'PlanningVolunteerPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of PlanningVolunteer items. */
  data: Array<PlanningVolunteer>;
};

/** A paginated list of Media items. */
export type MediaPaginator = {
  __typename?: 'MediaPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of Media items. */
  data: Array<Media>;
};

/** A paginated list of Wish items. */
export type WishPaginator = {
  __typename?: 'WishPaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of Wish items. */
  data: Array<Wish>;
};

/** A paginated list of Expense items. */
export type ExpensePaginator = {
  __typename?: 'ExpensePaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of Expense items. */
  data: Array<Expense>;
};

/** A paginated list of Mileage items. */
export type MileagePaginator = {
  __typename?: 'MileagePaginator';
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
  /** A list of Mileage items. */
  data: Array<Mileage>;
};

/** Allowed column names for Query.exportMileages.orderBy. */
export enum QueryExportMileagesOrderByColumn {
  MileageStart = 'MILEAGE_START',
  Id = 'ID',
  Date = 'DATE',
  CreatedAt = 'CREATED_AT',
  MileageEnd = 'MILEAGE_END'
}

/** Order by clause for Query.exportMileages.orderBy. */
export type QueryExportMileagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryExportMileagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.addresses.orderBy. */
export enum QueryAddressesOrderByColumn {
  Id = 'ID',
  Name = 'NAME',
  PostalCode = 'POSTAL_CODE',
  City = 'CITY',
  Country = 'COUNTRY',
  TotalCount = 'TOTAL_COUNT',
  WishesCount = 'WISHES_COUNT',
  CreatedAt = 'CREATED_AT'
}

/** Order by clause for Query.addresses.orderBy. */
export type QueryAddressesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryAddressesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.users.orderBy. */
export enum QueryUsersOrderByColumn {
  Id = 'ID',
  FullName = 'FULL_NAME',
  ActiveSince = 'ACTIVE_SINCE'
}

/** Order by clause for Query.users.orderBy. */
export type QueryUsersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryUsersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.planningVolunteers.orderBy. */
export enum QueryPlanningVolunteersOrderByColumn {
  FullName = 'FULL_NAME',
  ActiveSince = 'ACTIVE_SINCE',
  Score = 'SCORE'
}

/** Order by clause for Query.planningVolunteers.orderBy. */
export type QueryPlanningVolunteersOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryPlanningVolunteersOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.media.orderBy. */
export enum QueryMediaOrderByColumn {
  Id = 'ID',
  Description = 'DESCRIPTION',
  FileName = 'FILE_NAME',
  MimeType = 'MIME_TYPE',
  Size = 'SIZE',
  CreatedAt = 'CREATED_AT'
}

/** Order by clause for Query.media.orderBy. */
export type QueryMediaOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryMediaOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.wishes.orderBy. */
export enum QueryWishesOrderByColumn {
  Id = 'ID',
  PreferredWishDate = 'PREFERRED_WISH_DATE',
  WishDate = 'WISH_DATE',
  Status = 'STATUS',
  CreatedAt = 'CREATED_AT'
}

/** Order by clause for Query.wishes.orderBy. */
export type QueryWishesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryWishesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.expenses.orderBy. */
export enum QueryExpensesOrderByColumn {
  Id = 'ID',
  WishId = 'WISH_ID',
  Type = 'TYPE',
  Amount = 'AMOUNT',
  Status = 'STATUS',
  TransactionAt = 'TRANSACTION_AT'
}

/** Order by clause for Query.expenses.orderBy. */
export type QueryExpensesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryExpensesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.mileages.orderBy. */
export enum QueryMileagesOrderByColumn {
  MileageStart = 'MILEAGE_START',
  Id = 'ID',
  Date = 'DATE',
  CreatedAt = 'CREATED_AT',
  MileageEnd = 'MILEAGE_END'
}

/** Order by clause for Query.mileages.orderBy. */
export type QueryMileagesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryMileagesOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Minimum. */
  Min = 'MIN',
  /** Maximum. */
  Max = 'MAX',
  /** Sum. */
  Sum = 'SUM',
  /** Amount of items. */
  Count = 'COUNT'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type ActivityFragmentFragment = { __typename?: 'Activity', id: string, log_name?: string | null, description?: string | null, subject_type?: string | null, subject_id?: string | null, causer_type?: string | null, causer_id?: string | null, event?: string | null, properties?: any | null, batch_uuid?: string | null, created_at?: string | null, updated_at?: string | null, causer?: { __typename?: 'User', id: string, full_name: string } | null, subject?: { __typename?: 'Mail', id: string, notification?: string | null, subject?: string | null, status?: MailStatus | null, created_at?: string | null, updated_at?: string | null, preview_url?: string | null, notifiable?: { __typename?: 'User', id: string, full_name: string } | { __typename?: 'Contact', id: string, persona?: string | null } | null } | { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> } | { __typename?: 'GenericModel', model?: string | null, data?: any | null } | null };

export type MailFragmentFragment = { __typename?: 'Mail', id: string, notification?: string | null, subject?: string | null, status?: MailStatus | null, created_at?: string | null, updated_at?: string | null, preview_url?: string | null, notifiable?: { __typename?: 'User', id: string, full_name: string } | { __typename?: 'Contact', id: string, persona?: string | null } | null };

type AddressFragment_Address_Fragment = { __typename?: 'Address', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

type AddressFragment_ContactAddress_Fragment = { __typename?: 'ContactAddress', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

type AddressFragment_WishAddress_Fragment = { __typename?: 'WishAddress', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

type AddressFragment_UserAddress_Fragment = { __typename?: 'UserAddress', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

export type AddressFragmentFragment = AddressFragment_Address_Fragment | AddressFragment_ContactAddress_Fragment | AddressFragment_WishAddress_Fragment | AddressFragment_UserAddress_Fragment;

export type ContactAddressFragmentFragment = { __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

export type WishAddressFragmentFragment = { __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

export type UserAddressFragmentFragment = { __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country };

export type ExpenseFragmentFragment = { __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null };

export type SimpleChecklistFragmentFragment = { __typename?: 'Checklist', id: string, name: string, status: ChecklistStatus, description?: string | null };

export type ChecklistBlockFragmentFragment = { __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null };

export type ChecklistBlockWishFragmentFragment = { __typename?: 'ChecklistBlockWish', id: string, custom_block_name: string, checklistBlock: { __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null }> }, answers?: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> | null };

export type ChecklistQuestionFragmentFragment = { __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null };

export type ChecklistAnswerFragmentFragment = { __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number };

export type ChecklistFragmentFragment = { __typename?: 'Checklist', id: string, name: string, status: ChecklistStatus, description?: string | null, blocks: Array<{ __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null, answers: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> }> }> };

export type ContactFragmentFragment = { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null };

export type ExpenseRelatedWishFragmentFragment = { __typename?: 'Wish', id: string, wish_date?: string | null, end_date?: string | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, bank_card_number?: number | null } | null };

export type MediaFragmentFragment = { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null };

export type MileageFragmentFragment = { __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null };

export type MedicalInformationFragmentFragment = { __typename?: 'MedicalInformation', id: string, body_weight?: number | null, medical_condition_and_life_expectancy?: string | null, covid_positive?: boolean | null, location_covid_positive?: boolean | null, medical_supplies?: string | null, resuscitate?: boolean | null, resuscitate_statement?: boolean | null, mobility_status?: Mobility | null, mobility_status_divergent?: string | null };

export type NoteFragmentFragment = { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> };

export type PhotoFragmentFragment = { __typename?: 'Photo', uuid: string, name: string, src: string, placeholder?: string | null, download_url: string, srcset: Array<{ __typename?: 'SrcsetItem', width: number, src: string }>, metadata: { __typename?: 'PhotoMetadata', size?: number | null, mime_type?: string | null } };

export type PlanableWishesFragmentFragment = { __typename?: 'Wish', id: string, vehicle_id?: string | null, wish_date?: string | null, end_date?: string | null, preferred_wish_date?: string | null, status: Status, planning_status?: PlanningStatus | null, people_going: number, wish_description?: string | null, patient?: { __typename?: 'Contact', full_name?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null };

export type NotificationFragmentFragment = { __typename?: 'Notification', id: string, uuid: string, type?: NotificationType | null, data?: any | null, read_at?: string | null, created_at?: string | null };

export type PlannableVolunteerFragmentFragment = { __typename?: 'PlanningVolunteer', id: string, full_name?: string | null, phone_number?: string | null, roles: Array<RoleName>, active_since?: string | null, score?: number | null, addresses?: Array<{ __typename?: 'UserAddress', city?: string | null }> | null };

export type PlannableWishFragmentFragment = { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_date?: string | null, wish_description?: string | null, subject?: string | null, end_date?: string | null, planning_status?: PlanningStatus | null, people_going: number, patient?: { __typename?: 'Contact', full_name?: string | null, date_of_birth?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null, mailCustomizations?: Array<{ __typename?: 'MailCustomization', id: string, customization_type: MailCustomizationType, content: string }> | null };

export type ReservationFragmentFragment = { __typename?: 'Reservation', id: string, start_date: string, end_date?: string | null, description?: string | null, vehicle_id?: string | null, deleted_at?: string | null };

export type UserFragmentFragment = { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null };

export type UserDetailsFragmentFragment = { __typename?: 'UserDetails', bank_account_holder?: string | null, bank_account_number?: string | null, emergency_contact_name?: string | null, emergency_contact_phone_number?: string | null, big_number?: string | null, big_expires?: string | null, has_diploma?: boolean | null, diploma_type?: string | null, graduation_year?: number | null, driver_license_expires?: string | null, driver_license_types: Array<DriverLicenseType>, vog_issued_at?: string | null, vog_identifier?: number | null, preserve_name?: boolean | null, profession?: string | null, reserved_procedures: Array<ReservedProcedures>, active_since?: string | null, addresses: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> };

export type VehicleFragmentFragment = { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null };

export type WishFragmentFragment = { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type WishDetailFragmentFragment = { __typename?: 'Wish', additional_information?: string | null, referral_information?: string | null, previously_wish_requested?: boolean | null, wish_requested_at_other_organization?: boolean | null, organization_wish_requested_at?: string | null, wish_needs_ambulance?: boolean | null, expenses_sum?: number | null, id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null, id: string, body_weight?: number | null, medical_condition_and_life_expectancy?: string | null, covid_positive?: boolean | null, location_covid_positive?: boolean | null, resuscitate?: boolean | null, resuscitate_statement?: boolean | null, mobility_status?: Mobility | null, mobility_status_divergent?: string | null } | null, contacts?: Array<{ __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null }> | null, users?: Array<{ __typename?: 'User', id: string, full_name: string }> | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, checklist_block_wish?: Array<{ __typename?: 'ChecklistBlockWish', id: string, custom_block_name: string, checklistBlock: { __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null }> }, answers?: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> | null }> | null, notes?: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> }> | null, locations?: Array<{ __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null, media?: Array<{ __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null }> | null, mileage?: { __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null } | null, activities?: Array<{ __typename?: 'Activity', id: string, log_name?: string | null, description?: string | null, subject_type?: string | null, subject_id?: string | null, causer_type?: string | null, causer_id?: string | null, event?: string | null, properties?: any | null, batch_uuid?: string | null, created_at?: string | null, updated_at?: string | null, causer?: { __typename?: 'User', id: string, full_name: string } | null, subject?: { __typename?: 'Mail', id: string, notification?: string | null, subject?: string | null, status?: MailStatus | null, created_at?: string | null, updated_at?: string | null, preview_url?: string | null, notifiable?: { __typename?: 'User', id: string, full_name: string } | { __typename?: 'Contact', id: string, persona?: string | null } | null } | { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> } | { __typename?: 'GenericModel', model?: string | null, data?: any | null } | null }> | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type ActivateUserMutationVariables = Exact<{
  input?: InputMaybe<ActivateUserInput>;
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'AuthPayload', access_token?: string | null, refresh_token?: string | null, user?: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } };

export type ArchiveWishMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveWishMutation = { __typename?: 'Mutation', archiveWish?: { __typename?: 'Wish', id: string } | null };

export type ConfirmWishMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmWishMutation = { __typename?: 'Mutation', confirmWish?: { __typename?: 'ConfirmWishResponse', success: boolean } | null };

export type CreateAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'Address' } | { __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } };

export type CreateMileageMutationVariables = Exact<{
  input: MileageInput;
}>;


export type CreateMileageMutation = { __typename?: 'Mutation', createMileage?: { __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null } | null };

export type CreateMedicalInformationMutationVariables = Exact<{
  input: CreateMedicalInformationInput;
}>;


export type CreateMedicalInformationMutation = { __typename?: 'Mutation', createMedicalInformation?: { __typename?: 'MedicalInformation', id: string } | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateWishNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote?: { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null }> } | null };

export type CreateReservationMutationVariables = Exact<{
  input: ReservationInput;
}>;


export type CreateReservationMutation = { __typename?: 'Mutation', createReservation?: { __typename?: 'Reservation', id: string } | null };

export type CreateVehicleMutationVariables = Exact<{
  input: VehicleInput;
}>;


export type CreateVehicleMutation = { __typename?: 'Mutation', createVehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null };

export type CreateUserMutationVariables = Exact<{
  input?: InputMaybe<UserInput>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type CreateVehicleAvailabilityEntryMutationVariables = Exact<{
  vehicle_id: Scalars['ID'];
  unavailable_on: Scalars['Date'];
}>;


export type CreateVehicleAvailabilityEntryMutation = { __typename?: 'Mutation', createVehicleAvailabilityEntry: { __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string } };

export type CreateWishMutationVariables = Exact<{
  input: WishInput;
}>;


export type CreateWishMutation = { __typename?: 'Mutation', createWish?: { __typename?: 'Wish', id: string, patient?: { __typename?: 'Contact', id: string } | null } | null };

export type CreateWishRequestMutationVariables = Exact<{
  input: CreateWishRequestInput;
}>;


export type CreateWishRequestMutation = { __typename?: 'Mutation', createWishRequest?: { __typename?: 'Wish', id: string, patient?: { __typename?: 'Contact', id: string } | null } | null };

export type DeleteAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  type: Scalars['String'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', deleteAddress: { __typename?: 'Address' } | { __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } };

export type DeleteMailCustomizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMailCustomizationMutation = { __typename?: 'Mutation', deleteMailCustomization?: { __typename?: 'MailCustomization', id: string } | null };

export type DeleteVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVehicleMutation = { __typename?: 'Mutation', deleteVehicle: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } };

export type DeleteReservationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReservationMutation = { __typename?: 'Mutation', deleteReservation: { __typename?: 'Reservation', id: string } };

export type DeleteVehicleAvailabilityEntryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVehicleAvailabilityEntryMutation = { __typename?: 'Mutation', deleteVehicleAvailabilityEntry?: { __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string } | null };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type LoginMutationVariables = Exact<{
  input?: InputMaybe<LoginInput>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', access_token?: string | null, refresh_token?: string | null, user?: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null, otp?: { __typename?: 'OtpResponse', success: boolean, method: TwoFaMethod, digits: number, expiration_time_in_minutes: number } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', status: string, message?: string | null } };

export type RefreshTokenMutationVariables = Exact<{
  input?: InputMaybe<RefreshTokenInput>;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenPayload', access_token: string, refresh_token: string } };

export type ResendActivationMailMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendActivationMailMutation = { __typename?: 'Mutation', resendActivationMail?: { __typename?: 'SimpleStatus', status?: string | null } | null };

export type ResendTwoFactorVerificationMutationVariables = Exact<{
  input: ResendTwoFactorVerificationInput;
}>;


export type ResendTwoFactorVerificationMutation = { __typename?: 'Mutation', resendTwoFactorVerification: { __typename?: 'ResendTwoFactorVerificationResponse', success: boolean } };

export type SetNotificationReadMutationVariables = Exact<{
  input: NotificationActionInput;
}>;


export type SetNotificationReadMutation = { __typename?: 'Mutation', setNotificationRead: { __typename?: 'SimpleStatus', status?: string | null, message?: string | null } };

export type SetNotificationUnreadMutationVariables = Exact<{
  input: NotificationActionInput;
}>;


export type SetNotificationUnreadMutation = { __typename?: 'Mutation', setNotificationUnread: { __typename?: 'SimpleStatus', status?: string | null, message?: string | null } };

export type SetNotificationDeletedMutationVariables = Exact<{
  input: NotificationActionInput;
}>;


export type SetNotificationDeletedMutation = { __typename?: 'Mutation', setNotificationDeleted: { __typename?: 'SimpleStatus', status?: string | null, message?: string | null } };

export type RestoreVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreVehicleMutation = { __typename?: 'Mutation', restoreVehicle: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } };

export type ImportUsersMutationVariables = Exact<{
  input?: InputMaybe<ImportUsersInput>;
}>;


export type ImportUsersMutation = { __typename?: 'Mutation', importUsers?: { __typename?: 'ImportUsersResponse', success: boolean } | null };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } };

export type RestoreWishMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreWishMutation = { __typename?: 'Mutation', restoreWish?: { __typename?: 'Wish', id: string } | null };

export type TwoFactorVerificationMutationVariables = Exact<{
  input: TwoFactorVerificationInput;
}>;


export type TwoFactorVerificationMutation = { __typename?: 'Mutation', twoFactorVerification: { __typename?: 'TwoFactorVerificationResponse', valid: boolean, otp: string, user: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } } };

export type ToggleVehicleActivenessMutationVariables = Exact<{
  id: Scalars['ID'];
  inactive: Scalars['Boolean'];
}>;


export type ToggleVehicleActivenessMutation = { __typename?: 'Mutation', toggleVehicleActiveness: { __typename?: 'ToggleActivenessResponse', success: boolean, attached_wishes: number } };

export type UnplanWishMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnplanWishMutation = { __typename?: 'Mutation', unplanWish?: { __typename?: 'Wish', id: string } | null };

export type UpdateForgottenPasswordMutationVariables = Exact<{
  input?: InputMaybe<NewPasswordWithCodeInput>;
}>;


export type UpdateForgottenPasswordMutation = { __typename?: 'Mutation', updateForgottenPassword: { __typename?: 'ForgotPasswordResponse', status: string, message?: string | null } };

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'Address' } | { __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | { __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } };

export type UpdateMedicalInformationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MedicalInformationInput;
}>;


export type UpdateMedicalInformationMutation = { __typename?: 'Mutation', updateMedicalInformation?: { __typename?: 'MedicalInformation', id: string } | null };

export type UpdateReservationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation?: { __typename?: 'Reservation', id: string } | null };

export type UpdateMileageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MileageInput;
}>;


export type UpdateMileageMutation = { __typename?: 'Mutation', updateMileage?: { __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'UpdatePasswordResponse', status: string } };

export type UpdateVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
  input: VehicleInput;
}>;


export type UpdateVehicleMutation = { __typename?: 'Mutation', updateVehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UpdateUserStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: UserStatus;
  note: Scalars['String'];
  eventData: Scalars['JSON'];
}>;


export type UpdateUserStatusMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string }, createNote?: { __typename?: 'Note', id: string } | null };

export type UpdateVehicleAvailabilityEntryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: VehicleAvailabilityEntryInput;
}>;


export type UpdateVehicleAvailabilityEntryMutation = { __typename?: 'Mutation', updateVehicleAvailabilityEntry: { __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null } };

export type UpdateWishMutationVariables = Exact<{
  id: Scalars['ID'];
  planningUpdate?: InputMaybe<Scalars['Boolean']>;
  input: UpdateWishInput;
}>;


export type UpdateWishMutation = { __typename?: 'Mutation', updateWish: { __typename?: 'Wish', id: string } };

export type UpdateWishContactsMutationVariables = Exact<{
  wishId: Scalars['ID'];
  contactType?: InputMaybe<ContactType>;
  contacts: Array<UpdateContactInput> | UpdateContactInput;
}>;


export type UpdateWishContactsMutation = { __typename?: 'Mutation', updateWishContacts: Array<{ __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null }> };

export type UpdateWishRequestMutationVariables = Exact<{
  input: UpdateWishRequestInput;
}>;


export type UpdateWishRequestMutation = { __typename?: 'Mutation', updateWishRequest?: { __typename?: 'Wish', id: string, patient?: { __typename?: 'Contact', id: string } | null } | null };

export type UpdateWishStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Status;
  note: Scalars['String'];
  eventData: Scalars['JSON'];
}>;


export type UpdateWishStatusMutation = { __typename?: 'Mutation', updateWish: { __typename?: 'Wish', id: string }, createNote?: { __typename?: 'Note', id: string } | null };

export type UploadWishDocumentMutationVariables = Exact<{
  input: WishDocumentInput;
}>;


export type UploadWishDocumentMutation = { __typename?: 'Mutation', uploadWishDocument?: { __typename?: 'WishDocumentUploadResponse', success: boolean } | null };

export type UploadAvatarMutationVariables = Exact<{
  input?: InputMaybe<Avatar>;
}>;


export type UploadAvatarMutation = { __typename?: 'Mutation', uploadAvatar?: { __typename?: 'AvatarUrl', url?: string | null } | null };

export type ActiveVehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveVehiclesQuery = { __typename?: 'Query', activeVehicles: Array<{ __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null }> };

export type AddressesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  wishAddresses?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  column: QueryAddressesOrderByColumn;
  order: SortOrder;
}>;


export type AddressesQuery = { __typename?: 'Query', addresses: { __typename?: 'AddressPaginator', data: Array<{ __typename?: 'Address', formatted?: string | null, address_line_1?: string | null, wishes_count?: number | null, total_count?: number | null, has_location?: boolean | null, has_place_id?: boolean | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type AllVehicleAvailabilityEntriesQueryVariables = Exact<{
  from: Scalars['Date'];
  to: Scalars['Date'];
  vehicle_id?: InputMaybe<Scalars['ID']>;
}>;


export type AllVehicleAvailabilityEntriesQuery = { __typename?: 'Query', allVehicleAvailabilityEntries: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, vehicle?: { __typename?: 'Vehicle', id: string } | null }> };

export type AvailabilityQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
  user_id?: InputMaybe<Scalars['ID']>;
}>;


export type AvailabilityQuery = { __typename?: 'Query', availability: Array<{ __typename?: 'Availability', date: string, available?: boolean | null, blocked?: boolean | null, wish_planned?: boolean | null, wish_planned_as_concept?: boolean | null, volunteer_count?: number | null, availability_entry?: { __typename?: 'AvailabilityEntry', id: string } | null }> };

export type BigCheckQueryVariables = Exact<{
  big: Scalars['String'];
}>;


export type BigCheckQuery = { __typename?: 'Query', bigCheck?: { __typename?: 'Big', registrations: Array<{ __typename?: 'Registration', valid: boolean } | null> } | null };

export type AllAvailableVehiclesQueryVariables = Exact<{
  from: Scalars['Date'];
  to: Scalars['Date'];
}>;


export type AllAvailableVehiclesQuery = { __typename?: 'Query', allAvailableVehicles: Array<{ __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null }> };

export type CalculateDistanceQueryVariables = Exact<{
  fromAddressId: Scalars['ID'];
  toAddressId: Scalars['ID'];
  roundtrip?: InputMaybe<Scalars['Boolean']>;
}>;


export type CalculateDistanceQuery = { __typename?: 'Query', calculateDistance?: { __typename?: 'CalculateDistance', distance?: number | null } | null };

export type ExpenseRelatedWishesQueryVariables = Exact<{
  expenseId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type ExpenseRelatedWishesQuery = { __typename?: 'Query', expenseRelatedWishes: Array<{ __typename?: 'Wish', id: string, wish_date?: string | null, end_date?: string | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, bank_card_number?: number | null } | null }> };

export type ExpenseRelatedWishQueryVariables = Exact<{
  wishId: Scalars['ID'];
}>;


export type ExpenseRelatedWishQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', id: string, wish_date?: string | null, end_date?: string | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null } | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, bank_card_number?: number | null } | null } | null };

export type ExpenseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExpenseQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null } };

export type ExpensesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  wishId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ExpenseType>;
  status?: InputMaybe<ExpenseStatus>;
  transaction_at?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  only_unlinked?: InputMaybe<Scalars['Boolean']>;
  column: QueryExpensesOrderByColumn;
  order: SortOrder;
}>;


export type ExpensesQuery = { __typename?: 'Query', expenses: { __typename?: 'ExpensePaginator', data: Array<{ __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type ExportExpensesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExportExpensesQuery = { __typename?: 'Query', exportExpenses: string };

export type ExportMileagesQueryVariables = Exact<{
  vehicleId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type ExportMileagesQuery = { __typename?: 'Query', exportMileages: string };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, uuid: string, type?: NotificationType | null, data?: any | null, read_at?: string | null, created_at?: string | null }> };

export type MileagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  wishId?: InputMaybe<Scalars['ID']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  created_at?: InputMaybe<Scalars['Date']>;
  column: QueryMileagesOrderByColumn;
  order: SortOrder;
}>;


export type MileagesQuery = { __typename?: 'Query', mileages: { __typename?: 'MileagePaginator', data: Array<{ __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type OfficeQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficeQuery = { __typename?: 'Query', office?: { __typename?: 'Address', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type PlannableWishesQueryVariables = Exact<{
  input: PlannableWishesInput;
}>;


export type PlannableWishesQuery = { __typename?: 'Query', plannableWishes: Array<{ __typename?: 'Wish', id: string, vehicle_id?: string | null, wish_date?: string | null, end_date?: string | null, preferred_wish_date?: string | null, status: Status, planning_status?: PlanningStatus | null, people_going: number, wish_description?: string | null, patient?: { __typename?: 'Contact', full_name?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null }> };

export type PhotosQueryVariables = Exact<{
  wish_id: Scalars['ID'];
}>;


export type PhotosQuery = { __typename?: 'Query', photos: Array<{ __typename?: 'Photo', uuid: string, name: string, src: string, placeholder?: string | null, download_url: string, srcset: Array<{ __typename?: 'SrcsetItem', width: number, src: string }>, metadata: { __typename?: 'PhotoMetadata', size?: number | null, mime_type?: string | null } }> };

export type PlanningVolunteersQueryVariables = Exact<{
  wishId?: InputMaybe<Scalars['ID']>;
  vehicleId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  column: QueryPlanningVolunteersOrderByColumn;
  order: SortOrder;
  startDate: Scalars['Date'];
  endDate?: InputMaybe<Scalars['Date']>;
  showAvailable?: InputMaybe<Scalars['Boolean']>;
  specializations?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<RoleName>> | InputMaybe<RoleName>>;
}>;


export type PlanningVolunteersQuery = { __typename?: 'Query', planningVolunteers: { __typename?: 'PlanningVolunteerPaginator', data: Array<{ __typename?: 'PlanningVolunteer', id: string, full_name?: string | null, phone_number?: string | null, roles: Array<RoleName>, active_since?: string | null, score?: number | null, addresses?: Array<{ __typename?: 'UserAddress', city?: string | null }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type MediaQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  column: QueryMediaOrderByColumn;
  order: SortOrder;
  search?: InputMaybe<Scalars['String']>;
  file_category?: InputMaybe<FileCategory>;
  updated_at?: InputMaybe<Scalars['Date']>;
}>;


export type MediaQuery = { __typename?: 'Query', media: { __typename?: 'MediaPaginator', data: Array<{ __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type PostalCodeCheckQueryVariables = Exact<{
  postalCode: Scalars['String'];
  number: Scalars['String'];
}>;


export type PostalCodeCheckQuery = { __typename?: 'Query', postalCodeCheck?: { __typename?: 'PostalCodeCheck', zipcode: string, street?: string | null, streetNumber?: string | null, city?: string | null, municipality?: string | null, town?: string | null, province?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type PlannableWishQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type PlannableWishQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_date?: string | null, wish_description?: string | null, subject?: string | null, end_date?: string | null, planning_status?: PlanningStatus | null, people_going: number, patient?: { __typename?: 'Contact', full_name?: string | null, date_of_birth?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null, mailCustomizations?: Array<{ __typename?: 'MailCustomization', id: string, customization_type: MailCustomizationType, content: string }> | null } | null };

export type ReservationsQueryVariables = Exact<{
  start_date: Scalars['Date'];
  end_date?: InputMaybe<Scalars['Date']>;
}>;


export type ReservationsQuery = { __typename?: 'Query', reservations: Array<{ __typename?: 'Reservation', id: string, start_date: string, end_date?: string | null, description?: string | null, vehicle_id?: string | null, deleted_at?: string | null }> };

export type SimilarWishesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SimilarWishesQuery = { __typename?: 'Query', similarWishes: Array<{ __typename?: 'Wish', id: string, patient?: { __typename?: 'Contact', full_name?: string | null } | null }> };

export type ReservationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, start_date: string, end_date?: string | null, description?: string | null, vehicle_id?: string | null, deleted_at?: string | null } | null };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', bank_account_holder?: string | null, bank_account_number?: string | null, emergency_contact_name?: string | null, emergency_contact_phone_number?: string | null, big_number?: string | null, big_expires?: string | null, has_diploma?: boolean | null, diploma_type?: string | null, graduation_year?: number | null, driver_license_expires?: string | null, driver_license_types: Array<DriverLicenseType>, vog_issued_at?: string | null, vog_identifier?: number | null, profession?: string | null, preserve_name?: boolean | null, travel_allowance?: boolean | null, reserved_procedures?: Array<ReservedProcedures> | null, deletable?: boolean | null, id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, activities?: Array<{ __typename?: 'Activity', id: string, log_name?: string | null, description?: string | null, subject_type?: string | null, subject_id?: string | null, causer_type?: string | null, causer_id?: string | null, event?: string | null, properties?: any | null, batch_uuid?: string | null, created_at?: string | null, updated_at?: string | null, causer?: { __typename?: 'User', id: string, full_name: string } | null, subject?: { __typename?: 'Mail', id: string, notification?: string | null, subject?: string | null, status?: MailStatus | null, created_at?: string | null, updated_at?: string | null, preview_url?: string | null, notifiable?: { __typename?: 'User', id: string, full_name: string } | { __typename?: 'Contact', id: string, persona?: string | null } | null } | { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> } | { __typename?: 'GenericModel', model?: string | null, data?: any | null } | null }> | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type UserAddressesQueryVariables = Exact<{
  user_id: Scalars['ID'];
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type UserAddressesQuery = { __typename?: 'Query', userAddresses: { __typename?: 'UserAddressPaginator', data: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type UserAddressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserAddressQuery = { __typename?: 'Query', userAddress?: { __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country } | null };

export type UserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQuery = { __typename?: 'Query', userDetails?: { __typename?: 'UserDetails', bank_account_holder?: string | null, bank_account_number?: string | null, emergency_contact_name?: string | null, emergency_contact_phone_number?: string | null, big_number?: string | null, big_expires?: string | null, has_diploma?: boolean | null, diploma_type?: string | null, graduation_year?: number | null, driver_license_expires?: string | null, driver_license_types: Array<DriverLicenseType>, vog_issued_at?: string | null, vog_identifier?: number | null, preserve_name?: boolean | null, profession?: string | null, reserved_procedures: Array<ReservedProcedures>, active_since?: string | null, addresses: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> } | null };

export type UserWithActivationTokenQueryVariables = Exact<{
  input?: InputMaybe<ActivationTokenInput>;
}>;


export type UserWithActivationTokenQuery = { __typename?: 'Query', userWithActivationToken: { __typename?: 'User', id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } };

export type ValidateWishDateQueryVariables = Exact<{
  input: ValidateWishDateInput;
}>;


export type ValidateWishDateQuery = { __typename?: 'Query', validateWishDate: { __typename?: 'WishDateValidationResponse', valid: boolean, message?: string | null } };

export type VehicleQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type VehicleQuery = { __typename?: 'Query', vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null };

export type VehicleAvailabilityEntriesQueryVariables = Exact<{
  vehicle_id: Scalars['ID'];
  from: Scalars['Date'];
  to: Scalars['Date'];
}>;


export type VehicleAvailabilityEntriesQuery = { __typename?: 'Query', vehicleAvailabilityEntries: Array<{ __typename?: 'VehicleAvailabilityEntryData', date: string, unavailable: boolean, blocked: boolean, wish_planned: boolean, wish_draft_planned: boolean, reservation_planned: boolean, unavailability_entry?: { __typename?: 'VehicleAvailabilityEntry', id: string, reason?: string | null } | null }> };

export type UsersQueryVariables = Exact<{
  trashed?: InputMaybe<Trashed>;
  page?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  column: QueryUsersOrderByColumn;
  order: SortOrder;
  search?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  filesDelivered?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<UserStatus>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', deleted_at?: string | null, id: string, status?: UserStatus | null, full_name: string, first_name: string, last_name_prefix?: string | null, last_name: string, email: string, roles: Array<RoleName>, permissions: Array<PermissionName>, date_of_birth?: string | null, avatar_url?: string | null, phone_number?: string | null, activated?: boolean | null, activated_at?: string | null, active_since?: string | null, completed?: boolean | null, completed_at?: string | null, files_delivered?: boolean | null, files_delivered_at?: string | null, created_at?: string | null, updated_at?: string | null, declaration_of_conduct?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, drivers_license?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, degree?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null, addresses?: Array<{ __typename?: 'UserAddress', address_id: string, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type VehicleAvailabilityEntriesWishesCountQueryVariables = Exact<{
  date: Scalars['Date'];
  vehicle_id: Scalars['ID'];
}>;


export type VehicleAvailabilityEntriesWishesCountQuery = { __typename?: 'Query', vehicleAvailabilityEntriesWishesCount: Array<{ __typename?: 'VehicleAvailabilityCountRecord', date: string, wishes_count: number }> };

export type WishLocationsQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type WishLocationsQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', locations?: Array<{ __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null };

export type VehiclesQueryVariables = Exact<{
  trashed?: InputMaybe<Trashed>;
}>;


export type VehiclesQuery = { __typename?: 'Query', vehicles: Array<{ __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null }> };

export type WishNotesQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type WishNotesQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', notes?: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> }> | null } | null };

export type WishPlanningConfirmationExtraInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type WishPlanningConfirmationExtraInformationQuery = { __typename?: 'Query', wishPlanningConfirmationExtraInformation: string };

export type WishFilesQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type WishFilesQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', media?: Array<{ __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null }> | null } | null };

export type WishRequestQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type WishRequestQuery = { __typename?: 'Query', wishRequest?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, contacts?: Array<{ __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null }> | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null };

export type NotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCreatedSubscription = { __typename?: 'Subscription', notificationCreated?: { __typename?: 'Notification', id: string, uuid: string, type?: NotificationType | null, data?: any | null, read_at?: string | null, created_at?: string | null } | null };

export type WishesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  column: QueryWishesOrderByColumn;
  order: SortOrder;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  created_at?: InputMaybe<Scalars['Date']>;
  wish_date?: InputMaybe<Scalars['Date']>;
  user_id?: InputMaybe<Scalars['ID']>;
}>;


export type WishesQuery = { __typename?: 'Query', wishes: { __typename?: 'WishPaginator', data: Array<{ __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, users?: Array<{ __typename?: 'User', id: string, full_name: string }> | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number } } };

export type WishQueryVariables = Exact<{
  id: Scalars['ID'];
  trashed?: InputMaybe<Trashed>;
}>;


export type WishQuery = { __typename?: 'Query', wish?: { __typename?: 'Wish', additional_information?: string | null, referral_information?: string | null, previously_wish_requested?: boolean | null, wish_requested_at_other_organization?: boolean | null, organization_wish_requested_at?: string | null, wish_needs_ambulance?: boolean | null, expenses_sum?: number | null, id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null, id: string, body_weight?: number | null, medical_condition_and_life_expectancy?: string | null, covid_positive?: boolean | null, location_covid_positive?: boolean | null, resuscitate?: boolean | null, resuscitate_statement?: boolean | null, mobility_status?: Mobility | null, mobility_status_divergent?: string | null } | null, contacts?: Array<{ __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null }> | null, users?: Array<{ __typename?: 'User', id: string, full_name: string }> | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, checklist_block_wish?: Array<{ __typename?: 'ChecklistBlockWish', id: string, custom_block_name: string, checklistBlock: { __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null }> }, answers?: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> | null }> | null, notes?: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> }> | null, locations?: Array<{ __typename?: 'WishAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null, media?: Array<{ __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null }> | null, mileage?: { __typename?: 'Mileage', id: string, mileage_start?: number | null, mileage_end?: number | null, distance_traveled?: number | null, date?: string | null, reference?: MileageReference | null, created_at?: string | null, updated_at?: string | null, vehicle?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null, wish?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_description?: string | null, subject?: string | null, wish_date?: string | null, end_date?: string | null, status: Status, planning_status?: PlanningStatus | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, medical_information?: { __typename?: 'MedicalInformation', medical_supplies?: string | null } | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null } | null, activities?: Array<{ __typename?: 'Activity', id: string, log_name?: string | null, description?: string | null, subject_type?: string | null, subject_id?: string | null, causer_type?: string | null, causer_id?: string | null, event?: string | null, properties?: any | null, batch_uuid?: string | null, created_at?: string | null, updated_at?: string | null, causer?: { __typename?: 'User', id: string, full_name: string } | null, subject?: { __typename?: 'Mail', id: string, notification?: string | null, subject?: string | null, status?: MailStatus | null, created_at?: string | null, updated_at?: string | null, preview_url?: string | null, notifiable?: { __typename?: 'User', id: string, full_name: string } | { __typename?: 'Contact', id: string, persona?: string | null } | null } | { __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, content: string, event_type: NoteEventType, event_data?: any | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, user?: { __typename?: 'User', id: string, full_name: string, avatar_url?: string | null } | null }> } | { __typename?: 'GenericModel', model?: string | null, data?: any | null } | null }> | null, patient?: { __typename?: 'Contact', id: string, full_name?: string | null, first_name?: string | null, insertion?: string | null, last_name?: string | null, date_of_birth?: string | null, gender?: Gender | null, persona?: string | null, email?: string | null, phone_number?: string | null, contact_type?: ContactType | null, receives_mail?: boolean | null, relationship?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', address_id: string, floor?: number | null, elevator_available?: boolean | null, stretcher_accessible?: boolean | null, comment?: string | null, departure_at?: string | null, arrival_at?: string | null, id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country }> | null } | null } | null };

export type NotificationDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationDeletedSubscription = { __typename?: 'Subscription', notificationDeleted?: { __typename?: 'Notification', id: string, uuid: string, type?: NotificationType | null, data?: any | null, read_at?: string | null, created_at?: string | null } | null };

export type NotificationUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationUpdatedSubscription = { __typename?: 'Subscription', notificationUpdated?: { __typename?: 'Notification', id: string, uuid: string, type?: NotificationType | null, data?: any | null, read_at?: string | null, created_at?: string | null } | null };

export type PlanableWishesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PlanableWishesUpdatedSubscription = { __typename?: 'Subscription', wishesUpdated?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, wish_date?: string | null, end_date?: string | null, preferred_wish_date?: string | null, status: Status, planning_status?: PlanningStatus | null, people_going: number, wish_description?: string | null, patient?: { __typename?: 'Contact', full_name?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null } | null };

export type ReservationUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReservationUpdatedSubscription = { __typename?: 'Subscription', reservationUpdated?: { __typename?: 'Reservation', id: string, start_date: string, end_date?: string | null, description?: string | null, vehicle_id?: string | null, deleted_at?: string | null } | null };

export type ReservationsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ReservationsUpdatedSubscription = { __typename?: 'Subscription', reservationsUpdated?: { __typename?: 'Reservation', id: string, start_date: string, end_date?: string | null, description?: string | null, vehicle_id?: string | null, deleted_at?: string | null } | null };

export type PlannableWishUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlannableWishUpdatedSubscription = { __typename?: 'Subscription', wishUpdated?: { __typename?: 'Wish', id: string, vehicle_id?: string | null, preferred_wish_date?: string | null, wish_date?: string | null, wish_description?: string | null, subject?: string | null, end_date?: string | null, planning_status?: PlanningStatus | null, people_going: number, patient?: { __typename?: 'Contact', full_name?: string | null, date_of_birth?: string | null, addresses?: Array<{ __typename?: 'ContactAddress', city?: string | null, departure_at?: string | null, arrival_at?: string | null }> | null } | null, locations?: Array<{ __typename?: 'WishAddress', city?: string | null }> | null, user_wish?: Array<{ __typename?: 'UserWish', confirmed: boolean, user: { __typename?: 'User', id: string, full_name: string, roles: Array<RoleName> } }> | null, mailCustomizations?: Array<{ __typename?: 'MailCustomization', id: string, customization_type: MailCustomizationType, content: string }> | null } | null };

export type ExactConfigFragmentFragment = { __typename?: 'ExactConfig', enabled?: boolean | null, default_division?: string | null, default_journals: Array<{ __typename?: 'ExactJournalTypeValue', type: string, id: string }>, default_general_ledger_accounts: Array<{ __typename?: 'ExactGeneralLedgerAccountTypeValue', type: string, id: string }> };

export type WishUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WishUpdatedSubscription = { __typename?: 'Subscription', wishUpdated?: { __typename?: 'Wish', id: string } | null };

export type VehiclesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type VehiclesUpdatedSubscription = { __typename?: 'Subscription', vehiclesUpdated?: { __typename?: 'Vehicle', id: string, vehicle_number?: number | null, licence_plate?: string | null, model?: string | null, mileage?: number | null, bank_pincode?: string | null, fuel_pincode?: string | null, inactive?: boolean | null, created_at?: string | null, updated_at?: string | null, deleted_at?: string | null, availability_entries?: Array<{ __typename?: 'VehicleAvailabilityEntry', id: string, unavailable_on: string, reason?: string | null }> | null } | null };

export type CreateAvailabilityEntryMutationVariables = Exact<{
  user_id: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type CreateAvailabilityEntryMutation = { __typename?: 'Mutation', createAvailabilityEntry: { __typename?: 'AvailabilityEntry', id: string, date: string } };

export type DeleteAvailabilityEntryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAvailabilityEntryMutation = { __typename?: 'Mutation', deleteAvailabilityEntry: { __typename?: 'AvailabilityEntry', id: string, date: string } };

export type CreateChecklistBlockWishMutationVariables = Exact<{
  checklist_block_id: Scalars['ID'];
  wish_id: Scalars['ID'];
  custom_block_name: Scalars['String'];
}>;


export type CreateChecklistBlockWishMutation = { __typename?: 'Mutation', createChecklistBlockWish: { __typename?: 'ChecklistBlockWish', id: string, custom_block_name: string, checklistBlock: { __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null }> }, answers?: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> | null } };

export type SaveChecklistAnswersMutationVariables = Exact<{
  checklist_id: Scalars['ID'];
  wish_id: Scalars['ID'];
  input: Array<AnswersInput> | AnswersInput;
}>;


export type SaveChecklistAnswersMutation = { __typename?: 'Mutation', saveChecklistAnswers: { __typename?: 'Checklist', id: string, name: string, status: ChecklistStatus, description?: string | null, blocks: Array<{ __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null, answers: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> }> }> } };

export type DeleteChecklistBlockWishMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteChecklistBlockWishMutation = { __typename?: 'Mutation', deleteChecklistBlockWish: { __typename?: 'DeleteChecklistBlockWishResponse', success: boolean } };

export type ExactUpdateConfigMutationVariables = Exact<{
  input: ExactConfigInput;
}>;


export type ExactUpdateConfigMutation = { __typename?: 'Mutation', exactUpdateConfig?: { __typename?: 'ExactConfig', enabled?: boolean | null, default_division?: string | null, default_journals: Array<{ __typename?: 'ExactJournalTypeValue', type: string, id: string }>, default_general_ledger_accounts: Array<{ __typename?: 'ExactGeneralLedgerAccountTypeValue', type: string, id: string }> } | null };

export type ApproveExpensesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ApproveExpensesMutation = { __typename?: 'Mutation', approveExpenses: Array<{ __typename?: 'Expense', id: string }> };

export type CreateExpenseMutationVariables = Exact<{
  input: ExpenseCreateInput;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null } };

export type RelinkExpenseMutationVariables = Exact<{
  id: Scalars['ID'];
  wish_id?: InputMaybe<Scalars['ID']>;
}>;


export type RelinkExpenseMutation = { __typename?: 'Mutation', relinkExpense: { __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null } };

export type UpdateExpenseMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ExpenseUpdateInput;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, wish_id?: string | null, description?: string | null, amount?: number | null, type?: ExpenseType | null, status?: ExpenseStatus | null, transaction_at?: string | null, updated_at?: string | null, wish?: { __typename?: 'Wish', id: string, status: Status, patient?: { __typename?: 'Contact', persona?: string | null } | null } | null, submitted_by?: { __typename?: 'User', id: string, full_name: string } | null, payout_to?: { __typename?: 'User', id: string, full_name: string } | null, metadata?: { __typename?: 'MetaData', from_address_id?: string | null, to_address_id?: string | null, travel_allowance_rate?: number | null, distance?: number | null, roundtrip?: boolean | null, readonly?: boolean | null, bank_card_number?: number | null, exact?: boolean | null } | null, attachment?: { __typename?: 'Media', id: string, attachable: boolean, collection_name: string, disk: string, name: string, description?: string | null, file_name: string, mime_type?: string | null, size: number, url: string, created_at?: string | null, updated_at?: string | null, custom_properties?: any | null } | null } };

export type SaveWishPlanningConfirmationExtraInformationMutationVariables = Exact<{
  wishId: Scalars['ID'];
  content: Scalars['String'];
}>;


export type SaveWishPlanningConfirmationExtraInformationMutation = { __typename?: 'Mutation', saveWishPlanningConfirmationExtraInformation: boolean };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: Array<{ __typename?: 'Expense', id: string }> };

export type AttachMediaToWishMutationVariables = Exact<{
  wish_id: Scalars['ID'];
  media_id: Scalars['ID'];
}>;


export type AttachMediaToWishMutation = { __typename?: 'Mutation', attachMediaToWish?: { __typename?: 'SimpleStatus', status?: string | null } | null };

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMediaMutation = { __typename?: 'Mutation', deleteMedia?: { __typename?: 'Media', id: string } | null };

export type DetachMediaFromWishMutationVariables = Exact<{
  wish_id: Scalars['ID'];
  media_id: Scalars['ID'];
}>;


export type DetachMediaFromWishMutation = { __typename?: 'Mutation', detachMediaFromWish?: { __typename?: 'SimpleStatus', status?: string | null } | null };

export type ChecklistQueryVariables = Exact<{
  id: Scalars['ID'];
  wish_id: Scalars['ID'];
}>;


export type ChecklistQuery = { __typename?: 'Query', checklist: { __typename?: 'Checklist', id: string, name: string, status: ChecklistStatus, description?: string | null, blocks: Array<{ __typename?: 'ChecklistBlock', id: string, checklist_id: string, name: string, description?: string | null, can_duplicate?: boolean | null, questions: Array<{ __typename?: 'ChecklistQuestion', id: string, checklist_id: string, checklist_block_id: string, parent_id?: string | null, question: string, description?: string | null, answer_type: ChecklistAnswerType, required: boolean, custom_options?: any | null, answers: Array<{ __typename?: 'ChecklistAnswer', id: string, wish_id: string, checklist_id: string, checklist_block_id: string, checklist_question_id: string, checklist_block_wish_id?: string | null, answer: any, sequence: number }> }> }> } };

export type ChecklistsQueryVariables = Exact<{
  wish_id: Scalars['ID'];
}>;


export type ChecklistsQuery = { __typename?: 'Query', checklists: Array<{ __typename?: 'Checklist', id: string, name: string, status: ChecklistStatus, description?: string | null }> };

export type UploadMediaMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  file?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UploadMediaMutation = { __typename?: 'Mutation', uploadMedia?: { __typename?: 'Media', id: string } | null };

export type ExactAuthLinkQueryVariables = Exact<{
  redirectUrl?: InputMaybe<Scalars['String']>;
}>;


export type ExactAuthLinkQuery = { __typename?: 'Query', exactAuthLink?: string | null };

export type ExactAuthenticatedQueryVariables = Exact<{ [key: string]: never; }>;


export type ExactAuthenticatedQuery = { __typename?: 'Query', exactAuthenticated: boolean };

export type ExactConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ExactConfigQuery = { __typename?: 'Query', exactConfig: { __typename?: 'ExactConfig', enabled?: boolean | null, default_division?: string | null, default_journals: Array<{ __typename?: 'ExactJournalTypeValue', type: string, id: string }>, default_general_ledger_accounts: Array<{ __typename?: 'ExactGeneralLedgerAccountTypeValue', type: string, id: string }> } };

export type MapsPlaceAutocompleteQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type MapsPlaceAutocompleteQuery = { __typename?: 'Query', mapsPlaceAutocomplete: Array<{ __typename?: 'PlaceAutocompleteResult', name: string, address: string, description: string, place_id: string }> };

export type ExactDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExactDivisionsQuery = { __typename?: 'Query', exactDivisions: Array<{ __typename?: 'ExactDivision', id: string, code?: number | null, description?: string | null, default?: boolean | null, journals: Array<{ __typename?: 'ExactJournal', id: string, uuid?: string | null, code?: string | null, description?: string | null }>, general_ledger_accounts: Array<{ __typename?: 'ExactGeneralLedgerAccount', id: string, uuid?: string | null, code?: string | null, description?: string | null }> }> };

export type MapsPlaceDetailsQueryVariables = Exact<{
  placeId: Scalars['String'];
}>;


export type MapsPlaceDetailsQuery = { __typename?: 'Query', mapsPlaceDetails?: { __typename?: 'Address', id: string, name?: string | null, street?: string | null, number?: string | null, number_addition?: string | null, postal_code?: string | null, city?: string | null, country: Country, place_id?: string | null, created_at?: string | null, updated_at?: string | null } | null };

export type DeletePhotosMutationVariables = Exact<{
  wish_id: Scalars['ID'];
  photo_uuids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeletePhotosMutation = { __typename?: 'Mutation', deletePhotos: boolean };

export type UploadPhotosMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  wish_id: Scalars['ID'];
}>;


export type UploadPhotosMutation = { __typename?: 'Mutation', uploadPhotos: Array<{ __typename?: 'Photo', uuid: string, name: string, src: string, placeholder?: string | null, download_url: string, srcset: Array<{ __typename?: 'SrcsetItem', width: number, src: string }>, metadata: { __typename?: 'PhotoMetadata', size?: number | null, mime_type?: string | null } }> };

export type ExportPhotosQueryVariables = Exact<{
  wish_id: Scalars['ID'];
  photo_uuids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ExportPhotosQuery = { __typename?: 'Query', exportPhotos: string };

export const MediaFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MediaFragment on Media {
  id
  attachable
  collection_name
  disk
  name
  description
  file_name
  mime_type
  size
  url
  created_at
  updated_at
  custom_properties
}
    `;
export const ExpenseFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ExpenseFragment on Expense {
  id
  wish_id
  wish {
    id
    status
    patient {
      persona
    }
  }
  submitted_by {
    id
    full_name
  }
  payout_to {
    id
    full_name
  }
  description
  amount
  type
  status
  metadata {
    from_address_id
    to_address_id
    travel_allowance_rate
    distance
    roundtrip
    readonly
    bank_card_number
    exact
  }
  attachment {
    ...MediaFragment
  }
  transaction_at
  updated_at
}
    ${MediaFragmentFragmentDoc}`;
export const SimpleChecklistFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment SimpleChecklistFragment on Checklist {
  id
  name
  status
  description
}
    `;
export const ChecklistBlockFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ChecklistBlockFragment on ChecklistBlock {
  id
  checklist_id
  name
  description
  can_duplicate
}
    `;
export const ChecklistQuestionFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ChecklistQuestionFragment on ChecklistQuestion {
  id
  checklist_id
  checklist_block_id
  parent_id
  question
  description
  answer_type
  required
  custom_options
}
    `;
export const ChecklistAnswerFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ChecklistAnswerFragment on ChecklistAnswer {
  id
  wish_id
  checklist_id
  checklist_block_id
  checklist_question_id
  checklist_block_wish_id
  answer
  sequence
}
    `;
export const ChecklistFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ChecklistFragment on Checklist {
  ...SimpleChecklistFragment
  blocks {
    ...ChecklistBlockFragment
    questions {
      ...ChecklistQuestionFragment
      answers {
        ...ChecklistAnswerFragment
      }
    }
  }
}
    ${SimpleChecklistFragmentFragmentDoc}
${ChecklistBlockFragmentFragmentDoc}
${ChecklistQuestionFragmentFragmentDoc}
${ChecklistAnswerFragmentFragmentDoc}`;
export const ExpenseRelatedWishFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ExpenseRelatedWishFragment on Wish {
  id
  wish_date
  end_date
  patient {
    id
    full_name
  }
  vehicle {
    id
    vehicle_number
    bank_card_number
  }
}
    `;
export const PhotoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PhotoFragment on Photo {
  uuid
  name
  src
  srcset {
    width
    src
  }
  placeholder
  download_url
  metadata {
    size
    mime_type
  }
}
    `;
export const PlanableWishesFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PlanableWishesFragment on Wish {
  id
  vehicle_id
  wish_date
  end_date
  preferred_wish_date
  status
  planning_status
  people_going
  wish_description
  patient {
    full_name
    addresses {
      city
      departure_at
      arrival_at
    }
  }
  locations {
    city
  }
  user_wish {
    user {
      id
      full_name
      roles
    }
    confirmed
  }
}
    `;
export const NotificationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NotificationFragment on Notification {
  id
  uuid
  type
  data
  read_at
  created_at
}
    `;
export const PlannableVolunteerFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PlannableVolunteerFragment on PlanningVolunteer {
  id
  full_name
  phone_number
  addresses {
    city
  }
  roles
  active_since
  score
}
    `;
export const PlannableWishFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment PlannableWishFragment on Wish {
  id
  vehicle_id
  preferred_wish_date
  wish_date
  wish_description
  subject
  end_date
  planning_status
  people_going
  patient {
    full_name
    date_of_birth
    addresses {
      city
      departure_at
      arrival_at
    }
  }
  locations {
    city
  }
  user_wish {
    user {
      id
      full_name
      roles
    }
    confirmed
  }
  mailCustomizations {
    id
    customization_type
    content
  }
}
    `;
export const ReservationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ReservationFragment on Reservation {
  id
  start_date
  end_date
  description
  vehicle_id
  deleted_at
}
    `;
export const AddressFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment AddressFragment on AddressInterface {
  id
  name
  street
  number
  number_addition
  postal_code
  city
  country
}
    `;
export const UserAddressFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserAddressFragment on UserAddress {
  ...AddressFragment
  address_id
}
    ${AddressFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserFragment on User {
  id
  status
  full_name
  first_name
  last_name_prefix
  last_name
  email
  roles
  permissions
  date_of_birth
  avatar_url
  declaration_of_conduct {
    ...MediaFragment
  }
  drivers_license {
    ...MediaFragment
  }
  degree {
    ...MediaFragment
  }
  phone_number
  activated
  activated_at
  active_since
  completed
  completed_at
  files_delivered
  files_delivered_at
  addresses {
    ...UserAddressFragment
  }
  created_at
  updated_at
  deleted_at
}
    ${MediaFragmentFragmentDoc}
${UserAddressFragmentFragmentDoc}`;
export const UserDetailsFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserDetailsFragment on UserDetails {
  bank_account_holder
  bank_account_number
  emergency_contact_name
  emergency_contact_phone_number
  big_number
  big_expires
  has_diploma
  diploma_type
  graduation_year
  driver_license_expires
  driver_license_types
  vog_issued_at
  vog_identifier
  preserve_name
  profession
  addresses {
    ...UserAddressFragment
  }
  reserved_procedures
  active_since
}
    ${UserAddressFragmentFragmentDoc}`;
export const ContactAddressFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ContactAddressFragment on ContactAddress {
  ...AddressFragment
  address_id
  floor
  elevator_available
  stretcher_accessible
  comment
  departure_at
  arrival_at
}
    ${AddressFragmentFragmentDoc}`;
export const ContactFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ContactFragment on Contact {
  id
  full_name
  first_name
  insertion
  last_name
  date_of_birth
  gender
  persona
  email
  phone_number
  contact_type
  receives_mail
  relationship
  addresses {
    ...ContactAddressFragment
  }
}
    ${ContactAddressFragmentFragmentDoc}`;
export const WishFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WishFragment on Wish {
  id
  vehicle_id
  preferred_wish_date
  wish_description
  subject
  wish_date
  end_date
  status
  planning_status
  medical_information {
    medical_supplies
  }
  created_at
  updated_at
  deleted_at
  patient {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;
export const MedicalInformationFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MedicalInformationFragment on MedicalInformation {
  id
  body_weight
  medical_condition_and_life_expectancy
  covid_positive
  location_covid_positive
  medical_supplies
  resuscitate
  resuscitate_statement
  mobility_status
  mobility_status_divergent
}
    `;
export const VehicleFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment VehicleFragment on Vehicle {
  id
  vehicle_number
  licence_plate
  model
  mileage
  bank_pincode
  fuel_pincode
  inactive
  availability_entries {
    id
    unavailable_on
    reason
  }
  created_at
  updated_at
  deleted_at
}
    `;
export const ChecklistBlockWishFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ChecklistBlockWishFragment on ChecklistBlockWish {
  id
  checklistBlock {
    ...ChecklistBlockFragment
    questions {
      ...ChecklistQuestionFragment
    }
  }
  custom_block_name
  answers {
    ...ChecklistAnswerFragment
  }
}
    ${ChecklistBlockFragmentFragmentDoc}
${ChecklistQuestionFragmentFragmentDoc}
${ChecklistAnswerFragmentFragmentDoc}`;
export const NoteFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NoteFragment on Note {
  id
  content
  event_type
  event_data
  created_at
  updated_at
  deleted_at
  user {
    id
    full_name
    avatar_url
  }
  notes {
    id
    content
    event_type
    event_data
    created_at
    updated_at
    deleted_at
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const WishAddressFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WishAddressFragment on WishAddress {
  ...AddressFragment
  address_id
  floor
  elevator_available
  stretcher_accessible
  comment
  departure_at
  arrival_at
}
    ${AddressFragmentFragmentDoc}`;
export const MileageFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MileageFragment on Mileage {
  id
  mileage_start
  mileage_end
  distance_traveled
  vehicle {
    ...VehicleFragment
  }
  wish {
    ...WishFragment
  }
  date
  reference
  created_at
  updated_at
}
    ${VehicleFragmentFragmentDoc}
${WishFragmentFragmentDoc}`;
export const MailFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment MailFragment on Mail {
  id
  notification
  notifiable {
    ... on User {
      id
      full_name
    }
    ... on Contact {
      id
      persona
    }
  }
  subject
  status
  created_at
  updated_at
  preview_url
}
    `;
export const ActivityFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ActivityFragment on Activity {
  id
  log_name
  description
  subject_type
  subject_id
  causer_type
  causer_id
  event
  properties
  batch_uuid
  created_at
  updated_at
  causer {
    id
    full_name
  }
  subject {
    ... on Mail {
      ...MailFragment
    }
    ... on Note {
      ...NoteFragment
    }
    ... on GenericModel {
      model
      data
    }
  }
}
    ${MailFragmentFragmentDoc}
${NoteFragmentFragmentDoc}`;
export const WishDetailFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment WishDetailFragment on Wish {
  ...WishFragment
  medical_information {
    ...MedicalInformationFragment
  }
  contacts {
    ...ContactFragment
  }
  users {
    id
    full_name
  }
  vehicle {
    ...VehicleFragment
  }
  additional_information
  referral_information
  previously_wish_requested
  wish_requested_at_other_organization
  organization_wish_requested_at
  wish_needs_ambulance
  expenses_sum
  checklist_block_wish {
    ...ChecklistBlockWishFragment
  }
  notes {
    ...NoteFragment
  }
  locations {
    ...WishAddressFragment
  }
  media {
    ...MediaFragment
  }
  mileage {
    ...MileageFragment
  }
  activities {
    ...ActivityFragment
  }
}
    ${WishFragmentFragmentDoc}
${MedicalInformationFragmentFragmentDoc}
${ContactFragmentFragmentDoc}
${VehicleFragmentFragmentDoc}
${ChecklistBlockWishFragmentFragmentDoc}
${NoteFragmentFragmentDoc}
${WishAddressFragmentFragmentDoc}
${MediaFragmentFragmentDoc}
${MileageFragmentFragmentDoc}
${ActivityFragmentFragmentDoc}`;
export const ExactConfigFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ExactConfigFragment on ExactConfig {
  enabled
  default_division
  default_journals {
    type
    id
  }
  default_general_ledger_accounts {
    type
    id
  }
}
    `;
export const ActivateUserDocument = /*#__PURE__*/ gql`
    mutation ActivateUser($input: ActivateUserInput) {
  activateUser(input: $input) {
    access_token
    refresh_token
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useActivateUserMutation(options: VueApolloComposable.UseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
}
export type ActivateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActivateUserMutation, ActivateUserMutationVariables>;
export const ArchiveWishDocument = /*#__PURE__*/ gql`
    mutation ArchiveWish($id: ID!) {
  archiveWish(id: $id) {
    id
  }
}
    `;

/**
 * __useArchiveWishMutation__
 *
 * To run a mutation, you first call `useArchiveWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveWishMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useArchiveWishMutation(options: VueApolloComposable.UseMutationOptions<ArchiveWishMutation, ArchiveWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveWishMutation, ArchiveWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ArchiveWishMutation, ArchiveWishMutationVariables>(ArchiveWishDocument, options);
}
export type ArchiveWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchiveWishMutation, ArchiveWishMutationVariables>;
export const ConfirmWishDocument = /*#__PURE__*/ gql`
    mutation ConfirmWish($token: String!) {
  confirmWish(token: $token) {
    success
  }
}
    `;

/**
 * __useConfirmWishMutation__
 *
 * To run a mutation, you first call `useConfirmWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmWishMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useConfirmWishMutation(options: VueApolloComposable.UseMutationOptions<ConfirmWishMutation, ConfirmWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfirmWishMutation, ConfirmWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConfirmWishMutation, ConfirmWishMutationVariables>(ConfirmWishDocument, options);
}
export type ConfirmWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfirmWishMutation, ConfirmWishMutationVariables>;
export const CreateAddressDocument = /*#__PURE__*/ gql`
    mutation CreateAddress($input: CreateAddressInput!) {
  createAddress(input: $input) {
    ...ContactAddressFragment
    ...UserAddressFragment
    ...WishAddressFragment
  }
}
    ${ContactAddressFragmentFragmentDoc}
${UserAddressFragmentFragmentDoc}
${WishAddressFragmentFragmentDoc}`;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAddressMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAddressMutation(options: VueApolloComposable.UseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
}
export type CreateAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAddressMutation, CreateAddressMutationVariables>;
export const CreateMileageDocument = /*#__PURE__*/ gql`
    mutation CreateMileage($input: MileageInput!) {
  createMileage(input: $input) {
    ...MileageFragment
  }
}
    ${MileageFragmentFragmentDoc}`;

/**
 * __useCreateMileageMutation__
 *
 * To run a mutation, you first call `useCreateMileageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMileageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMileageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMileageMutation(options: VueApolloComposable.UseMutationOptions<CreateMileageMutation, CreateMileageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMileageMutation, CreateMileageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMileageMutation, CreateMileageMutationVariables>(CreateMileageDocument, options);
}
export type CreateMileageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMileageMutation, CreateMileageMutationVariables>;
export const CreateMedicalInformationDocument = /*#__PURE__*/ gql`
    mutation CreateMedicalInformation($input: CreateMedicalInformationInput!) {
  createMedicalInformation(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateMedicalInformationMutation__
 *
 * To run a mutation, you first call `useCreateMedicalInformationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicalInformationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMedicalInformationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicalInformationMutation(options: VueApolloComposable.UseMutationOptions<CreateMedicalInformationMutation, CreateMedicalInformationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateMedicalInformationMutation, CreateMedicalInformationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateMedicalInformationMutation, CreateMedicalInformationMutationVariables>(CreateMedicalInformationDocument, options);
}
export type CreateMedicalInformationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateMedicalInformationMutation, CreateMedicalInformationMutationVariables>;
export const CreateNoteDocument = /*#__PURE__*/ gql`
    mutation CreateNote($input: CreateWishNoteInput!) {
  createNote(input: $input) {
    id
    content
    event_type
    event_data
    created_at
    updated_at
    deleted_at
    notes {
      id
      content
      event_type
      event_data
      created_at
      updated_at
      deleted_at
    }
  }
}
    `;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateNoteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(options: VueApolloComposable.UseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
}
export type CreateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateNoteMutation, CreateNoteMutationVariables>;
export const CreateReservationDocument = /*#__PURE__*/ gql`
    mutation CreateReservation($input: ReservationInput!) {
  createReservation(input: $input) {
    id
  }
}
    `;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateReservationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationMutation(options: VueApolloComposable.UseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateReservationMutation, CreateReservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateReservationMutation, CreateReservationMutationVariables>(CreateReservationDocument, options);
}
export type CreateReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateReservationMutation, CreateReservationMutationVariables>;
export const CreateVehicleDocument = /*#__PURE__*/ gql`
    mutation CreateVehicle($input: VehicleInput!) {
  createVehicle(input: $input) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useCreateVehicleMutation__
 *
 * To run a mutation, you first call `useCreateVehicleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVehicleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVehicleMutation(options: VueApolloComposable.UseMutationOptions<CreateVehicleMutation, CreateVehicleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVehicleMutation, CreateVehicleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateVehicleMutation, CreateVehicleMutationVariables>(CreateVehicleDocument, options);
}
export type CreateVehicleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVehicleMutation, CreateVehicleMutationVariables>;
export const CreateUserDocument = /*#__PURE__*/ gql`
    mutation CreateUser($input: UserInput) {
  createUser(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(options: VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserMutation, CreateUserMutationVariables>;
export const CreateVehicleAvailabilityEntryDocument = /*#__PURE__*/ gql`
    mutation CreateVehicleAvailabilityEntry($vehicle_id: ID!, $unavailable_on: Date!) {
  createVehicleAvailabilityEntry(
    vehicle_id: $vehicle_id
    unavailable_on: $unavailable_on
  ) {
    id
    unavailable_on
  }
}
    `;

/**
 * __useCreateVehicleAvailabilityEntryMutation__
 *
 * To run a mutation, you first call `useCreateVehicleAvailabilityEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleAvailabilityEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVehicleAvailabilityEntryMutation({
 *   variables: {
 *     vehicle_id: // value for 'vehicle_id'
 *     unavailable_on: // value for 'unavailable_on'
 *   },
 * });
 */
export function useCreateVehicleAvailabilityEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateVehicleAvailabilityEntryMutation, CreateVehicleAvailabilityEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateVehicleAvailabilityEntryMutation, CreateVehicleAvailabilityEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateVehicleAvailabilityEntryMutation, CreateVehicleAvailabilityEntryMutationVariables>(CreateVehicleAvailabilityEntryDocument, options);
}
export type CreateVehicleAvailabilityEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateVehicleAvailabilityEntryMutation, CreateVehicleAvailabilityEntryMutationVariables>;
export const CreateWishDocument = /*#__PURE__*/ gql`
    mutation CreateWish($input: WishInput!) {
  createWish(input: $input) {
    id
    patient {
      id
    }
  }
}
    `;

/**
 * __useCreateWishMutation__
 *
 * To run a mutation, you first call `useCreateWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWishMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateWishMutation(options: VueApolloComposable.UseMutationOptions<CreateWishMutation, CreateWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWishMutation, CreateWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateWishMutation, CreateWishMutationVariables>(CreateWishDocument, options);
}
export type CreateWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWishMutation, CreateWishMutationVariables>;
export const CreateWishRequestDocument = /*#__PURE__*/ gql`
    mutation CreateWishRequest($input: CreateWishRequestInput!) {
  createWishRequest(input: $input) {
    id
    patient {
      id
    }
  }
}
    `;

/**
 * __useCreateWishRequestMutation__
 *
 * To run a mutation, you first call `useCreateWishRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWishRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWishRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateWishRequestMutation(options: VueApolloComposable.UseMutationOptions<CreateWishRequestMutation, CreateWishRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWishRequestMutation, CreateWishRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateWishRequestMutation, CreateWishRequestMutationVariables>(CreateWishRequestDocument, options);
}
export type CreateWishRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWishRequestMutation, CreateWishRequestMutationVariables>;
export const DeleteAddressDocument = /*#__PURE__*/ gql`
    mutation DeleteAddress($id: ID!, $type: String!) {
  deleteAddress(id: $id, type: $type) {
    ...ContactAddressFragment
    ...UserAddressFragment
    ...WishAddressFragment
  }
}
    ${ContactAddressFragmentFragmentDoc}
${UserAddressFragmentFragmentDoc}
${WishAddressFragmentFragmentDoc}`;

/**
 * __useDeleteAddressMutation__
 *
 * To run a mutation, you first call `useDeleteAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAddressMutation({
 *   variables: {
 *     id: // value for 'id'
 *     type: // value for 'type'
 *   },
 * });
 */
export function useDeleteAddressMutation(options: VueApolloComposable.UseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAddressMutation, DeleteAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(DeleteAddressDocument, options);
}
export type DeleteAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const DeleteMailCustomizationDocument = /*#__PURE__*/ gql`
    mutation DeleteMailCustomization($id: ID!) {
  deleteMailCustomization(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteMailCustomizationMutation__
 *
 * To run a mutation, you first call `useDeleteMailCustomizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailCustomizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMailCustomizationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMailCustomizationMutation(options: VueApolloComposable.UseMutationOptions<DeleteMailCustomizationMutation, DeleteMailCustomizationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMailCustomizationMutation, DeleteMailCustomizationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMailCustomizationMutation, DeleteMailCustomizationMutationVariables>(DeleteMailCustomizationDocument, options);
}
export type DeleteMailCustomizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMailCustomizationMutation, DeleteMailCustomizationMutationVariables>;
export const DeleteVehicleDocument = /*#__PURE__*/ gql`
    mutation DeleteVehicle($id: ID!) {
  deleteVehicle(id: $id) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useDeleteVehicleMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVehicleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleMutation(options: VueApolloComposable.UseMutationOptions<DeleteVehicleMutation, DeleteVehicleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteVehicleMutation, DeleteVehicleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteVehicleMutation, DeleteVehicleMutationVariables>(DeleteVehicleDocument, options);
}
export type DeleteVehicleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteVehicleMutation, DeleteVehicleMutationVariables>;
export const DeleteUserDocument = /*#__PURE__*/ gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(options: VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteReservationDocument = /*#__PURE__*/ gql`
    mutation DeleteReservation($id: ID!) {
  deleteReservation(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteReservationMutation__
 *
 * To run a mutation, you first call `useDeleteReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteReservationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReservationMutation(options: VueApolloComposable.UseMutationOptions<DeleteReservationMutation, DeleteReservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteReservationMutation, DeleteReservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteReservationMutation, DeleteReservationMutationVariables>(DeleteReservationDocument, options);
}
export type DeleteReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteReservationMutation, DeleteReservationMutationVariables>;
export const DeleteVehicleAvailabilityEntryDocument = /*#__PURE__*/ gql`
    mutation DeleteVehicleAvailabilityEntry($id: ID!) {
  deleteVehicleAvailabilityEntry(id: $id) {
    id
    unavailable_on
  }
}
    `;

/**
 * __useDeleteVehicleAvailabilityEntryMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleAvailabilityEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleAvailabilityEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVehicleAvailabilityEntryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleAvailabilityEntryMutation(options: VueApolloComposable.UseMutationOptions<DeleteVehicleAvailabilityEntryMutation, DeleteVehicleAvailabilityEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteVehicleAvailabilityEntryMutation, DeleteVehicleAvailabilityEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteVehicleAvailabilityEntryMutation, DeleteVehicleAvailabilityEntryMutationVariables>(DeleteVehicleAvailabilityEntryDocument, options);
}
export type DeleteVehicleAvailabilityEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteVehicleAvailabilityEntryMutation, DeleteVehicleAvailabilityEntryMutationVariables>;
export const ForgotPasswordDocument = /*#__PURE__*/ gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    status
    message
  }
}
    `;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForgotPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(options: VueApolloComposable.UseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginDocument = /*#__PURE__*/ gql`
    mutation Login($input: LoginInput) {
  login(input: $input) {
    access_token
    refresh_token
    user {
      ...UserFragment
    }
    otp {
      success
      method
      digits
      expiration_time_in_minutes
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LoginMutation, LoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = /*#__PURE__*/ gql`
    mutation Logout {
  logout {
    status
    message
  }
}
    `;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogoutMutation();
 */
export function useLogoutMutation(options: VueApolloComposable.UseMutationOptions<LogoutMutation, LogoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LogoutMutation, LogoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = /*#__PURE__*/ gql`
    mutation RefreshToken($input: RefreshTokenInput) {
  refreshToken(input: $input) {
    access_token
    refresh_token
  }
}
    `;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokenMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(options: VueApolloComposable.UseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
}
export type RefreshTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ResendActivationMailDocument = /*#__PURE__*/ gql`
    mutation ResendActivationMail($id: ID!) {
  resendActivationMail(id: $id) {
    status
  }
}
    `;

/**
 * __useResendActivationMailMutation__
 *
 * To run a mutation, you first call `useResendActivationMailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationMailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendActivationMailMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResendActivationMailMutation(options: VueApolloComposable.UseMutationOptions<ResendActivationMailMutation, ResendActivationMailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendActivationMailMutation, ResendActivationMailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResendActivationMailMutation, ResendActivationMailMutationVariables>(ResendActivationMailDocument, options);
}
export type ResendActivationMailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendActivationMailMutation, ResendActivationMailMutationVariables>;
export const ResendTwoFactorVerificationDocument = /*#__PURE__*/ gql`
    mutation ResendTwoFactorVerification($input: ResendTwoFactorVerificationInput!) {
  resendTwoFactorVerification(input: $input) {
    success
  }
}
    `;

/**
 * __useResendTwoFactorVerificationMutation__
 *
 * To run a mutation, you first call `useResendTwoFactorVerificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendTwoFactorVerificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendTwoFactorVerificationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResendTwoFactorVerificationMutation(options: VueApolloComposable.UseMutationOptions<ResendTwoFactorVerificationMutation, ResendTwoFactorVerificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendTwoFactorVerificationMutation, ResendTwoFactorVerificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResendTwoFactorVerificationMutation, ResendTwoFactorVerificationMutationVariables>(ResendTwoFactorVerificationDocument, options);
}
export type ResendTwoFactorVerificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendTwoFactorVerificationMutation, ResendTwoFactorVerificationMutationVariables>;
export const SetNotificationReadDocument = /*#__PURE__*/ gql`
    mutation SetNotificationRead($input: NotificationActionInput!) {
  setNotificationRead(input: $input) {
    status
    message
  }
}
    `;

/**
 * __useSetNotificationReadMutation__
 *
 * To run a mutation, you first call `useSetNotificationReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationReadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationReadMutation(options: VueApolloComposable.UseMutationOptions<SetNotificationReadMutation, SetNotificationReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetNotificationReadMutation, SetNotificationReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetNotificationReadMutation, SetNotificationReadMutationVariables>(SetNotificationReadDocument, options);
}
export type SetNotificationReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetNotificationReadMutation, SetNotificationReadMutationVariables>;
export const SetNotificationUnreadDocument = /*#__PURE__*/ gql`
    mutation SetNotificationUnread($input: NotificationActionInput!) {
  setNotificationUnread(input: $input) {
    status
    message
  }
}
    `;

/**
 * __useSetNotificationUnreadMutation__
 *
 * To run a mutation, you first call `useSetNotificationUnreadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationUnreadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationUnreadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationUnreadMutation(options: VueApolloComposable.UseMutationOptions<SetNotificationUnreadMutation, SetNotificationUnreadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetNotificationUnreadMutation, SetNotificationUnreadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetNotificationUnreadMutation, SetNotificationUnreadMutationVariables>(SetNotificationUnreadDocument, options);
}
export type SetNotificationUnreadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetNotificationUnreadMutation, SetNotificationUnreadMutationVariables>;
export const SetNotificationDeletedDocument = /*#__PURE__*/ gql`
    mutation SetNotificationDeleted($input: NotificationActionInput!) {
  setNotificationDeleted(input: $input) {
    status
    message
  }
}
    `;

/**
 * __useSetNotificationDeletedMutation__
 *
 * To run a mutation, you first call `useSetNotificationDeletedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationDeletedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetNotificationDeletedMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationDeletedMutation(options: VueApolloComposable.UseMutationOptions<SetNotificationDeletedMutation, SetNotificationDeletedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetNotificationDeletedMutation, SetNotificationDeletedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetNotificationDeletedMutation, SetNotificationDeletedMutationVariables>(SetNotificationDeletedDocument, options);
}
export type SetNotificationDeletedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetNotificationDeletedMutation, SetNotificationDeletedMutationVariables>;
export const RestoreVehicleDocument = /*#__PURE__*/ gql`
    mutation RestoreVehicle($id: ID!) {
  restoreVehicle(id: $id) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useRestoreVehicleMutation__
 *
 * To run a mutation, you first call `useRestoreVehicleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreVehicleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreVehicleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRestoreVehicleMutation(options: VueApolloComposable.UseMutationOptions<RestoreVehicleMutation, RestoreVehicleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RestoreVehicleMutation, RestoreVehicleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RestoreVehicleMutation, RestoreVehicleMutationVariables>(RestoreVehicleDocument, options);
}
export type RestoreVehicleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RestoreVehicleMutation, RestoreVehicleMutationVariables>;
export const ImportUsersDocument = /*#__PURE__*/ gql`
    mutation ImportUsers($input: ImportUsersInput) {
  importUsers(input: $input) {
    success
  }
}
    `;

/**
 * __useImportUsersMutation__
 *
 * To run a mutation, you first call `useImportUsersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportUsersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportUsersMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useImportUsersMutation(options: VueApolloComposable.UseMutationOptions<ImportUsersMutation, ImportUsersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportUsersMutation, ImportUsersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ImportUsersMutation, ImportUsersMutationVariables>(ImportUsersDocument, options);
}
export type ImportUsersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportUsersMutation, ImportUsersMutationVariables>;
export const RestoreUserDocument = /*#__PURE__*/ gql`
    mutation RestoreUser($id: ID!) {
  restoreUser(id: $id) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserMutation(options: VueApolloComposable.UseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument, options);
}
export type RestoreUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RestoreUserMutation, RestoreUserMutationVariables>;
export const RestoreWishDocument = /*#__PURE__*/ gql`
    mutation RestoreWish($id: ID!) {
  restoreWish(id: $id) {
    id
  }
}
    `;

/**
 * __useRestoreWishMutation__
 *
 * To run a mutation, you first call `useRestoreWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreWishMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRestoreWishMutation(options: VueApolloComposable.UseMutationOptions<RestoreWishMutation, RestoreWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RestoreWishMutation, RestoreWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RestoreWishMutation, RestoreWishMutationVariables>(RestoreWishDocument, options);
}
export type RestoreWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RestoreWishMutation, RestoreWishMutationVariables>;
export const TwoFactorVerificationDocument = /*#__PURE__*/ gql`
    mutation TwoFactorVerification($input: TwoFactorVerificationInput!) {
  twoFactorVerification(input: $input) {
    valid
    otp
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useTwoFactorVerificationMutation__
 *
 * To run a mutation, you first call `useTwoFactorVerificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTwoFactorVerificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTwoFactorVerificationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTwoFactorVerificationMutation(options: VueApolloComposable.UseMutationOptions<TwoFactorVerificationMutation, TwoFactorVerificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TwoFactorVerificationMutation, TwoFactorVerificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<TwoFactorVerificationMutation, TwoFactorVerificationMutationVariables>(TwoFactorVerificationDocument, options);
}
export type TwoFactorVerificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TwoFactorVerificationMutation, TwoFactorVerificationMutationVariables>;
export const ToggleVehicleActivenessDocument = /*#__PURE__*/ gql`
    mutation ToggleVehicleActiveness($id: ID!, $inactive: Boolean!) {
  toggleVehicleActiveness(id: $id, inactive: $inactive) {
    success
    attached_wishes
  }
}
    `;

/**
 * __useToggleVehicleActivenessMutation__
 *
 * To run a mutation, you first call `useToggleVehicleActivenessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleVehicleActivenessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleVehicleActivenessMutation({
 *   variables: {
 *     id: // value for 'id'
 *     inactive: // value for 'inactive'
 *   },
 * });
 */
export function useToggleVehicleActivenessMutation(options: VueApolloComposable.UseMutationOptions<ToggleVehicleActivenessMutation, ToggleVehicleActivenessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ToggleVehicleActivenessMutation, ToggleVehicleActivenessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ToggleVehicleActivenessMutation, ToggleVehicleActivenessMutationVariables>(ToggleVehicleActivenessDocument, options);
}
export type ToggleVehicleActivenessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ToggleVehicleActivenessMutation, ToggleVehicleActivenessMutationVariables>;
export const UnplanWishDocument = /*#__PURE__*/ gql`
    mutation UnplanWish($id: ID!) {
  unplanWish(id: $id) {
    id
  }
}
    `;

/**
 * __useUnplanWishMutation__
 *
 * To run a mutation, you first call `useUnplanWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnplanWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnplanWishMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnplanWishMutation(options: VueApolloComposable.UseMutationOptions<UnplanWishMutation, UnplanWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnplanWishMutation, UnplanWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnplanWishMutation, UnplanWishMutationVariables>(UnplanWishDocument, options);
}
export type UnplanWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnplanWishMutation, UnplanWishMutationVariables>;
export const UpdateForgottenPasswordDocument = /*#__PURE__*/ gql`
    mutation UpdateForgottenPassword($input: NewPasswordWithCodeInput) {
  updateForgottenPassword(input: $input) {
    status
    message
  }
}
    `;

/**
 * __useUpdateForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateForgottenPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForgottenPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateForgottenPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateForgottenPasswordMutation(options: VueApolloComposable.UseMutationOptions<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>(UpdateForgottenPasswordDocument, options);
}
export type UpdateForgottenPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateForgottenPasswordMutation, UpdateForgottenPasswordMutationVariables>;
export const UpdateAddressDocument = /*#__PURE__*/ gql`
    mutation UpdateAddress($id: ID!, $input: UpdateAddressInput!) {
  updateAddress(id: $id, input: $input) {
    ...ContactAddressFragment
    ...UserAddressFragment
    ...WishAddressFragment
  }
}
    ${ContactAddressFragmentFragmentDoc}
${UserAddressFragmentFragmentDoc}
${WishAddressFragmentFragmentDoc}`;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAddressMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(options: VueApolloComposable.UseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
}
export type UpdateAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const UpdateMedicalInformationDocument = /*#__PURE__*/ gql`
    mutation UpdateMedicalInformation($id: ID!, $input: MedicalInformationInput!) {
  updateMedicalInformation(id: $id, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateMedicalInformationMutation__
 *
 * To run a mutation, you first call `useUpdateMedicalInformationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicalInformationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMedicalInformationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMedicalInformationMutation(options: VueApolloComposable.UseMutationOptions<UpdateMedicalInformationMutation, UpdateMedicalInformationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMedicalInformationMutation, UpdateMedicalInformationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMedicalInformationMutation, UpdateMedicalInformationMutationVariables>(UpdateMedicalInformationDocument, options);
}
export type UpdateMedicalInformationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMedicalInformationMutation, UpdateMedicalInformationMutationVariables>;
export const UpdateReservationDocument = /*#__PURE__*/ gql`
    mutation UpdateReservation($id: ID!, $input: ReservationInput!) {
  updateReservation(id: $id, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateReservationMutation__
 *
 * To run a mutation, you first call `useUpdateReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReservationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReservationMutation(options: VueApolloComposable.UseMutationOptions<UpdateReservationMutation, UpdateReservationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateReservationMutation, UpdateReservationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateReservationMutation, UpdateReservationMutationVariables>(UpdateReservationDocument, options);
}
export type UpdateReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const UpdateMileageDocument = /*#__PURE__*/ gql`
    mutation UpdateMileage($id: ID!, $input: MileageInput!) {
  updateMileage(id: $id, input: $input) {
    ...MileageFragment
  }
}
    ${MileageFragmentFragmentDoc}`;

/**
 * __useUpdateMileageMutation__
 *
 * To run a mutation, you first call `useUpdateMileageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMileageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMileageMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMileageMutation(options: VueApolloComposable.UseMutationOptions<UpdateMileageMutation, UpdateMileageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateMileageMutation, UpdateMileageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateMileageMutation, UpdateMileageMutationVariables>(UpdateMileageDocument, options);
}
export type UpdateMileageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateMileageMutation, UpdateMileageMutationVariables>;
export const UpdatePasswordDocument = /*#__PURE__*/ gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    status
  }
}
    `;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(options: VueApolloComposable.UseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
}
export type UpdatePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateVehicleDocument = /*#__PURE__*/ gql`
    mutation UpdateVehicle($id: ID!, $input: VehicleInput!) {
  updateVehicle(id: $id, input: $input) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useUpdateVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVehicleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleMutation(options: VueApolloComposable.UseMutationOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateVehicleMutation, UpdateVehicleMutationVariables>(UpdateVehicleDocument, options);
}
export type UpdateVehicleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateVehicleMutation, UpdateVehicleMutationVariables>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation UpdateUser($id: ID!, $input: UpdateUserInput) {
  updateUser(id: $id, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserStatusDocument = /*#__PURE__*/ gql`
    mutation UpdateUserStatus($id: ID!, $status: UserStatus!, $note: String!, $eventData: JSON!) {
  updateUser(id: $id, input: {status: $status}) {
    id
  }
  createNote(
    input: {content: $note, noteable_id: $id, noteable_type: "App\\\\Models\\\\User", event_type: UserStatusChange, event_data: $eventData}
  ) {
    id
  }
}
    `;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *     note: // value for 'note'
 *     eventData: // value for 'eventData'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(UpdateUserStatusDocument, options);
}
export type UpdateUserStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;
export const UpdateVehicleAvailabilityEntryDocument = /*#__PURE__*/ gql`
    mutation UpdateVehicleAvailabilityEntry($id: ID!, $input: VehicleAvailabilityEntryInput!) {
  updateVehicleAvailabilityEntry(id: $id, input: $input) {
    id
    unavailable_on
    reason
  }
}
    `;

/**
 * __useUpdateVehicleAvailabilityEntryMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleAvailabilityEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleAvailabilityEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVehicleAvailabilityEntryMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVehicleAvailabilityEntryMutation(options: VueApolloComposable.UseMutationOptions<UpdateVehicleAvailabilityEntryMutation, UpdateVehicleAvailabilityEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateVehicleAvailabilityEntryMutation, UpdateVehicleAvailabilityEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateVehicleAvailabilityEntryMutation, UpdateVehicleAvailabilityEntryMutationVariables>(UpdateVehicleAvailabilityEntryDocument, options);
}
export type UpdateVehicleAvailabilityEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateVehicleAvailabilityEntryMutation, UpdateVehicleAvailabilityEntryMutationVariables>;
export const UpdateWishDocument = /*#__PURE__*/ gql`
    mutation UpdateWish($id: ID!, $planningUpdate: Boolean, $input: UpdateWishInput!) {
  updateWish(id: $id, planningUpdate: $planningUpdate, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateWishMutation__
 *
 * To run a mutation, you first call `useUpdateWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWishMutation({
 *   variables: {
 *     id: // value for 'id'
 *     planningUpdate: // value for 'planningUpdate'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWishMutation(options: VueApolloComposable.UseMutationOptions<UpdateWishMutation, UpdateWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWishMutation, UpdateWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWishMutation, UpdateWishMutationVariables>(UpdateWishDocument, options);
}
export type UpdateWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWishMutation, UpdateWishMutationVariables>;
export const UpdateWishContactsDocument = /*#__PURE__*/ gql`
    mutation UpdateWishContacts($wishId: ID!, $contactType: ContactType, $contacts: [UpdateContactInput!]!) {
  updateWishContacts(
    wish_id: $wishId
    contact_type: $contactType
    input: $contacts
  ) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useUpdateWishContactsMutation__
 *
 * To run a mutation, you first call `useUpdateWishContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWishContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWishContactsMutation({
 *   variables: {
 *     wishId: // value for 'wishId'
 *     contactType: // value for 'contactType'
 *     contacts: // value for 'contacts'
 *   },
 * });
 */
export function useUpdateWishContactsMutation(options: VueApolloComposable.UseMutationOptions<UpdateWishContactsMutation, UpdateWishContactsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWishContactsMutation, UpdateWishContactsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWishContactsMutation, UpdateWishContactsMutationVariables>(UpdateWishContactsDocument, options);
}
export type UpdateWishContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWishContactsMutation, UpdateWishContactsMutationVariables>;
export const UpdateWishRequestDocument = /*#__PURE__*/ gql`
    mutation UpdateWishRequest($input: UpdateWishRequestInput!) {
  updateWishRequest(input: $input) {
    id
    patient {
      id
    }
  }
}
    `;

/**
 * __useUpdateWishRequestMutation__
 *
 * To run a mutation, you first call `useUpdateWishRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWishRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWishRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWishRequestMutation(options: VueApolloComposable.UseMutationOptions<UpdateWishRequestMutation, UpdateWishRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWishRequestMutation, UpdateWishRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWishRequestMutation, UpdateWishRequestMutationVariables>(UpdateWishRequestDocument, options);
}
export type UpdateWishRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWishRequestMutation, UpdateWishRequestMutationVariables>;
export const UpdateWishStatusDocument = /*#__PURE__*/ gql`
    mutation UpdateWishStatus($id: ID!, $status: Status!, $note: String!, $eventData: JSON!) {
  updateWish(id: $id, input: {status: $status}) {
    id
  }
  createNote(
    input: {content: $note, noteable_id: $id, noteable_type: "App\\\\Models\\\\Wish", event_type: WishStatusChange, event_data: $eventData}
  ) {
    id
  }
}
    `;

/**
 * __useUpdateWishStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWishStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWishStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWishStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *     note: // value for 'note'
 *     eventData: // value for 'eventData'
 *   },
 * });
 */
export function useUpdateWishStatusMutation(options: VueApolloComposable.UseMutationOptions<UpdateWishStatusMutation, UpdateWishStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWishStatusMutation, UpdateWishStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWishStatusMutation, UpdateWishStatusMutationVariables>(UpdateWishStatusDocument, options);
}
export type UpdateWishStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWishStatusMutation, UpdateWishStatusMutationVariables>;
export const UploadWishDocumentDocument = /*#__PURE__*/ gql`
    mutation UploadWishDocument($input: WishDocumentInput!) {
  uploadWishDocument(input: $input) {
    success
  }
}
    `;

/**
 * __useUploadWishDocumentMutation__
 *
 * To run a mutation, you first call `useUploadWishDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadWishDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadWishDocumentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUploadWishDocumentMutation(options: VueApolloComposable.UseMutationOptions<UploadWishDocumentMutation, UploadWishDocumentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadWishDocumentMutation, UploadWishDocumentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadWishDocumentMutation, UploadWishDocumentMutationVariables>(UploadWishDocumentDocument, options);
}
export type UploadWishDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadWishDocumentMutation, UploadWishDocumentMutationVariables>;
export const UploadAvatarDocument = /*#__PURE__*/ gql`
    mutation UploadAvatar($input: Avatar) {
  uploadAvatar(input: $input) {
    url
  }
}
    `;

/**
 * __useUploadAvatarMutation__
 *
 * To run a mutation, you first call `useUploadAvatarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadAvatarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadAvatarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUploadAvatarMutation(options: VueApolloComposable.UseMutationOptions<UploadAvatarMutation, UploadAvatarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadAvatarMutation, UploadAvatarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadAvatarMutation, UploadAvatarMutationVariables>(UploadAvatarDocument, options);
}
export type UploadAvatarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadAvatarMutation, UploadAvatarMutationVariables>;
export const ActiveVehiclesDocument = /*#__PURE__*/ gql`
    query ActiveVehicles {
  activeVehicles {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useActiveVehiclesQuery__
 *
 * To run a query within a Vue component, call `useActiveVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveVehiclesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActiveVehiclesQuery();
 */
export function useActiveVehiclesQuery(options: VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>(ActiveVehiclesDocument, {}, options);
}
export function useActiveVehiclesLazyQuery(options: VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>(ActiveVehiclesDocument, {}, options);
}
export type ActiveVehiclesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActiveVehiclesQuery, ActiveVehiclesQueryVariables>;
export const AddressesDocument = /*#__PURE__*/ gql`
    query Addresses($first: Int!, $page: Int, $wishAddresses: Boolean, $search: String, $column: QueryAddressesOrderByColumn!, $order: SortOrder!) {
  addresses(
    first: $first
    page: $page
    wishAddresses: $wishAddresses
    search: $search
    orderBy: [{column: $column, order: $order}]
  ) {
    data {
      ...AddressFragment
      formatted
      address_line_1
      wishes_count
      total_count
      has_location
      has_place_id
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useAddressesQuery__
 *
 * To run a query within a Vue component, call `useAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAddressesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   wishAddresses: // value for 'wishAddresses'
 *   search: // value for 'search'
 *   column: // value for 'column'
 *   order: // value for 'order'
 * });
 */
export function useAddressesQuery(variables: AddressesQueryVariables | VueCompositionApi.Ref<AddressesQueryVariables> | ReactiveFunction<AddressesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, variables, options);
}
export function useAddressesLazyQuery(variables?: AddressesQueryVariables | VueCompositionApi.Ref<AddressesQueryVariables> | ReactiveFunction<AddressesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AddressesQuery, AddressesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, variables, options);
}
export type AddressesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AddressesQuery, AddressesQueryVariables>;
export const AllVehicleAvailabilityEntriesDocument = /*#__PURE__*/ gql`
    query AllVehicleAvailabilityEntries($from: Date!, $to: Date!, $vehicle_id: ID) {
  allVehicleAvailabilityEntries(from: $from, to: $to, vehicle_id: $vehicle_id) {
    id
    unavailable_on
    vehicle {
      id
    }
  }
}
    `;

/**
 * __useAllVehicleAvailabilityEntriesQuery__
 *
 * To run a query within a Vue component, call `useAllVehicleAvailabilityEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehicleAvailabilityEntriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllVehicleAvailabilityEntriesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   vehicle_id: // value for 'vehicle_id'
 * });
 */
export function useAllVehicleAvailabilityEntriesQuery(variables: AllVehicleAvailabilityEntriesQueryVariables | VueCompositionApi.Ref<AllVehicleAvailabilityEntriesQueryVariables> | ReactiveFunction<AllVehicleAvailabilityEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>(AllVehicleAvailabilityEntriesDocument, variables, options);
}
export function useAllVehicleAvailabilityEntriesLazyQuery(variables?: AllVehicleAvailabilityEntriesQueryVariables | VueCompositionApi.Ref<AllVehicleAvailabilityEntriesQueryVariables> | ReactiveFunction<AllVehicleAvailabilityEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>(AllVehicleAvailabilityEntriesDocument, variables, options);
}
export type AllVehicleAvailabilityEntriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllVehicleAvailabilityEntriesQuery, AllVehicleAvailabilityEntriesQueryVariables>;
export const AvailabilityDocument = /*#__PURE__*/ gql`
    query Availability($start: Date!, $end: Date!, $user_id: ID) {
  availability(start: $start, end: $end, user_id: $user_id) {
    date
    available
    blocked
    wish_planned
    wish_planned_as_concept
    volunteer_count
    availability_entry {
      id
    }
  }
}
    `;

/**
 * __useAvailabilityQuery__
 *
 * To run a query within a Vue component, call `useAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailabilityQuery({
 *   start: // value for 'start'
 *   end: // value for 'end'
 *   user_id: // value for 'user_id'
 * });
 */
export function useAvailabilityQuery(variables: AvailabilityQueryVariables | VueCompositionApi.Ref<AvailabilityQueryVariables> | ReactiveFunction<AvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, variables, options);
}
export function useAvailabilityLazyQuery(variables?: AvailabilityQueryVariables | VueCompositionApi.Ref<AvailabilityQueryVariables> | ReactiveFunction<AvailabilityQueryVariables>, options: VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailabilityQuery, AvailabilityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, variables, options);
}
export type AvailabilityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailabilityQuery, AvailabilityQueryVariables>;
export const BigCheckDocument = /*#__PURE__*/ gql`
    query BigCheck($big: String!) {
  bigCheck(big: $big) {
    registrations {
      valid
    }
  }
}
    `;

/**
 * __useBigCheckQuery__
 *
 * To run a query within a Vue component, call `useBigCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useBigCheckQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBigCheckQuery({
 *   big: // value for 'big'
 * });
 */
export function useBigCheckQuery(variables: BigCheckQueryVariables | VueCompositionApi.Ref<BigCheckQueryVariables> | ReactiveFunction<BigCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BigCheckQuery, BigCheckQueryVariables>(BigCheckDocument, variables, options);
}
export function useBigCheckLazyQuery(variables?: BigCheckQueryVariables | VueCompositionApi.Ref<BigCheckQueryVariables> | ReactiveFunction<BigCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BigCheckQuery, BigCheckQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BigCheckQuery, BigCheckQueryVariables>(BigCheckDocument, variables, options);
}
export type BigCheckQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BigCheckQuery, BigCheckQueryVariables>;
export const AllAvailableVehiclesDocument = /*#__PURE__*/ gql`
    query allAvailableVehicles($from: Date!, $to: Date!) {
  allAvailableVehicles(from: $from, to: $to) {
    id
    vehicle_number
    licence_plate
  }
}
    `;

/**
 * __useAllAvailableVehiclesQuery__
 *
 * To run a query within a Vue component, call `useAllAvailableVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAvailableVehiclesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllAvailableVehiclesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useAllAvailableVehiclesQuery(variables: AllAvailableVehiclesQueryVariables | VueCompositionApi.Ref<AllAvailableVehiclesQueryVariables> | ReactiveFunction<AllAvailableVehiclesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>(AllAvailableVehiclesDocument, variables, options);
}
export function useAllAvailableVehiclesLazyQuery(variables?: AllAvailableVehiclesQueryVariables | VueCompositionApi.Ref<AllAvailableVehiclesQueryVariables> | ReactiveFunction<AllAvailableVehiclesQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>(AllAvailableVehiclesDocument, variables, options);
}
export type AllAvailableVehiclesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllAvailableVehiclesQuery, AllAvailableVehiclesQueryVariables>;
export const CalculateDistanceDocument = /*#__PURE__*/ gql`
    query CalculateDistance($fromAddressId: ID!, $toAddressId: ID!, $roundtrip: Boolean) {
  calculateDistance(
    fromAddressId: $fromAddressId
    toAddressId: $toAddressId
    roundtrip: $roundtrip
  ) {
    distance
  }
}
    `;

/**
 * __useCalculateDistanceQuery__
 *
 * To run a query within a Vue component, call `useCalculateDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateDistanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalculateDistanceQuery({
 *   fromAddressId: // value for 'fromAddressId'
 *   toAddressId: // value for 'toAddressId'
 *   roundtrip: // value for 'roundtrip'
 * });
 */
export function useCalculateDistanceQuery(variables: CalculateDistanceQueryVariables | VueCompositionApi.Ref<CalculateDistanceQueryVariables> | ReactiveFunction<CalculateDistanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalculateDistanceQuery, CalculateDistanceQueryVariables>(CalculateDistanceDocument, variables, options);
}
export function useCalculateDistanceLazyQuery(variables?: CalculateDistanceQueryVariables | VueCompositionApi.Ref<CalculateDistanceQueryVariables> | ReactiveFunction<CalculateDistanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalculateDistanceQuery, CalculateDistanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalculateDistanceQuery, CalculateDistanceQueryVariables>(CalculateDistanceDocument, variables, options);
}
export type CalculateDistanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalculateDistanceQuery, CalculateDistanceQueryVariables>;
export const ExpenseRelatedWishesDocument = /*#__PURE__*/ gql`
    query ExpenseRelatedWishes($expenseId: ID!, $search: String) {
  expenseRelatedWishes(expense_id: $expenseId, search: $search) {
    ...ExpenseRelatedWishFragment
  }
}
    ${ExpenseRelatedWishFragmentFragmentDoc}`;

/**
 * __useExpenseRelatedWishesQuery__
 *
 * To run a query within a Vue component, call `useExpenseRelatedWishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseRelatedWishesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExpenseRelatedWishesQuery({
 *   expenseId: // value for 'expenseId'
 *   search: // value for 'search'
 * });
 */
export function useExpenseRelatedWishesQuery(variables: ExpenseRelatedWishesQueryVariables | VueCompositionApi.Ref<ExpenseRelatedWishesQueryVariables> | ReactiveFunction<ExpenseRelatedWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>(ExpenseRelatedWishesDocument, variables, options);
}
export function useExpenseRelatedWishesLazyQuery(variables?: ExpenseRelatedWishesQueryVariables | VueCompositionApi.Ref<ExpenseRelatedWishesQueryVariables> | ReactiveFunction<ExpenseRelatedWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>(ExpenseRelatedWishesDocument, variables, options);
}
export type ExpenseRelatedWishesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpenseRelatedWishesQuery, ExpenseRelatedWishesQueryVariables>;
export const ExpenseRelatedWishDocument = /*#__PURE__*/ gql`
    query ExpenseRelatedWish($wishId: ID!) {
  wish(id: $wishId) {
    ...ExpenseRelatedWishFragment
  }
}
    ${ExpenseRelatedWishFragmentFragmentDoc}`;

/**
 * __useExpenseRelatedWishQuery__
 *
 * To run a query within a Vue component, call `useExpenseRelatedWishQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseRelatedWishQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExpenseRelatedWishQuery({
 *   wishId: // value for 'wishId'
 * });
 */
export function useExpenseRelatedWishQuery(variables: ExpenseRelatedWishQueryVariables | VueCompositionApi.Ref<ExpenseRelatedWishQueryVariables> | ReactiveFunction<ExpenseRelatedWishQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>(ExpenseRelatedWishDocument, variables, options);
}
export function useExpenseRelatedWishLazyQuery(variables?: ExpenseRelatedWishQueryVariables | VueCompositionApi.Ref<ExpenseRelatedWishQueryVariables> | ReactiveFunction<ExpenseRelatedWishQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>(ExpenseRelatedWishDocument, variables, options);
}
export type ExpenseRelatedWishQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpenseRelatedWishQuery, ExpenseRelatedWishQueryVariables>;
export const ExpenseDocument = /*#__PURE__*/ gql`
    query Expense($id: ID!) {
  expense(id: $id) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragmentFragmentDoc}`;

/**
 * __useExpenseQuery__
 *
 * To run a query within a Vue component, call `useExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpenseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExpenseQuery({
 *   id: // value for 'id'
 * });
 */
export function useExpenseQuery(variables: ExpenseQueryVariables | VueCompositionApi.Ref<ExpenseQueryVariables> | ReactiveFunction<ExpenseQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpenseQuery, ExpenseQueryVariables>(ExpenseDocument, variables, options);
}
export function useExpenseLazyQuery(variables?: ExpenseQueryVariables | VueCompositionApi.Ref<ExpenseQueryVariables> | ReactiveFunction<ExpenseQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpenseQuery, ExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpenseQuery, ExpenseQueryVariables>(ExpenseDocument, variables, options);
}
export type ExpenseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpenseQuery, ExpenseQueryVariables>;
export const ExpensesDocument = /*#__PURE__*/ gql`
    query Expenses($first: Int!, $page: Int, $wishId: ID, $userId: ID, $type: ExpenseType, $status: ExpenseStatus, $transaction_at: Date, $search: String, $only_unlinked: Boolean, $column: QueryExpensesOrderByColumn!, $order: SortOrder!) {
  expenses(
    first: $first
    page: $page
    wishId: $wishId
    userId: $userId
    type: $type
    status: $status
    transaction_at: $transaction_at
    search: $search
    only_unlinked: $only_unlinked
    orderBy: [{column: $column, order: $order}]
  ) {
    data {
      ...ExpenseFragment
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${ExpenseFragmentFragmentDoc}`;

/**
 * __useExpensesQuery__
 *
 * To run a query within a Vue component, call `useExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExpensesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   wishId: // value for 'wishId'
 *   userId: // value for 'userId'
 *   type: // value for 'type'
 *   status: // value for 'status'
 *   transaction_at: // value for 'transaction_at'
 *   search: // value for 'search'
 *   only_unlinked: // value for 'only_unlinked'
 *   column: // value for 'column'
 *   order: // value for 'order'
 * });
 */
export function useExpensesQuery(variables: ExpensesQueryVariables | VueCompositionApi.Ref<ExpensesQueryVariables> | ReactiveFunction<ExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, variables, options);
}
export function useExpensesLazyQuery(variables?: ExpensesQueryVariables | VueCompositionApi.Ref<ExpensesQueryVariables> | ReactiveFunction<ExpensesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExpensesQuery, ExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExpensesQuery, ExpensesQueryVariables>(ExpensesDocument, variables, options);
}
export type ExpensesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExpensesQuery, ExpensesQueryVariables>;
export const ExportExpensesDocument = /*#__PURE__*/ gql`
    query ExportExpenses($ids: [ID!]) {
  exportExpenses(ids: $ids)
}
    `;

/**
 * __useExportExpensesQuery__
 *
 * To run a query within a Vue component, call `useExportExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExpensesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportExpensesQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useExportExpensesQuery(variables: ExportExpensesQueryVariables | VueCompositionApi.Ref<ExportExpensesQueryVariables> | ReactiveFunction<ExportExpensesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportExpensesQuery, ExportExpensesQueryVariables>(ExportExpensesDocument, variables, options);
}
export function useExportExpensesLazyQuery(variables: ExportExpensesQueryVariables | VueCompositionApi.Ref<ExportExpensesQueryVariables> | ReactiveFunction<ExportExpensesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportExpensesQuery, ExportExpensesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportExpensesQuery, ExportExpensesQueryVariables>(ExportExpensesDocument, variables, options);
}
export type ExportExpensesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportExpensesQuery, ExportExpensesQueryVariables>;
export const ExportMileagesDocument = /*#__PURE__*/ gql`
    query ExportMileages($vehicleId: ID, $startDate: Date, $endDate: Date) {
  exportMileages(
    vehicle_id: $vehicleId
    start_date: $startDate
    end_date: $endDate
  )
}
    `;

/**
 * __useExportMileagesQuery__
 *
 * To run a query within a Vue component, call `useExportMileagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMileagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportMileagesQuery({
 *   vehicleId: // value for 'vehicleId'
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 * });
 */
export function useExportMileagesQuery(variables: ExportMileagesQueryVariables | VueCompositionApi.Ref<ExportMileagesQueryVariables> | ReactiveFunction<ExportMileagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportMileagesQuery, ExportMileagesQueryVariables>(ExportMileagesDocument, variables, options);
}
export function useExportMileagesLazyQuery(variables: ExportMileagesQueryVariables | VueCompositionApi.Ref<ExportMileagesQueryVariables> | ReactiveFunction<ExportMileagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportMileagesQuery, ExportMileagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportMileagesQuery, ExportMileagesQueryVariables>(ExportMileagesDocument, variables, options);
}
export type ExportMileagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportMileagesQuery, ExportMileagesQueryVariables>;
export const NotificationsDocument = /*#__PURE__*/ gql`
    query Notifications {
  notifications {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a Vue component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsQuery();
 */
export function useNotificationsQuery(options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, {}, options);
}
export function useNotificationsLazyQuery(options: VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsQuery, NotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, {}, options);
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsQuery, NotificationsQueryVariables>;
export const MileagesDocument = /*#__PURE__*/ gql`
    query Mileages($page: Int, $first: Int!, $wishId: ID, $vehicleId: ID, $date: Date, $created_at: Date, $column: QueryMileagesOrderByColumn!, $order: SortOrder!) {
  mileages(
    page: $page
    first: $first
    wish_id: $wishId
    vehicle_id: $vehicleId
    date: $date
    created_at: $created_at
    orderBy: [{column: $column, order: $order}]
  ) {
    data {
      ...MileageFragment
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${MileageFragmentFragmentDoc}`;

/**
 * __useMileagesQuery__
 *
 * To run a query within a Vue component, call `useMileagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMileagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMileagesQuery({
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   wishId: // value for 'wishId'
 *   vehicleId: // value for 'vehicleId'
 *   date: // value for 'date'
 *   created_at: // value for 'created_at'
 *   column: // value for 'column'
 *   order: // value for 'order'
 * });
 */
export function useMileagesQuery(variables: MileagesQueryVariables | VueCompositionApi.Ref<MileagesQueryVariables> | ReactiveFunction<MileagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MileagesQuery, MileagesQueryVariables>(MileagesDocument, variables, options);
}
export function useMileagesLazyQuery(variables?: MileagesQueryVariables | VueCompositionApi.Ref<MileagesQueryVariables> | ReactiveFunction<MileagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MileagesQuery, MileagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MileagesQuery, MileagesQueryVariables>(MileagesDocument, variables, options);
}
export type MileagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MileagesQuery, MileagesQueryVariables>;
export const OfficeDocument = /*#__PURE__*/ gql`
    query Office {
  office {
    ...AddressFragment
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useOfficeQuery__
 *
 * To run a query within a Vue component, call `useOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOfficeQuery();
 */
export function useOfficeQuery(options: VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, {}, options);
}
export function useOfficeLazyQuery(options: VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfficeQuery, OfficeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, {}, options);
}
export type OfficeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OfficeQuery, OfficeQueryVariables>;
export const MeDocument = /*#__PURE__*/ gql`
    query Me {
  me {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MeQuery, MeQueryVariables>;
export const PlannableWishesDocument = /*#__PURE__*/ gql`
    query PlannableWishes($input: PlannableWishesInput!) {
  plannableWishes(input: $input) {
    ...PlanableWishesFragment
  }
}
    ${PlanableWishesFragmentFragmentDoc}`;

/**
 * __usePlannableWishesQuery__
 *
 * To run a query within a Vue component, call `usePlannableWishesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannableWishesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlannableWishesQuery({
 *   input: // value for 'input'
 * });
 */
export function usePlannableWishesQuery(variables: PlannableWishesQueryVariables | VueCompositionApi.Ref<PlannableWishesQueryVariables> | ReactiveFunction<PlannableWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlannableWishesQuery, PlannableWishesQueryVariables>(PlannableWishesDocument, variables, options);
}
export function usePlannableWishesLazyQuery(variables?: PlannableWishesQueryVariables | VueCompositionApi.Ref<PlannableWishesQueryVariables> | ReactiveFunction<PlannableWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannableWishesQuery, PlannableWishesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlannableWishesQuery, PlannableWishesQueryVariables>(PlannableWishesDocument, variables, options);
}
export type PlannableWishesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlannableWishesQuery, PlannableWishesQueryVariables>;
export const PhotosDocument = /*#__PURE__*/ gql`
    query Photos($wish_id: ID!) {
  photos(wish_id: $wish_id) {
    ...PhotoFragment
  }
}
    ${PhotoFragmentFragmentDoc}`;

/**
 * __usePhotosQuery__
 *
 * To run a query within a Vue component, call `usePhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePhotosQuery({
 *   wish_id: // value for 'wish_id'
 * });
 */
export function usePhotosQuery(variables: PhotosQueryVariables | VueCompositionApi.Ref<PhotosQueryVariables> | ReactiveFunction<PhotosQueryVariables>, options: VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PhotosQuery, PhotosQueryVariables>(PhotosDocument, variables, options);
}
export function usePhotosLazyQuery(variables?: PhotosQueryVariables | VueCompositionApi.Ref<PhotosQueryVariables> | ReactiveFunction<PhotosQueryVariables>, options: VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PhotosQuery, PhotosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PhotosQuery, PhotosQueryVariables>(PhotosDocument, variables, options);
}
export type PhotosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PhotosQuery, PhotosQueryVariables>;
export const PlanningVolunteersDocument = /*#__PURE__*/ gql`
    query PlanningVolunteers($wishId: ID, $vehicleId: ID, $page: Int, $first: Int!, $column: QueryPlanningVolunteersOrderByColumn!, $order: SortOrder!, $startDate: Date!, $endDate: Date, $showAvailable: Boolean, $specializations: [String], $search: String, $roles: [RoleName]) {
  planningVolunteers(
    wishId: $wishId
    vehicleId: $vehicleId
    first: $first
    page: $page
    orderBy: [{column: $column, order: $order}]
    startDate: $startDate
    endDate: $endDate
    showAvailable: $showAvailable
    specializations: $specializations
    search: $search
    roles: $roles
  ) {
    data {
      ...PlannableVolunteerFragment
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${PlannableVolunteerFragmentFragmentDoc}`;

/**
 * __usePlanningVolunteersQuery__
 *
 * To run a query within a Vue component, call `usePlanningVolunteersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningVolunteersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlanningVolunteersQuery({
 *   wishId: // value for 'wishId'
 *   vehicleId: // value for 'vehicleId'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   column: // value for 'column'
 *   order: // value for 'order'
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 *   showAvailable: // value for 'showAvailable'
 *   specializations: // value for 'specializations'
 *   search: // value for 'search'
 *   roles: // value for 'roles'
 * });
 */
export function usePlanningVolunteersQuery(variables: PlanningVolunteersQueryVariables | VueCompositionApi.Ref<PlanningVolunteersQueryVariables> | ReactiveFunction<PlanningVolunteersQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>(PlanningVolunteersDocument, variables, options);
}
export function usePlanningVolunteersLazyQuery(variables?: PlanningVolunteersQueryVariables | VueCompositionApi.Ref<PlanningVolunteersQueryVariables> | ReactiveFunction<PlanningVolunteersQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>(PlanningVolunteersDocument, variables, options);
}
export type PlanningVolunteersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlanningVolunteersQuery, PlanningVolunteersQueryVariables>;
export const MediaDocument = /*#__PURE__*/ gql`
    query Media($first: Int!, $page: Int, $column: QueryMediaOrderByColumn!, $order: SortOrder!, $search: String, $file_category: FileCategory, $updated_at: Date) {
  media(
    page: $page
    first: $first
    orderBy: [{column: $column, order: $order}]
    search: $search
    file_category: $file_category
    updated_at: $updated_at
  ) {
    data {
      ...MediaFragment
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${MediaFragmentFragmentDoc}`;

/**
 * __useMediaQuery__
 *
 * To run a query within a Vue component, call `useMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMediaQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   column: // value for 'column'
 *   order: // value for 'order'
 *   search: // value for 'search'
 *   file_category: // value for 'file_category'
 *   updated_at: // value for 'updated_at'
 * });
 */
export function useMediaQuery(variables: MediaQueryVariables | VueCompositionApi.Ref<MediaQueryVariables> | ReactiveFunction<MediaQueryVariables>, options: VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MediaQuery, MediaQueryVariables>(MediaDocument, variables, options);
}
export function useMediaLazyQuery(variables?: MediaQueryVariables | VueCompositionApi.Ref<MediaQueryVariables> | ReactiveFunction<MediaQueryVariables>, options: VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MediaQuery, MediaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MediaQuery, MediaQueryVariables>(MediaDocument, variables, options);
}
export type MediaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MediaQuery, MediaQueryVariables>;
export const PostalCodeCheckDocument = /*#__PURE__*/ gql`
    query PostalCodeCheck($postalCode: String!, $number: String!) {
  postalCodeCheck(postalCode: $postalCode, number: $number) {
    zipcode
    street
    streetNumber
    city
    municipality
    town
    province
    latitude
    longitude
  }
}
    `;

/**
 * __usePostalCodeCheckQuery__
 *
 * To run a query within a Vue component, call `usePostalCodeCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostalCodeCheckQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePostalCodeCheckQuery({
 *   postalCode: // value for 'postalCode'
 *   number: // value for 'number'
 * });
 */
export function usePostalCodeCheckQuery(variables: PostalCodeCheckQueryVariables | VueCompositionApi.Ref<PostalCodeCheckQueryVariables> | ReactiveFunction<PostalCodeCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>(PostalCodeCheckDocument, variables, options);
}
export function usePostalCodeCheckLazyQuery(variables?: PostalCodeCheckQueryVariables | VueCompositionApi.Ref<PostalCodeCheckQueryVariables> | ReactiveFunction<PostalCodeCheckQueryVariables>, options: VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>(PostalCodeCheckDocument, variables, options);
}
export type PostalCodeCheckQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PostalCodeCheckQuery, PostalCodeCheckQueryVariables>;
export const PlannableWishDocument = /*#__PURE__*/ gql`
    query PlannableWish($id: ID!, $trashed: Trashed = WITH) {
  wish(id: $id, trashed: $trashed) {
    ...PlannableWishFragment
  }
}
    ${PlannableWishFragmentFragmentDoc}`;

/**
 * __usePlannableWishQuery__
 *
 * To run a query within a Vue component, call `usePlannableWishQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannableWishQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlannableWishQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function usePlannableWishQuery(variables: PlannableWishQueryVariables | VueCompositionApi.Ref<PlannableWishQueryVariables> | ReactiveFunction<PlannableWishQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PlannableWishQuery, PlannableWishQueryVariables>(PlannableWishDocument, variables, options);
}
export function usePlannableWishLazyQuery(variables?: PlannableWishQueryVariables | VueCompositionApi.Ref<PlannableWishQueryVariables> | ReactiveFunction<PlannableWishQueryVariables>, options: VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PlannableWishQuery, PlannableWishQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PlannableWishQuery, PlannableWishQueryVariables>(PlannableWishDocument, variables, options);
}
export type PlannableWishQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PlannableWishQuery, PlannableWishQueryVariables>;
export const ReservationsDocument = /*#__PURE__*/ gql`
    query Reservations($start_date: Date!, $end_date: Date) {
  reservations(start_date: $start_date, end_date: $end_date) {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationsQuery__
 *
 * To run a query within a Vue component, call `useReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReservationsQuery({
 *   start_date: // value for 'start_date'
 *   end_date: // value for 'end_date'
 * });
 */
export function useReservationsQuery(variables: ReservationsQueryVariables | VueCompositionApi.Ref<ReservationsQueryVariables> | ReactiveFunction<ReservationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReservationsQuery, ReservationsQueryVariables>(ReservationsDocument, variables, options);
}
export function useReservationsLazyQuery(variables?: ReservationsQueryVariables | VueCompositionApi.Ref<ReservationsQueryVariables> | ReactiveFunction<ReservationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReservationsQuery, ReservationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReservationsQuery, ReservationsQueryVariables>(ReservationsDocument, variables, options);
}
export type ReservationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReservationsQuery, ReservationsQueryVariables>;
export const SimilarWishesDocument = /*#__PURE__*/ gql`
    query SimilarWishes($id: ID!) {
  similarWishes(id: $id) {
    id
    patient {
      full_name
    }
  }
}
    `;

/**
 * __useSimilarWishesQuery__
 *
 * To run a query within a Vue component, call `useSimilarWishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarWishesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSimilarWishesQuery({
 *   id: // value for 'id'
 * });
 */
export function useSimilarWishesQuery(variables: SimilarWishesQueryVariables | VueCompositionApi.Ref<SimilarWishesQueryVariables> | ReactiveFunction<SimilarWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SimilarWishesQuery, SimilarWishesQueryVariables>(SimilarWishesDocument, variables, options);
}
export function useSimilarWishesLazyQuery(variables?: SimilarWishesQueryVariables | VueCompositionApi.Ref<SimilarWishesQueryVariables> | ReactiveFunction<SimilarWishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SimilarWishesQuery, SimilarWishesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SimilarWishesQuery, SimilarWishesQueryVariables>(SimilarWishesDocument, variables, options);
}
export type SimilarWishesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SimilarWishesQuery, SimilarWishesQueryVariables>;
export const ReservationDocument = /*#__PURE__*/ gql`
    query Reservation($id: ID!) {
  reservation(id: $id) {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationQuery__
 *
 * To run a query within a Vue component, call `useReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReservationQuery({
 *   id: // value for 'id'
 * });
 */
export function useReservationQuery(variables: ReservationQueryVariables | VueCompositionApi.Ref<ReservationQueryVariables> | ReactiveFunction<ReservationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, variables, options);
}
export function useReservationLazyQuery(variables?: ReservationQueryVariables | VueCompositionApi.Ref<ReservationQueryVariables> | ReactiveFunction<ReservationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReservationQuery, ReservationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, variables, options);
}
export type ReservationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ReservationQuery, ReservationQueryVariables>;
export const UserDocument = /*#__PURE__*/ gql`
    query User($id: ID!, $trashed: Trashed) {
  user(id: $id, trashed: $trashed) {
    ...UserFragment
    bank_account_holder
    bank_account_number
    emergency_contact_name
    emergency_contact_phone_number
    big_number
    big_expires
    has_diploma
    diploma_type
    graduation_year
    driver_license_expires
    driver_license_types
    vog_issued_at
    vog_identifier
    profession
    preserve_name
    travel_allowance
    reserved_procedures
    deletable
    activities {
      ...ActivityFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ActivityFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a Vue component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useUserQuery(variables: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export function useUserLazyQuery(variables?: UserQueryVariables | VueCompositionApi.Ref<UserQueryVariables> | ReactiveFunction<UserQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserQuery, UserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, variables, options);
}
export type UserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserQuery, UserQueryVariables>;
export const UserAddressesDocument = /*#__PURE__*/ gql`
    query UserAddresses($user_id: ID!, $first: Int!, $page: Int = 1) {
  userAddresses(user_id: $user_id, first: $first, page: $page) {
    data {
      ...UserAddressFragment
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${UserAddressFragmentFragmentDoc}`;

/**
 * __useUserAddressesQuery__
 *
 * To run a query within a Vue component, call `useUserAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAddressesQuery({
 *   user_id: // value for 'user_id'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useUserAddressesQuery(variables: UserAddressesQueryVariables | VueCompositionApi.Ref<UserAddressesQueryVariables> | ReactiveFunction<UserAddressesQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAddressesQuery, UserAddressesQueryVariables>(UserAddressesDocument, variables, options);
}
export function useUserAddressesLazyQuery(variables?: UserAddressesQueryVariables | VueCompositionApi.Ref<UserAddressesQueryVariables> | ReactiveFunction<UserAddressesQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAddressesQuery, UserAddressesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAddressesQuery, UserAddressesQueryVariables>(UserAddressesDocument, variables, options);
}
export type UserAddressesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAddressesQuery, UserAddressesQueryVariables>;
export const UserAddressDocument = /*#__PURE__*/ gql`
    query UserAddress($id: ID!) {
  userAddress(id: $id) {
    ...UserAddressFragment
  }
}
    ${UserAddressFragmentFragmentDoc}`;

/**
 * __useUserAddressQuery__
 *
 * To run a query within a Vue component, call `useUserAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserAddressQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserAddressQuery(variables: UserAddressQueryVariables | VueCompositionApi.Ref<UserAddressQueryVariables> | ReactiveFunction<UserAddressQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserAddressQuery, UserAddressQueryVariables>(UserAddressDocument, variables, options);
}
export function useUserAddressLazyQuery(variables?: UserAddressQueryVariables | VueCompositionApi.Ref<UserAddressQueryVariables> | ReactiveFunction<UserAddressQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserAddressQuery, UserAddressQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserAddressQuery, UserAddressQueryVariables>(UserAddressDocument, variables, options);
}
export type UserAddressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserAddressQuery, UserAddressQueryVariables>;
export const UserDetailsDocument = /*#__PURE__*/ gql`
    query UserDetails {
  userDetails {
    ...UserDetailsFragment
  }
}
    ${UserDetailsFragmentFragmentDoc}`;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a Vue component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserDetailsQuery();
 */
export function useUserDetailsQuery(options: VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, {}, options);
}
export function useUserDetailsLazyQuery(options: VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDetailsQuery, UserDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, {}, options);
}
export type UserDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserDetailsQuery, UserDetailsQueryVariables>;
export const UserWithActivationTokenDocument = /*#__PURE__*/ gql`
    query UserWithActivationToken($input: ActivationTokenInput) {
  userWithActivationToken(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserWithActivationTokenQuery__
 *
 * To run a query within a Vue component, call `useUserWithActivationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithActivationTokenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserWithActivationTokenQuery({
 *   input: // value for 'input'
 * });
 */
export function useUserWithActivationTokenQuery(variables: UserWithActivationTokenQueryVariables | VueCompositionApi.Ref<UserWithActivationTokenQueryVariables> | ReactiveFunction<UserWithActivationTokenQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>(UserWithActivationTokenDocument, variables, options);
}
export function useUserWithActivationTokenLazyQuery(variables: UserWithActivationTokenQueryVariables | VueCompositionApi.Ref<UserWithActivationTokenQueryVariables> | ReactiveFunction<UserWithActivationTokenQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>(UserWithActivationTokenDocument, variables, options);
}
export type UserWithActivationTokenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserWithActivationTokenQuery, UserWithActivationTokenQueryVariables>;
export const ValidateWishDateDocument = /*#__PURE__*/ gql`
    query ValidateWishDate($input: ValidateWishDateInput!) {
  validateWishDate(input: $input) {
    valid
    message
  }
}
    `;

/**
 * __useValidateWishDateQuery__
 *
 * To run a query within a Vue component, call `useValidateWishDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateWishDateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useValidateWishDateQuery({
 *   input: // value for 'input'
 * });
 */
export function useValidateWishDateQuery(variables: ValidateWishDateQueryVariables | VueCompositionApi.Ref<ValidateWishDateQueryVariables> | ReactiveFunction<ValidateWishDateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ValidateWishDateQuery, ValidateWishDateQueryVariables>(ValidateWishDateDocument, variables, options);
}
export function useValidateWishDateLazyQuery(variables?: ValidateWishDateQueryVariables | VueCompositionApi.Ref<ValidateWishDateQueryVariables> | ReactiveFunction<ValidateWishDateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ValidateWishDateQuery, ValidateWishDateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ValidateWishDateQuery, ValidateWishDateQueryVariables>(ValidateWishDateDocument, variables, options);
}
export type ValidateWishDateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ValidateWishDateQuery, ValidateWishDateQueryVariables>;
export const VehicleDocument = /*#__PURE__*/ gql`
    query Vehicle($id: ID!, $trashed: Trashed) {
  vehicle(id: $id, trashed: $trashed) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useVehicleQuery__
 *
 * To run a query within a Vue component, call `useVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVehicleQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useVehicleQuery(variables: VehicleQueryVariables | VueCompositionApi.Ref<VehicleQueryVariables> | ReactiveFunction<VehicleQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, variables, options);
}
export function useVehicleLazyQuery(variables?: VehicleQueryVariables | VueCompositionApi.Ref<VehicleQueryVariables> | ReactiveFunction<VehicleQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleQuery, VehicleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VehicleQuery, VehicleQueryVariables>(VehicleDocument, variables, options);
}
export type VehicleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VehicleQuery, VehicleQueryVariables>;
export const VehicleAvailabilityEntriesDocument = /*#__PURE__*/ gql`
    query VehicleAvailabilityEntries($vehicle_id: ID!, $from: Date!, $to: Date!) {
  vehicleAvailabilityEntries(vehicle_id: $vehicle_id, from: $from, to: $to) {
    date
    unavailable
    blocked
    wish_planned
    wish_draft_planned
    reservation_planned
    unavailability_entry {
      id
      reason
    }
  }
}
    `;

/**
 * __useVehicleAvailabilityEntriesQuery__
 *
 * To run a query within a Vue component, call `useVehicleAvailabilityEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleAvailabilityEntriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVehicleAvailabilityEntriesQuery({
 *   vehicle_id: // value for 'vehicle_id'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useVehicleAvailabilityEntriesQuery(variables: VehicleAvailabilityEntriesQueryVariables | VueCompositionApi.Ref<VehicleAvailabilityEntriesQueryVariables> | ReactiveFunction<VehicleAvailabilityEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>(VehicleAvailabilityEntriesDocument, variables, options);
}
export function useVehicleAvailabilityEntriesLazyQuery(variables?: VehicleAvailabilityEntriesQueryVariables | VueCompositionApi.Ref<VehicleAvailabilityEntriesQueryVariables> | ReactiveFunction<VehicleAvailabilityEntriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>(VehicleAvailabilityEntriesDocument, variables, options);
}
export type VehicleAvailabilityEntriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VehicleAvailabilityEntriesQuery, VehicleAvailabilityEntriesQueryVariables>;
export const UsersDocument = /*#__PURE__*/ gql`
    query Users($trashed: Trashed, $page: Int, $first: Int!, $column: QueryUsersOrderByColumn!, $order: SortOrder!, $search: String, $role: String, $active: Boolean, $completed: Boolean, $filesDelivered: Boolean, $status: UserStatus) {
  users(
    trashed: $trashed
    page: $page
    first: $first
    orderBy: [{column: $column, order: $order}]
    search: $search
    role: $role
    active: $active
    completed: $completed
    filesDelivered: $filesDelivered
    status: $status
  ) {
    data {
      ...UserFragment
      deleted_at
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a Vue component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersQuery({
 *   trashed: // value for 'trashed'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   column: // value for 'column'
 *   order: // value for 'order'
 *   search: // value for 'search'
 *   role: // value for 'role'
 *   active: // value for 'active'
 *   completed: // value for 'completed'
 *   filesDelivered: // value for 'filesDelivered'
 *   status: // value for 'status'
 * });
 */
export function useUsersQuery(variables: UsersQueryVariables | VueCompositionApi.Ref<UsersQueryVariables> | ReactiveFunction<UsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options);
}
export function useUsersLazyQuery(variables?: UsersQueryVariables | VueCompositionApi.Ref<UsersQueryVariables> | ReactiveFunction<UsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options);
}
export type UsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersQuery, UsersQueryVariables>;
export const VehicleAvailabilityEntriesWishesCountDocument = /*#__PURE__*/ gql`
    query VehicleAvailabilityEntriesWishesCount($date: Date!, $vehicle_id: ID!) {
  vehicleAvailabilityEntriesWishesCount(date: $date, vehicle_id: $vehicle_id) {
    date
    wishes_count
  }
}
    `;

/**
 * __useVehicleAvailabilityEntriesWishesCountQuery__
 *
 * To run a query within a Vue component, call `useVehicleAvailabilityEntriesWishesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleAvailabilityEntriesWishesCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVehicleAvailabilityEntriesWishesCountQuery({
 *   date: // value for 'date'
 *   vehicle_id: // value for 'vehicle_id'
 * });
 */
export function useVehicleAvailabilityEntriesWishesCountQuery(variables: VehicleAvailabilityEntriesWishesCountQueryVariables | VueCompositionApi.Ref<VehicleAvailabilityEntriesWishesCountQueryVariables> | ReactiveFunction<VehicleAvailabilityEntriesWishesCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>(VehicleAvailabilityEntriesWishesCountDocument, variables, options);
}
export function useVehicleAvailabilityEntriesWishesCountLazyQuery(variables?: VehicleAvailabilityEntriesWishesCountQueryVariables | VueCompositionApi.Ref<VehicleAvailabilityEntriesWishesCountQueryVariables> | ReactiveFunction<VehicleAvailabilityEntriesWishesCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>(VehicleAvailabilityEntriesWishesCountDocument, variables, options);
}
export type VehicleAvailabilityEntriesWishesCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VehicleAvailabilityEntriesWishesCountQuery, VehicleAvailabilityEntriesWishesCountQueryVariables>;
export const WishLocationsDocument = /*#__PURE__*/ gql`
    query WishLocations($id: ID!, $trashed: Trashed = WITH) {
  wish(id: $id, trashed: $trashed) {
    locations {
      ...WishAddressFragment
    }
  }
}
    ${WishAddressFragmentFragmentDoc}`;

/**
 * __useWishLocationsQuery__
 *
 * To run a query within a Vue component, call `useWishLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishLocationsQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useWishLocationsQuery(variables: WishLocationsQueryVariables | VueCompositionApi.Ref<WishLocationsQueryVariables> | ReactiveFunction<WishLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishLocationsQuery, WishLocationsQueryVariables>(WishLocationsDocument, variables, options);
}
export function useWishLocationsLazyQuery(variables?: WishLocationsQueryVariables | VueCompositionApi.Ref<WishLocationsQueryVariables> | ReactiveFunction<WishLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishLocationsQuery, WishLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishLocationsQuery, WishLocationsQueryVariables>(WishLocationsDocument, variables, options);
}
export type WishLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishLocationsQuery, WishLocationsQueryVariables>;
export const VehiclesDocument = /*#__PURE__*/ gql`
    query Vehicles($trashed: Trashed) {
  vehicles(trashed: $trashed) {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useVehiclesQuery__
 *
 * To run a query within a Vue component, call `useVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVehiclesQuery({
 *   trashed: // value for 'trashed'
 * });
 */
export function useVehiclesQuery(variables: VehiclesQueryVariables | VueCompositionApi.Ref<VehiclesQueryVariables> | ReactiveFunction<VehiclesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, variables, options);
}
export function useVehiclesLazyQuery(variables: VehiclesQueryVariables | VueCompositionApi.Ref<VehiclesQueryVariables> | ReactiveFunction<VehiclesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VehiclesQuery, VehiclesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VehiclesQuery, VehiclesQueryVariables>(VehiclesDocument, variables, options);
}
export type VehiclesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VehiclesQuery, VehiclesQueryVariables>;
export const WishNotesDocument = /*#__PURE__*/ gql`
    query WishNotes($id: ID!, $trashed: Trashed = WITH) {
  wish(id: $id, trashed: $trashed) {
    notes {
      ...NoteFragment
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useWishNotesQuery__
 *
 * To run a query within a Vue component, call `useWishNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishNotesQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useWishNotesQuery(variables: WishNotesQueryVariables | VueCompositionApi.Ref<WishNotesQueryVariables> | ReactiveFunction<WishNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishNotesQuery, WishNotesQueryVariables>(WishNotesDocument, variables, options);
}
export function useWishNotesLazyQuery(variables?: WishNotesQueryVariables | VueCompositionApi.Ref<WishNotesQueryVariables> | ReactiveFunction<WishNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishNotesQuery, WishNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishNotesQuery, WishNotesQueryVariables>(WishNotesDocument, variables, options);
}
export type WishNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishNotesQuery, WishNotesQueryVariables>;
export const WishPlanningConfirmationExtraInformationDocument = /*#__PURE__*/ gql`
    query WishPlanningConfirmationExtraInformation {
  wishPlanningConfirmationExtraInformation
}
    `;

/**
 * __useWishPlanningConfirmationExtraInformationQuery__
 *
 * To run a query within a Vue component, call `useWishPlanningConfirmationExtraInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishPlanningConfirmationExtraInformationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishPlanningConfirmationExtraInformationQuery();
 */
export function useWishPlanningConfirmationExtraInformationQuery(options: VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>(WishPlanningConfirmationExtraInformationDocument, {}, options);
}
export function useWishPlanningConfirmationExtraInformationLazyQuery(options: VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>(WishPlanningConfirmationExtraInformationDocument, {}, options);
}
export type WishPlanningConfirmationExtraInformationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishPlanningConfirmationExtraInformationQuery, WishPlanningConfirmationExtraInformationQueryVariables>;
export const WishFilesDocument = /*#__PURE__*/ gql`
    query WishFiles($id: ID!, $trashed: Trashed = WITH) {
  wish(id: $id, trashed: $trashed) {
    media {
      ...MediaFragment
    }
  }
}
    ${MediaFragmentFragmentDoc}`;

/**
 * __useWishFilesQuery__
 *
 * To run a query within a Vue component, call `useWishFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishFilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishFilesQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useWishFilesQuery(variables: WishFilesQueryVariables | VueCompositionApi.Ref<WishFilesQueryVariables> | ReactiveFunction<WishFilesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishFilesQuery, WishFilesQueryVariables>(WishFilesDocument, variables, options);
}
export function useWishFilesLazyQuery(variables?: WishFilesQueryVariables | VueCompositionApi.Ref<WishFilesQueryVariables> | ReactiveFunction<WishFilesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishFilesQuery, WishFilesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishFilesQuery, WishFilesQueryVariables>(WishFilesDocument, variables, options);
}
export type WishFilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishFilesQuery, WishFilesQueryVariables>;
export const WishRequestDocument = /*#__PURE__*/ gql`
    query WishRequest($key: String!) {
  wishRequest(key: $key) {
    ...WishFragment
    contacts {
      ...ContactFragment
    }
  }
}
    ${WishFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useWishRequestQuery__
 *
 * To run a query within a Vue component, call `useWishRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishRequestQuery({
 *   key: // value for 'key'
 * });
 */
export function useWishRequestQuery(variables: WishRequestQueryVariables | VueCompositionApi.Ref<WishRequestQueryVariables> | ReactiveFunction<WishRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishRequestQuery, WishRequestQueryVariables>(WishRequestDocument, variables, options);
}
export function useWishRequestLazyQuery(variables?: WishRequestQueryVariables | VueCompositionApi.Ref<WishRequestQueryVariables> | ReactiveFunction<WishRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishRequestQuery, WishRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishRequestQuery, WishRequestQueryVariables>(WishRequestDocument, variables, options);
}
export type WishRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishRequestQuery, WishRequestQueryVariables>;
export const NotificationCreatedDocument = /*#__PURE__*/ gql`
    subscription NotificationCreated {
  notificationCreated {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a Vue component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationCreatedSubscription();
 */
export function useNotificationCreatedSubscription(options: VueApolloComposable.UseSubscriptionOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>(NotificationCreatedDocument, {}, options);
}
export type NotificationCreatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>;
export const WishesDocument = /*#__PURE__*/ gql`
    query Wishes($page: Int, $first: Int!, $column: QueryWishesOrderByColumn!, $order: SortOrder!, $search: String, $status: Status, $created_at: Date, $wish_date: Date, $user_id: ID) {
  wishes(
    page: $page
    first: $first
    orderBy: [{column: $column, order: $order}]
    search: $search
    status: $status
    created_at: $created_at
    wish_date: $wish_date
    user_id: $user_id
  ) {
    data {
      ...WishFragment
      users {
        id
        full_name
      }
    }
    paginatorInfo {
      total
      perPage
      currentPage
    }
  }
}
    ${WishFragmentFragmentDoc}`;

/**
 * __useWishesQuery__
 *
 * To run a query within a Vue component, call `useWishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishesQuery({
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   column: // value for 'column'
 *   order: // value for 'order'
 *   search: // value for 'search'
 *   status: // value for 'status'
 *   created_at: // value for 'created_at'
 *   wish_date: // value for 'wish_date'
 *   user_id: // value for 'user_id'
 * });
 */
export function useWishesQuery(variables: WishesQueryVariables | VueCompositionApi.Ref<WishesQueryVariables> | ReactiveFunction<WishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishesQuery, WishesQueryVariables>(WishesDocument, variables, options);
}
export function useWishesLazyQuery(variables?: WishesQueryVariables | VueCompositionApi.Ref<WishesQueryVariables> | ReactiveFunction<WishesQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishesQuery, WishesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishesQuery, WishesQueryVariables>(WishesDocument, variables, options);
}
export type WishesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishesQuery, WishesQueryVariables>;
export const WishDocument = /*#__PURE__*/ gql`
    query Wish($id: ID!, $trashed: Trashed = WITH) {
  wish(id: $id, trashed: $trashed) {
    ...WishDetailFragment
  }
}
    ${WishDetailFragmentFragmentDoc}`;

/**
 * __useWishQuery__
 *
 * To run a query within a Vue component, call `useWishQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWishQuery({
 *   id: // value for 'id'
 *   trashed: // value for 'trashed'
 * });
 */
export function useWishQuery(variables: WishQueryVariables | VueCompositionApi.Ref<WishQueryVariables> | ReactiveFunction<WishQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WishQuery, WishQueryVariables>(WishDocument, variables, options);
}
export function useWishLazyQuery(variables?: WishQueryVariables | VueCompositionApi.Ref<WishQueryVariables> | ReactiveFunction<WishQueryVariables>, options: VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WishQuery, WishQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WishQuery, WishQueryVariables>(WishDocument, variables, options);
}
export type WishQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WishQuery, WishQueryVariables>;
export const NotificationDeletedDocument = /*#__PURE__*/ gql`
    subscription NotificationDeleted {
  notificationDeleted {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationDeletedSubscription__
 *
 * To run a query within a Vue component, call `useNotificationDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationDeletedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationDeletedSubscription();
 */
export function useNotificationDeletedSubscription(options: VueApolloComposable.UseSubscriptionOptions<NotificationDeletedSubscription, NotificationDeletedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<NotificationDeletedSubscription, NotificationDeletedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<NotificationDeletedSubscription, NotificationDeletedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<NotificationDeletedSubscription, NotificationDeletedSubscriptionVariables>(NotificationDeletedDocument, {}, options);
}
export type NotificationDeletedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<NotificationDeletedSubscription, NotificationDeletedSubscriptionVariables>;
export const NotificationUpdatedDocument = /*#__PURE__*/ gql`
    subscription NotificationUpdated {
  notificationUpdated {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useNotificationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationUpdatedSubscription();
 */
export function useNotificationUpdatedSubscription(options: VueApolloComposable.UseSubscriptionOptions<NotificationUpdatedSubscription, NotificationUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<NotificationUpdatedSubscription, NotificationUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<NotificationUpdatedSubscription, NotificationUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<NotificationUpdatedSubscription, NotificationUpdatedSubscriptionVariables>(NotificationUpdatedDocument, {}, options);
}
export type NotificationUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<NotificationUpdatedSubscription, NotificationUpdatedSubscriptionVariables>;
export const PlanableWishesUpdatedDocument = /*#__PURE__*/ gql`
    subscription PlanableWishesUpdated {
  wishesUpdated {
    ...PlanableWishesFragment
  }
}
    ${PlanableWishesFragmentFragmentDoc}`;

/**
 * __usePlanableWishesUpdatedSubscription__
 *
 * To run a query within a Vue component, call `usePlanableWishesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlanableWishesUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = usePlanableWishesUpdatedSubscription();
 */
export function usePlanableWishesUpdatedSubscription(options: VueApolloComposable.UseSubscriptionOptions<PlanableWishesUpdatedSubscription, PlanableWishesUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<PlanableWishesUpdatedSubscription, PlanableWishesUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<PlanableWishesUpdatedSubscription, PlanableWishesUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<PlanableWishesUpdatedSubscription, PlanableWishesUpdatedSubscriptionVariables>(PlanableWishesUpdatedDocument, {}, options);
}
export type PlanableWishesUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<PlanableWishesUpdatedSubscription, PlanableWishesUpdatedSubscriptionVariables>;
export const ReservationUpdatedDocument = /*#__PURE__*/ gql`
    subscription ReservationUpdated($id: ID!) {
  reservationUpdated(id: $id) {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useReservationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReservationUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useReservationUpdatedSubscription({
 *   id: // value for 'id'
 * });
 */
export function useReservationUpdatedSubscription(variables: ReservationUpdatedSubscriptionVariables | VueCompositionApi.Ref<ReservationUpdatedSubscriptionVariables> | ReactiveFunction<ReservationUpdatedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<ReservationUpdatedSubscription, ReservationUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<ReservationUpdatedSubscription, ReservationUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<ReservationUpdatedSubscription, ReservationUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<ReservationUpdatedSubscription, ReservationUpdatedSubscriptionVariables>(ReservationUpdatedDocument, variables, options);
}
export type ReservationUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<ReservationUpdatedSubscription, ReservationUpdatedSubscriptionVariables>;
export const ReservationsUpdatedDocument = /*#__PURE__*/ gql`
    subscription ReservationsUpdated {
  reservationsUpdated {
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationsUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useReservationsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReservationsUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useReservationsUpdatedSubscription();
 */
export function useReservationsUpdatedSubscription(options: VueApolloComposable.UseSubscriptionOptions<ReservationsUpdatedSubscription, ReservationsUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<ReservationsUpdatedSubscription, ReservationsUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<ReservationsUpdatedSubscription, ReservationsUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<ReservationsUpdatedSubscription, ReservationsUpdatedSubscriptionVariables>(ReservationsUpdatedDocument, {}, options);
}
export type ReservationsUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<ReservationsUpdatedSubscription, ReservationsUpdatedSubscriptionVariables>;
export const PlannableWishUpdatedDocument = /*#__PURE__*/ gql`
    subscription PlannableWishUpdated($id: ID!) {
  wishUpdated(id: $id) {
    ...PlannableWishFragment
  }
}
    ${PlannableWishFragmentFragmentDoc}`;

/**
 * __usePlannableWishUpdatedSubscription__
 *
 * To run a query within a Vue component, call `usePlannableWishUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlannableWishUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = usePlannableWishUpdatedSubscription({
 *   id: // value for 'id'
 * });
 */
export function usePlannableWishUpdatedSubscription(variables: PlannableWishUpdatedSubscriptionVariables | VueCompositionApi.Ref<PlannableWishUpdatedSubscriptionVariables> | ReactiveFunction<PlannableWishUpdatedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<PlannableWishUpdatedSubscription, PlannableWishUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<PlannableWishUpdatedSubscription, PlannableWishUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<PlannableWishUpdatedSubscription, PlannableWishUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<PlannableWishUpdatedSubscription, PlannableWishUpdatedSubscriptionVariables>(PlannableWishUpdatedDocument, variables, options);
}
export type PlannableWishUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<PlannableWishUpdatedSubscription, PlannableWishUpdatedSubscriptionVariables>;
export const WishUpdatedDocument = /*#__PURE__*/ gql`
    subscription WishUpdated($id: ID!) {
  wishUpdated(id: $id) {
    id
  }
}
    `;

/**
 * __useWishUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useWishUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWishUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useWishUpdatedSubscription({
 *   id: // value for 'id'
 * });
 */
export function useWishUpdatedSubscription(variables: WishUpdatedSubscriptionVariables | VueCompositionApi.Ref<WishUpdatedSubscriptionVariables> | ReactiveFunction<WishUpdatedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<WishUpdatedSubscription, WishUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<WishUpdatedSubscription, WishUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<WishUpdatedSubscription, WishUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<WishUpdatedSubscription, WishUpdatedSubscriptionVariables>(WishUpdatedDocument, variables, options);
}
export type WishUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<WishUpdatedSubscription, WishUpdatedSubscriptionVariables>;
export const VehiclesUpdatedDocument = /*#__PURE__*/ gql`
    subscription VehiclesUpdated {
  vehiclesUpdated {
    ...VehicleFragment
  }
}
    ${VehicleFragmentFragmentDoc}`;

/**
 * __useVehiclesUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useVehiclesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useVehiclesUpdatedSubscription();
 */
export function useVehiclesUpdatedSubscription(options: VueApolloComposable.UseSubscriptionOptions<VehiclesUpdatedSubscription, VehiclesUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<VehiclesUpdatedSubscription, VehiclesUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<VehiclesUpdatedSubscription, VehiclesUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<VehiclesUpdatedSubscription, VehiclesUpdatedSubscriptionVariables>(VehiclesUpdatedDocument, {}, options);
}
export type VehiclesUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<VehiclesUpdatedSubscription, VehiclesUpdatedSubscriptionVariables>;
export const CreateAvailabilityEntryDocument = /*#__PURE__*/ gql`
    mutation CreateAvailabilityEntry($user_id: ID!, $date: Date!) {
  createAvailabilityEntry(user_id: $user_id, date: $date) {
    id
    date
  }
}
    `;

/**
 * __useCreateAvailabilityEntryMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAvailabilityEntryMutation({
 *   variables: {
 *     user_id: // value for 'user_id'
 *     date: // value for 'date'
 *   },
 * });
 */
export function useCreateAvailabilityEntryMutation(options: VueApolloComposable.UseMutationOptions<CreateAvailabilityEntryMutation, CreateAvailabilityEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAvailabilityEntryMutation, CreateAvailabilityEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAvailabilityEntryMutation, CreateAvailabilityEntryMutationVariables>(CreateAvailabilityEntryDocument, options);
}
export type CreateAvailabilityEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAvailabilityEntryMutation, CreateAvailabilityEntryMutationVariables>;
export const DeleteAvailabilityEntryDocument = /*#__PURE__*/ gql`
    mutation DeleteAvailabilityEntry($id: ID!) {
  deleteAvailabilityEntry(id: $id) {
    id
    date
  }
}
    `;

/**
 * __useDeleteAvailabilityEntryMutation__
 *
 * To run a mutation, you first call `useDeleteAvailabilityEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailabilityEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAvailabilityEntryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAvailabilityEntryMutation(options: VueApolloComposable.UseMutationOptions<DeleteAvailabilityEntryMutation, DeleteAvailabilityEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAvailabilityEntryMutation, DeleteAvailabilityEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAvailabilityEntryMutation, DeleteAvailabilityEntryMutationVariables>(DeleteAvailabilityEntryDocument, options);
}
export type DeleteAvailabilityEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAvailabilityEntryMutation, DeleteAvailabilityEntryMutationVariables>;
export const CreateChecklistBlockWishDocument = /*#__PURE__*/ gql`
    mutation CreateChecklistBlockWish($checklist_block_id: ID!, $wish_id: ID!, $custom_block_name: String!) {
  createChecklistBlockWish(
    checklist_block_id: $checklist_block_id
    wish_id: $wish_id
    custom_block_name: $custom_block_name
  ) {
    ...ChecklistBlockWishFragment
  }
}
    ${ChecklistBlockWishFragmentFragmentDoc}`;

/**
 * __useCreateChecklistBlockWishMutation__
 *
 * To run a mutation, you first call `useCreateChecklistBlockWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistBlockWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateChecklistBlockWishMutation({
 *   variables: {
 *     checklist_block_id: // value for 'checklist_block_id'
 *     wish_id: // value for 'wish_id'
 *     custom_block_name: // value for 'custom_block_name'
 *   },
 * });
 */
export function useCreateChecklistBlockWishMutation(options: VueApolloComposable.UseMutationOptions<CreateChecklistBlockWishMutation, CreateChecklistBlockWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateChecklistBlockWishMutation, CreateChecklistBlockWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateChecklistBlockWishMutation, CreateChecklistBlockWishMutationVariables>(CreateChecklistBlockWishDocument, options);
}
export type CreateChecklistBlockWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateChecklistBlockWishMutation, CreateChecklistBlockWishMutationVariables>;
export const SaveChecklistAnswersDocument = /*#__PURE__*/ gql`
    mutation SaveChecklistAnswers($checklist_id: ID!, $wish_id: ID!, $input: [AnswersInput!]!) {
  saveChecklistAnswers(
    checklist_id: $checklist_id
    wish_id: $wish_id
    input: $input
  ) {
    ...ChecklistFragment
  }
}
    ${ChecklistFragmentFragmentDoc}`;

/**
 * __useSaveChecklistAnswersMutation__
 *
 * To run a mutation, you first call `useSaveChecklistAnswersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveChecklistAnswersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveChecklistAnswersMutation({
 *   variables: {
 *     checklist_id: // value for 'checklist_id'
 *     wish_id: // value for 'wish_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveChecklistAnswersMutation(options: VueApolloComposable.UseMutationOptions<SaveChecklistAnswersMutation, SaveChecklistAnswersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveChecklistAnswersMutation, SaveChecklistAnswersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveChecklistAnswersMutation, SaveChecklistAnswersMutationVariables>(SaveChecklistAnswersDocument, options);
}
export type SaveChecklistAnswersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveChecklistAnswersMutation, SaveChecklistAnswersMutationVariables>;
export const DeleteChecklistBlockWishDocument = /*#__PURE__*/ gql`
    mutation DeleteChecklistBlockWish($id: ID!) {
  deleteChecklistBlockWish(id: $id) {
    success
  }
}
    `;

/**
 * __useDeleteChecklistBlockWishMutation__
 *
 * To run a mutation, you first call `useDeleteChecklistBlockWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChecklistBlockWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteChecklistBlockWishMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChecklistBlockWishMutation(options: VueApolloComposable.UseMutationOptions<DeleteChecklistBlockWishMutation, DeleteChecklistBlockWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteChecklistBlockWishMutation, DeleteChecklistBlockWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteChecklistBlockWishMutation, DeleteChecklistBlockWishMutationVariables>(DeleteChecklistBlockWishDocument, options);
}
export type DeleteChecklistBlockWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteChecklistBlockWishMutation, DeleteChecklistBlockWishMutationVariables>;
export const ExactUpdateConfigDocument = /*#__PURE__*/ gql`
    mutation ExactUpdateConfig($input: ExactConfigInput!) {
  exactUpdateConfig(input: $input) {
    ...ExactConfigFragment
  }
}
    ${ExactConfigFragmentFragmentDoc}`;

/**
 * __useExactUpdateConfigMutation__
 *
 * To run a mutation, you first call `useExactUpdateConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExactUpdateConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExactUpdateConfigMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useExactUpdateConfigMutation(options: VueApolloComposable.UseMutationOptions<ExactUpdateConfigMutation, ExactUpdateConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExactUpdateConfigMutation, ExactUpdateConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExactUpdateConfigMutation, ExactUpdateConfigMutationVariables>(ExactUpdateConfigDocument, options);
}
export type ExactUpdateConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExactUpdateConfigMutation, ExactUpdateConfigMutationVariables>;
export const ApproveExpensesDocument = /*#__PURE__*/ gql`
    mutation ApproveExpenses($ids: [ID!]!) {
  approveExpenses(ids: $ids) {
    id
  }
}
    `;

/**
 * __useApproveExpensesMutation__
 *
 * To run a mutation, you first call `useApproveExpensesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveExpensesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveExpensesMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useApproveExpensesMutation(options: VueApolloComposable.UseMutationOptions<ApproveExpensesMutation, ApproveExpensesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveExpensesMutation, ApproveExpensesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveExpensesMutation, ApproveExpensesMutationVariables>(ApproveExpensesDocument, options);
}
export type ApproveExpensesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveExpensesMutation, ApproveExpensesMutationVariables>;
export const CreateExpenseDocument = /*#__PURE__*/ gql`
    mutation CreateExpense($input: ExpenseCreateInput!) {
  createExpense(input: $input) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragmentFragmentDoc}`;

/**
 * __useCreateExpenseMutation__
 *
 * To run a mutation, you first call `useCreateExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateExpenseMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpenseMutation(options: VueApolloComposable.UseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, options);
}
export type CreateExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const RelinkExpenseDocument = /*#__PURE__*/ gql`
    mutation RelinkExpense($id: ID!, $wish_id: ID) {
  relinkExpense(id: $id, wish_id: $wish_id) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragmentFragmentDoc}`;

/**
 * __useRelinkExpenseMutation__
 *
 * To run a mutation, you first call `useRelinkExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRelinkExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRelinkExpenseMutation({
 *   variables: {
 *     id: // value for 'id'
 *     wish_id: // value for 'wish_id'
 *   },
 * });
 */
export function useRelinkExpenseMutation(options: VueApolloComposable.UseMutationOptions<RelinkExpenseMutation, RelinkExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RelinkExpenseMutation, RelinkExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RelinkExpenseMutation, RelinkExpenseMutationVariables>(RelinkExpenseDocument, options);
}
export type RelinkExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RelinkExpenseMutation, RelinkExpenseMutationVariables>;
export const UpdateExpenseDocument = /*#__PURE__*/ gql`
    mutation UpdateExpense($id: ID!, $input: ExpenseUpdateInput!) {
  updateExpense(id: $id, input: $input) {
    ...ExpenseFragment
  }
}
    ${ExpenseFragmentFragmentDoc}`;

/**
 * __useUpdateExpenseMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateExpenseMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpenseMutation(options: VueApolloComposable.UseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateExpenseMutation, UpdateExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument, options);
}
export type UpdateExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const SaveWishPlanningConfirmationExtraInformationDocument = /*#__PURE__*/ gql`
    mutation SaveWishPlanningConfirmationExtraInformation($wishId: ID!, $content: String!) {
  saveWishPlanningConfirmationExtraInformation(wishId: $wishId, content: $content)
}
    `;

/**
 * __useSaveWishPlanningConfirmationExtraInformationMutation__
 *
 * To run a mutation, you first call `useSaveWishPlanningConfirmationExtraInformationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveWishPlanningConfirmationExtraInformationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveWishPlanningConfirmationExtraInformationMutation({
 *   variables: {
 *     wishId: // value for 'wishId'
 *     content: // value for 'content'
 *   },
 * });
 */
export function useSaveWishPlanningConfirmationExtraInformationMutation(options: VueApolloComposable.UseMutationOptions<SaveWishPlanningConfirmationExtraInformationMutation, SaveWishPlanningConfirmationExtraInformationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveWishPlanningConfirmationExtraInformationMutation, SaveWishPlanningConfirmationExtraInformationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveWishPlanningConfirmationExtraInformationMutation, SaveWishPlanningConfirmationExtraInformationMutationVariables>(SaveWishPlanningConfirmationExtraInformationDocument, options);
}
export type SaveWishPlanningConfirmationExtraInformationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveWishPlanningConfirmationExtraInformationMutation, SaveWishPlanningConfirmationExtraInformationMutationVariables>;
export const DeleteExpenseDocument = /*#__PURE__*/ gql`
    mutation DeleteExpense($id: ID!) {
  deleteExpense(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteExpenseMutation__
 *
 * To run a mutation, you first call `useDeleteExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExpenseMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpenseMutation(options: VueApolloComposable.UseMutationOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteExpenseMutation, DeleteExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument, options);
}
export type DeleteExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteExpenseMutation, DeleteExpenseMutationVariables>;
export const AttachMediaToWishDocument = /*#__PURE__*/ gql`
    mutation AttachMediaToWish($wish_id: ID!, $media_id: ID!) {
  attachMediaToWish(wish_id: $wish_id, media_id: $media_id) {
    status
  }
}
    `;

/**
 * __useAttachMediaToWishMutation__
 *
 * To run a mutation, you first call `useAttachMediaToWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachMediaToWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachMediaToWishMutation({
 *   variables: {
 *     wish_id: // value for 'wish_id'
 *     media_id: // value for 'media_id'
 *   },
 * });
 */
export function useAttachMediaToWishMutation(options: VueApolloComposable.UseMutationOptions<AttachMediaToWishMutation, AttachMediaToWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttachMediaToWishMutation, AttachMediaToWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AttachMediaToWishMutation, AttachMediaToWishMutationVariables>(AttachMediaToWishDocument, options);
}
export type AttachMediaToWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttachMediaToWishMutation, AttachMediaToWishMutationVariables>;
export const DeleteMediaDocument = /*#__PURE__*/ gql`
    mutation DeleteMedia($id: ID!) {
  deleteMedia(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMediaMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(options: VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, options);
}
export type DeleteMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const DetachMediaFromWishDocument = /*#__PURE__*/ gql`
    mutation DetachMediaFromWish($wish_id: ID!, $media_id: ID!) {
  detachMediaFromWish(wish_id: $wish_id, media_id: $media_id) {
    status
  }
}
    `;

/**
 * __useDetachMediaFromWishMutation__
 *
 * To run a mutation, you first call `useDetachMediaFromWishMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDetachMediaFromWishMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDetachMediaFromWishMutation({
 *   variables: {
 *     wish_id: // value for 'wish_id'
 *     media_id: // value for 'media_id'
 *   },
 * });
 */
export function useDetachMediaFromWishMutation(options: VueApolloComposable.UseMutationOptions<DetachMediaFromWishMutation, DetachMediaFromWishMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DetachMediaFromWishMutation, DetachMediaFromWishMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DetachMediaFromWishMutation, DetachMediaFromWishMutationVariables>(DetachMediaFromWishDocument, options);
}
export type DetachMediaFromWishMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DetachMediaFromWishMutation, DetachMediaFromWishMutationVariables>;
export const ChecklistDocument = /*#__PURE__*/ gql`
    query Checklist($id: ID!, $wish_id: ID!) {
  checklist(id: $id, wish_id: $wish_id) {
    ...ChecklistFragment
  }
}
    ${ChecklistFragmentFragmentDoc}`;

/**
 * __useChecklistQuery__
 *
 * To run a query within a Vue component, call `useChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChecklistQuery({
 *   id: // value for 'id'
 *   wish_id: // value for 'wish_id'
 * });
 */
export function useChecklistQuery(variables: ChecklistQueryVariables | VueCompositionApi.Ref<ChecklistQueryVariables> | ReactiveFunction<ChecklistQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChecklistQuery, ChecklistQueryVariables>(ChecklistDocument, variables, options);
}
export function useChecklistLazyQuery(variables?: ChecklistQueryVariables | VueCompositionApi.Ref<ChecklistQueryVariables> | ReactiveFunction<ChecklistQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistQuery, ChecklistQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChecklistQuery, ChecklistQueryVariables>(ChecklistDocument, variables, options);
}
export type ChecklistQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChecklistQuery, ChecklistQueryVariables>;
export const ChecklistsDocument = /*#__PURE__*/ gql`
    query Checklists($wish_id: ID!) {
  checklists(wish_id: $wish_id) {
    ...SimpleChecklistFragment
  }
}
    ${SimpleChecklistFragmentFragmentDoc}`;

/**
 * __useChecklistsQuery__
 *
 * To run a query within a Vue component, call `useChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChecklistsQuery({
 *   wish_id: // value for 'wish_id'
 * });
 */
export function useChecklistsQuery(variables: ChecklistsQueryVariables | VueCompositionApi.Ref<ChecklistsQueryVariables> | ReactiveFunction<ChecklistsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChecklistsQuery, ChecklistsQueryVariables>(ChecklistsDocument, variables, options);
}
export function useChecklistsLazyQuery(variables?: ChecklistsQueryVariables | VueCompositionApi.Ref<ChecklistsQueryVariables> | ReactiveFunction<ChecklistsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChecklistsQuery, ChecklistsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChecklistsQuery, ChecklistsQueryVariables>(ChecklistsDocument, variables, options);
}
export type ChecklistsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChecklistsQuery, ChecklistsQueryVariables>;
export const UploadMediaDocument = /*#__PURE__*/ gql`
    mutation UploadMedia($id: ID, $file: Upload, $description: String) {
  uploadMedia(id: $id, file: $file, description: $description) {
    id
  }
}
    `;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadMediaMutation({
 *   variables: {
 *     id: // value for 'id'
 *     file: // value for 'file'
 *     description: // value for 'description'
 *   },
 * });
 */
export function useUploadMediaMutation(options: VueApolloComposable.UseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
}
export type UploadMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadMediaMutation, UploadMediaMutationVariables>;
export const ExactAuthLinkDocument = /*#__PURE__*/ gql`
    query ExactAuthLink($redirectUrl: String) {
  exactAuthLink(redirectUrl: $redirectUrl)
}
    `;

/**
 * __useExactAuthLinkQuery__
 *
 * To run a query within a Vue component, call `useExactAuthLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useExactAuthLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExactAuthLinkQuery({
 *   redirectUrl: // value for 'redirectUrl'
 * });
 */
export function useExactAuthLinkQuery(variables: ExactAuthLinkQueryVariables | VueCompositionApi.Ref<ExactAuthLinkQueryVariables> | ReactiveFunction<ExactAuthLinkQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>(ExactAuthLinkDocument, variables, options);
}
export function useExactAuthLinkLazyQuery(variables: ExactAuthLinkQueryVariables | VueCompositionApi.Ref<ExactAuthLinkQueryVariables> | ReactiveFunction<ExactAuthLinkQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>(ExactAuthLinkDocument, variables, options);
}
export type ExactAuthLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExactAuthLinkQuery, ExactAuthLinkQueryVariables>;
export const ExactAuthenticatedDocument = /*#__PURE__*/ gql`
    query ExactAuthenticated {
  exactAuthenticated
}
    `;

/**
 * __useExactAuthenticatedQuery__
 *
 * To run a query within a Vue component, call `useExactAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useExactAuthenticatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExactAuthenticatedQuery();
 */
export function useExactAuthenticatedQuery(options: VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>(ExactAuthenticatedDocument, {}, options);
}
export function useExactAuthenticatedLazyQuery(options: VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>(ExactAuthenticatedDocument, {}, options);
}
export type ExactAuthenticatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExactAuthenticatedQuery, ExactAuthenticatedQueryVariables>;
export const ExactConfigDocument = /*#__PURE__*/ gql`
    query ExactConfig {
  exactConfig {
    ...ExactConfigFragment
  }
}
    ${ExactConfigFragmentFragmentDoc}`;

/**
 * __useExactConfigQuery__
 *
 * To run a query within a Vue component, call `useExactConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useExactConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExactConfigQuery();
 */
export function useExactConfigQuery(options: VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExactConfigQuery, ExactConfigQueryVariables>(ExactConfigDocument, {}, options);
}
export function useExactConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactConfigQuery, ExactConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExactConfigQuery, ExactConfigQueryVariables>(ExactConfigDocument, {}, options);
}
export type ExactConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExactConfigQuery, ExactConfigQueryVariables>;
export const MapsPlaceAutocompleteDocument = /*#__PURE__*/ gql`
    query MapsPlaceAutocomplete($search: String) {
  mapsPlaceAutocomplete(search: $search) {
    name
    address
    description
    place_id
  }
}
    `;

/**
 * __useMapsPlaceAutocompleteQuery__
 *
 * To run a query within a Vue component, call `useMapsPlaceAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapsPlaceAutocompleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMapsPlaceAutocompleteQuery({
 *   search: // value for 'search'
 * });
 */
export function useMapsPlaceAutocompleteQuery(variables: MapsPlaceAutocompleteQueryVariables | VueCompositionApi.Ref<MapsPlaceAutocompleteQueryVariables> | ReactiveFunction<MapsPlaceAutocompleteQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>(MapsPlaceAutocompleteDocument, variables, options);
}
export function useMapsPlaceAutocompleteLazyQuery(variables: MapsPlaceAutocompleteQueryVariables | VueCompositionApi.Ref<MapsPlaceAutocompleteQueryVariables> | ReactiveFunction<MapsPlaceAutocompleteQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>(MapsPlaceAutocompleteDocument, variables, options);
}
export type MapsPlaceAutocompleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MapsPlaceAutocompleteQuery, MapsPlaceAutocompleteQueryVariables>;
export const ExactDivisionsDocument = /*#__PURE__*/ gql`
    query ExactDivisions {
  exactDivisions {
    id
    code
    description
    default
    journals {
      id
      uuid
      code
      description
    }
    general_ledger_accounts {
      id
      uuid
      code
      description
    }
  }
}
    `;

/**
 * __useExactDivisionsQuery__
 *
 * To run a query within a Vue component, call `useExactDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExactDivisionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExactDivisionsQuery();
 */
export function useExactDivisionsQuery(options: VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExactDivisionsQuery, ExactDivisionsQueryVariables>(ExactDivisionsDocument, {}, options);
}
export function useExactDivisionsLazyQuery(options: VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExactDivisionsQuery, ExactDivisionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExactDivisionsQuery, ExactDivisionsQueryVariables>(ExactDivisionsDocument, {}, options);
}
export type ExactDivisionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExactDivisionsQuery, ExactDivisionsQueryVariables>;
export const MapsPlaceDetailsDocument = /*#__PURE__*/ gql`
    query MapsPlaceDetails($placeId: String!) {
  mapsPlaceDetails(place_id: $placeId) {
    id
    name
    street
    number
    number_addition
    postal_code
    city
    country
    place_id
    created_at
    updated_at
  }
}
    `;

/**
 * __useMapsPlaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useMapsPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapsPlaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMapsPlaceDetailsQuery({
 *   placeId: // value for 'placeId'
 * });
 */
export function useMapsPlaceDetailsQuery(variables: MapsPlaceDetailsQueryVariables | VueCompositionApi.Ref<MapsPlaceDetailsQueryVariables> | ReactiveFunction<MapsPlaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>(MapsPlaceDetailsDocument, variables, options);
}
export function useMapsPlaceDetailsLazyQuery(variables?: MapsPlaceDetailsQueryVariables | VueCompositionApi.Ref<MapsPlaceDetailsQueryVariables> | ReactiveFunction<MapsPlaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>(MapsPlaceDetailsDocument, variables, options);
}
export type MapsPlaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MapsPlaceDetailsQuery, MapsPlaceDetailsQueryVariables>;
export const DeletePhotosDocument = /*#__PURE__*/ gql`
    mutation DeletePhotos($wish_id: ID!, $photo_uuids: [ID!]!) {
  deletePhotos(wish_id: $wish_id, photo_uuids: $photo_uuids)
}
    `;

/**
 * __useDeletePhotosMutation__
 *
 * To run a mutation, you first call `useDeletePhotosMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotosMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePhotosMutation({
 *   variables: {
 *     wish_id: // value for 'wish_id'
 *     photo_uuids: // value for 'photo_uuids'
 *   },
 * });
 */
export function useDeletePhotosMutation(options: VueApolloComposable.UseMutationOptions<DeletePhotosMutation, DeletePhotosMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePhotosMutation, DeletePhotosMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePhotosMutation, DeletePhotosMutationVariables>(DeletePhotosDocument, options);
}
export type DeletePhotosMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePhotosMutation, DeletePhotosMutationVariables>;
export const UploadPhotosDocument = /*#__PURE__*/ gql`
    mutation UploadPhotos($files: [Upload!]!, $wish_id: ID!) {
  uploadPhotos(files: $files, wish_id: $wish_id) {
    ...PhotoFragment
  }
}
    ${PhotoFragmentFragmentDoc}`;

/**
 * __useUploadPhotosMutation__
 *
 * To run a mutation, you first call `useUploadPhotosMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotosMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadPhotosMutation({
 *   variables: {
 *     files: // value for 'files'
 *     wish_id: // value for 'wish_id'
 *   },
 * });
 */
export function useUploadPhotosMutation(options: VueApolloComposable.UseMutationOptions<UploadPhotosMutation, UploadPhotosMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UploadPhotosMutation, UploadPhotosMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UploadPhotosMutation, UploadPhotosMutationVariables>(UploadPhotosDocument, options);
}
export type UploadPhotosMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UploadPhotosMutation, UploadPhotosMutationVariables>;
export const ExportPhotosDocument = /*#__PURE__*/ gql`
    query ExportPhotos($wish_id: ID!, $photo_uuids: [ID!]) {
  exportPhotos(wish_id: $wish_id, photo_uuids: $photo_uuids)
}
    `;

/**
 * __useExportPhotosQuery__
 *
 * To run a query within a Vue component, call `useExportPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPhotosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportPhotosQuery({
 *   wish_id: // value for 'wish_id'
 *   photo_uuids: // value for 'photo_uuids'
 * });
 */
export function useExportPhotosQuery(variables: ExportPhotosQueryVariables | VueCompositionApi.Ref<ExportPhotosQueryVariables> | ReactiveFunction<ExportPhotosQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ExportPhotosQuery, ExportPhotosQueryVariables>(ExportPhotosDocument, variables, options);
}
export function useExportPhotosLazyQuery(variables?: ExportPhotosQueryVariables | VueCompositionApi.Ref<ExportPhotosQueryVariables> | ReactiveFunction<ExportPhotosQueryVariables>, options: VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExportPhotosQuery, ExportPhotosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ExportPhotosQuery, ExportPhotosQueryVariables>(ExportPhotosDocument, variables, options);
}
export type ExportPhotosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ExportPhotosQuery, ExportPhotosQueryVariables>;